<template>
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="ichiran()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-1" style="margin-top:0;background-color:white">

    <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
     <!-- 各文言はuserdata.jsより -->
     <div v-if="enqete_ok == 0" style="text-align:center">
     {{GlobalData.$enqete_mikaitou}}<br>
      <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>{{GlobalData.$enqete_link}}</u></span><br>
      <hr style="width:100%">
    </div>

    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" v-on:click="ichiran" style="cursor:pointer">体験プログラム一覧</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
        
    <div id="manual_area">

<span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>
</div>

<br clear="all">
         <!-- ボタン（PCのみ） -->
         <div class="pc_only" style="text-align:center;padding:6px">
            
         <!-- 体験OKフラグが立ってないと申込めない -->
            <template v-if="taiken_ok == 1">
                <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right:10px" v-on:click="moushikomi_set()" v-if="shakyo_moushikomi_flg == true && seisaku_moushikomi_flg == true && joken_moushikomi_flg == true">申込み</button>
            </template>
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-on:click="ichiran()">戻る</button>
        </div>

        
        <!--タイトル画像が存在する場合は表示-->
        <!--
        <img v-if="taiken_list.title_image" v-bind:src="taiken_list.title_image" style="max-width:100%;margin-bottom:10px">
-->
        <div class="p-2">
        <!-- 施設・体験の場合のみタブ切替 -->
        <!-- タブ切り替え タブ3つ -->
        <div id="tab" v-if="taiken_list.shubetsu==1">
            <ul class="tabMenu">
                <li @click="TabSelect('tab_detail')" id="tab_detail" v-bind:class="detail_color">詳細内容</li>
                <li @click="TabSelect('tab_list')" id="tab_list" v-bind:class="list_color" style="width:34%">日程一覧</li>
                <li @click="TabSelect('tab_calendar')" id="tab_calendar" v-bind:class="calendar_color">カレンダー</li>
            </ul>
        </div>

        <div class="tabContents" v-bind:class="contents_color">
            
            <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
            <div v-if="enqete_ok == 0" style="text-align:center">
                <!--
            体験プログラムのお申込みにはアンケートにご回答いただく必要があります。<br>
            <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>アンケートフォームへ移動する</u></span><br>
            <hr style="width:100%">-->
            </div>

            <div v-else-if="taiken_ok == 0">
                <p style="color:red"><b>体験プログラムの申込みには、
                <template v-if="jizen_ok == 0">
                    <!--事前説明会を申し込んでないなら誘導する-->
                    <span v-on:click="jizen_list"><u style="cursor:pointer">事前説明会への参加</u></span>
                </template>
                <template v-else>
                    <!--事前説明会を申込済みなら誘導しない-->
                    事前説明会への参加
                </template>
                が必要です。</b></p>
            </div>
            <div v-else-if="taiken_list.shubetsu == 2 || (taiken_list.shubetsu == 1 && TabActive != 'tab_detail')">

                
                <div v-if="shakyo_moushikomi_flg == false">
                    <p style="color:red"><b>{{moushikomi_message}}</b></p>
                    
                </div>
                <div v-else-if="joken_moushikomi_flg == false">
                    <p style="color:red"><b v-html="joken_fuka_message"></b></p>
                </div>
                <div v-else-if ="seisaku_moushikomi_flg == false">
                    <p style="color:red"><b>このプログラムは満員です。</b></p>
                </div>
                <div v-else>
                    <div v-if="mode=='nologin'" style="text-align:left;font-size:19px;">
                        <p style="color:red"><b>体験プログラムの申込みには、<span v-on:click="login"><u style="cursor:pointer">ログイン</u></span>が必要です。</b></p>
                    </div>
                    <div v-if="mode=='noinfo'" style="text-align:left;font-size:19px;">
                        <p style="color:red"><b>体験プログラムの申込みには、ユーザー情報（プロフィール）の登録が必要です。<br><u v-on:click="userinfo()" style="cursor: pointer;">マイページ</u>から登録してください。</b></p>
                    </div>
                </div>
            </div>
            <br clear="all" v-if="mode=='nologin' || mode=='noinfo'" >
            <br clear="all" v-else-if="TabActive == 'tab_list'"   class="pc_only" >
            <br clear="all" v-else-if="TabActive == 'tab_calendar'"  class="pc_only" >
            
            <div v-if="TabActive === 'tab_detail'">
                
                <div v-if="shakyo_moushikomi_flg == false && taiken_list.shubetsu == 1">
                    <p style="color:red"><b>申込開始日まで今しばらくお待ちください。</b></p>
                    
                </div>
                <div v-else-if="joken_moushikomi_flg == false && taiken_list.shubetsu == 1">
                    <p style="color:red"><b ></b></p>
                </div>
                <div v-else-if ="seisaku_moushikomi_flg == false && taiken_list.shubetsu == 1">
                    <p style="color:red"><b>このプログラムは満員です。</b></p>
                </div>
                <span style="text-align: left;float: left;padding:5px">
                    <span  :style="{ color: shosai_color[0] ,fontWeight:shosai_bold[0] == '0' ? 400 : 700 }">{{ taiken_list.bunrui1 }}</span>
                    <span v-if="shosai_disp[1] == 1 && taiken_list.bunrui2 != 'なし'"  :style="{ color: shosai_color[1] ,fontWeight:shosai_bold[1] == '0' ? 400 : 700 }"><br>{{ taiken_list.bunrui2 }}</span>
                </span>

                <!-- 施設・地域活動 -->
                <table class="vy-form-table"  v-if="taiken_list.shubetsu == 1">
                    <!-- No. プログラム名称 -->
                    <tr>
                        <td colspan="2"><div class="vy-dotted pc_only"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;" :style="{ color: shosai_color[2] ,fontWeight:shosai_bold[2] == '0' ? 400 : 700 }">
                            <b>{{ taiken_list.taiken_no_text }}：{{ taiken_list.name }}</b>
                        </td>
                    </tr>
                    
                    <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && taiken_list.s_comment != null && taiken_list.s_comment != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th>
                                <label for="">受入先からのコメント</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[6] ,fontWeight:shosai_bold[6] == '0' ? 400 : 700 }">
                                {{taiken_list.s_comment}}
                            </td>
                        </tr>
                    </template>
                    <template v-if="taiken_list.all_teiin_flg == 1">
                      <!--プログラム全体の定員-->
                      <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label >
                                    プログラム全体の定員
                                </label>
                            </th>
                            <td style="text-align: left;font-size:16px" :style="{ color: shosai_color[25] ,fontWeight:shosai_bold[25] == '0' ? 400 : 700 }">
                               {{ok_user_count}} 人 / {{taiken_list.seisaku_teiin}} 人
                            </td>
                        </tr>
                    </template>

                </table>
                <div id="tab" style="display: flex;justify-content: space-between;" v-if="taiken_list.shubetsu == 1 && sub_list.length != 0">
                  <ul id="katsudou_tabMenu" class="edit_tabMenu">
                    <template v-if="KatsudouActive=='main'">
                        <li class="tabblue">活動1</li>
                      </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
                      </template>
                      <template v-for="(result,s) in sub_list" v-bind:key="s">
                        <template v-if="KatsudouActive=='sub'+s">
                          <li class="tabblue" >活動{{s+2}}</li>
                        </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                      </template>
                    </template>
                  </ul>
                </div>
                <table class="vy-form-table edit_komoku_area" v-if="taiken_list.shubetsu == 1"  style="margin-bottom:0px;margin-top:0px">
                    
                    <tbody v-show="KatsudouActive=='main'">
                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1">
                        <tr>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[3] ,fontWeight:shosai_bold[3] == '0' ? 400 : 700 }">
                                {{ taiken_list.naiyou }}
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 参加の義務 -->
                    <template v-if="sub_list.length != 0">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                        <th>
                            <label for="">参加の義務</label>
                        </th>
                        <td style="text-align: left;" :style="{ color: shosai_color[27] ,fontWeight:shosai_bold[27] == '0' ? 400 : 700 }">
                          {{ hissu_list[taiken_list.hissu_flg ]}}
                          </td>
                      </tr>
                    </template>

                     <!-- 開催地名 -->
                     <template v-if="shosai_disp[18] == 1 && taiken_list.k_name != null && taiken_list.k_name != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    開催地名
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        開催地名
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[18] ,fontWeight:shosai_bold[18] == '0' ? 400 : 700 }">
                            {{ taiken_list.k_name }}
                            </td>
                        </tr>
                    </template>
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        施設住所
                                    </label>
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、開催場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" v-on:click="jusho(taiken_list.k_jusyo)">
                                <u :style="{ color: shosai_color[4] ,fontWeight:shosai_bold[4] == '0' ? 400 : 700 }">{{ taiken_list.k_jusyo }}</u>
                            </td>
                        </tr>
                    </template>
                     <!-- アクセス方法 -->
                     <template v-if="shosai_disp[20] == 1 && taiken_list.k_access != null && taiken_list.k_access != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    アクセス方法
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        アクセス方法
                                    </label>
                                </span>
                                
                            </th>
                            <td :style="{ color: shosai_color[20] ,fontWeight:shosai_bold[20] == '0' ? 400 : 700 }">
                                {{ taiken_list.k_access }}
                            </td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && taiken_list.k_tel != null && taiken_list.k_tel != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer"  :style="{ color: shosai_color[19] ,fontWeight:shosai_bold[19] == '0' ? 400 : 700 }">
                                <u>{{ taiken_list.k_tel }}</u>
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 日程 -->
                    <!-- 「table」内でv-forを使うときは「template」で囲む -->
                    <template v-for="(result,i) in disp_nittei_list" v-bind:key="i" >
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- 日程 -->
                        <tr>
                            <th>
                                <label for="">
                                    日程{{ result[0].nittei_group }}
                                </label>
                            </th>
                            <td style="text-align: left" :style="{ color: shosai_color[22] ,fontWeight:shosai_bold[22] == '0' ? 400 : 700 }">
                            
                              <b>開催日：</b>
                              <template v-if="result[0].kaisai_start">
                                {{DateSetting(result[0].kaisai_start)}} <span v-if="result[0].kaisai_end && result[0].kaisai_end != result[0].kaisai_start">～{{DateSetting(result[0].kaisai_end)}}</span>
                              </template>
                              <br>
                              
                              <span  v-if="taiken_list.shubetsu == 1">
                                <span style="display:flex;align-items: center;">
                                  
                                  <div>
                                    
                                    <b>時間帯<template v-if="result.length > 1">1</template>：</b>
                                    <span v-if="result[0].jikantai_start">{{TimeSetting(result[0].jikantai_start)}} ～ {{TimeSetting(result[0].jikantai_end)}}</span>
                                    <span v-if="taiken_list.teiin_settei == 0">
                                      &nbsp;&nbsp;<b>定員：</b>
                                        
                                        <template v-if="result[0].teiin_mongon != '' && result[0].teiin_mongon != null">
                                          {{result[0].teiin_mongon}}
                                        </template>
                                        <template v-else>
                                          <span v-if="result[0].teiin >= 999">無し</span><span v-else-if="result[0].teiin">{{result[0].teiin}} 名まで</span>
                                        </template>
                                    </span><br> 
                                    <template v-if="result[1]">
                                         <b>時間帯2：</b>
                                      <span v-if="result[1].jikantai_start">{{TimeSetting(result[1].jikantai_start)}} ～ {{TimeSetting(result[1].jikantai_end)}}</span>
                                      <span v-if="taiken_list.teiin_settei == 0">
                                        &nbsp;&nbsp;<b>定員：</b>
                                        
                                        <template v-if="result[1].teiin_mongon != '' && result[1].teiin_mongon != null">
                                          {{result[1].teiin_mongon}}
                                        </template>
                                        <template v-else>
                                          <span v-if="result[1].teiin >= 999">無し</span><span v-else-if="result[1].teiin">{{result[1].teiin}} 名まで</span>
                                        </template>
                                      </span><br> 
                                    </template>
                                    <template v-if="result[2]">
                                         <b>時間帯3：</b>
                                      <span v-if="result[2].jikantai_start">{{TimeSetting(result[2].jikantai_start)}} ～ {{TimeSetting(result[2].jikantai_end)}}</span>
                                      <span v-if="taiken_list.teiin_settei == 0">
                                        &nbsp;&nbsp;<b>定員：</b>
                                        
                                        <template v-if="result[2].teiin_mongon != '' && result[2].teiin_mongon != null">
                                          {{result[2].teiin_mongon}}
                                        </template>
                                        <template v-else>
                                          <span v-if="result[2].teiin >= 999">無し</span><span v-else-if="result[2].teiin">{{result[2].teiin}} 名まで</span>
                                        </template>
                                      </span><br> 
                                    </template>
                                  </div>
                                </span>
                                <span v-if="taiken_list.shubetsu == 1">
                                  <span v-if="result[0].kaisai_youbi != null && result[0].kaisai_youbi != ''"><b>開催曜日：</b>{{youbi_irekae(result[0].kaisai_youbi)}} <br></span>
                                  <span v-if="result[0].jogai != null && result[0].jogai != ''"><b>除外曜日：</b>{{youbi_irekae(result[0].jogai)}} <br></span>
                                  <span v-if="result[0].jogai_date != null && result[0].jogai_date != ''"><b>除外日：</b>{{result[0].jogai_date}} <br></span>
                                  
                                </span>
                                <span v-if="result[0].comment != null && result[0].comment != ''"><b>コメント：</b>{{ result[0].comment }}</span>
                              </span>
                                    
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="taiken_list.nittei_sentaku == 0">
                        <!-- 日程選択方法が日程ごと（nittei_sentaku == 1）であれば以下の項目は非表示 -->
                      <template v-if="shosai_disp[5] == 1">
                        <!-- 活動日数 -->
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label for="">活動日数</label>
                              </th>
                              <td style="text-align: left" :style="{ color: shosai_color[5] ,fontWeight:shosai_bold[5] == '0' ? 400 : 700 }">
                                
                                <template v-if="taiken_list.nissu_mongon != '' && taiken_list.nissu_mongon != null ">
                                {{ taiken_list.nissu_mongon  }}
                                </template>
                                <template v-else>
                                  <span v-if=" taiken_list.nissu_min == taiken_list.nissu_max ">
                                  {{ taiken_list.nissu_min  }}日
                                  </span>                            
                                  <span v-else-if="taiken_list.nissu_min != taiken_list.nissu_max ">
                                  <span v-if="taiken_list.nissu_max == '' || taiken_list.nissu_max == null ">
                                      {{ taiken_list.nissu_min  }}日以上
                                  </span>
                                  <span v-else-if="taiken_list.nissu_min == '' || taiken_list.nissu_min == null ">
                                      {{ taiken_list.nissu_max  }}日以下
                                  </span>
                                  <span v-else>
                                      {{taiken_list.nissu_min}} ～ {{taiken_list.nissu_max}}日
                                  </span>
                                  </span>&nbsp;&nbsp;
                                  <span v-if="taiken_list.nissu_joken == 1">連続</span>
                                </template>
                              </td>
                          </tr>
                      </template>
                    
                      <template v-if="taiken_list.teiin_settei == 1" >
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label for="">1日の定員</label>
                              </th>
                              <td style="text-align: left" :style="{ color: shosai_color[26] ,fontWeight:shosai_bold[26] == '0' ? 400 : 700 }">
                                {{ taiken_list.teiin_mongon }}
                              </td>
                          </tr>

                      </template>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝開催日から〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1"  :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="taiken_list.shimekiri_date"  :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{EuDateTimeSetting(taiken_list.shimekiri_date)}}</span>
                            <span v-else  :style="{ color: shosai_color[16] ,fontWeight:shosai_bold[16] == '0' ? 400 : 700 }">開催日の{{taiken_list.shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    
                        <!-- 参加条件（対象者） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">参加条件（対象者）</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[24] ,fontWeight:shosai_bold[24] == '0' ? 400 : 700 }">
                              <template v-if="taiken_list.joken_mongon != '' && taiken_list.joken_mongon != null">
                                {{taiken_list.joken_mongon }}
                              </template>
                              <template v-else>
                                {{createJokenText(taiken_list.joken_all_start,taiken_list.joken_all_end)}}
                              </template>
                           
                            </td>
                        </tr>
                        
                    
                        <!-- 参加にあたって（参加費、検便、検温等、マスク着用、昼食、持ち物） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                        <tr>
                            <th>
                                <label for="">参加にあたって</label>
                            </th>
                            <td style="text-align: left;">
                              <template v-if="shosai_disp[9] == 1">
                                <span  :style="{ color: shosai_color[9] ,fontWeight:shosai_bold[9] == '0' ? 400 : 700 }">
                                <b>参加費：</b>
                                  <span v-if="taiken_list.sankahi == null || taiken_list.sankahi == ''">
                                      不要
                                  </span>
                                  <span v-else>
                                  {{taiken_list.sankahi}}
                                  </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[10] == 1">
                                  <br>
                                <span  :style="{ color: shosai_color[10] ,fontWeight:shosai_bold[10] == '0' ? 400 : 700 }">
                                <b>検温等：</b>
                                    <span v-if="taiken_list.kensa == null || taiken_list.kensa == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{taiken_list.kensa}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[17] == 1">
                                  <br>
                                <span  :style="{ color: shosai_color[17] ,fontWeight:shosai_bold[17] == '0' ? 400 : 700 }">
                                    <b>検便：</b>
                                    <span v-if="taiken_list.kenben == null || taiken_list.kenben == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{taiken_list.kenben}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[11] == 1">
                                <br>
                                <span  :style="{ color: shosai_color[11] ,fontWeight:shosai_bold[11] == '0' ? 400 : 700 }">
                                    <b>マスク着用：</b>
                                    <span v-if="taiken_list.mask == null || taiken_list.mask == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{taiken_list.mask}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[12] == 1">
                                <br>
                                <span  :style="{ color: shosai_color[12] ,fontWeight:shosai_bold[12] == '0' ? 400 : 700 }">
                                <b>昼食：</b>
                                <span v-if="taiken_list.chusyoku == null || taiken_list.chusyoku == '' || taiken_list.chusyoku == '不要'">
                                    無し
                                </span>
                                <span v-else-if="taiken_list.chusyoku == '要'">
                                    有り
                                </span>
                                <span v-else>
                                {{taiken_list.chusyoku}}
                                </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[13] == 1 && (taiken_list.mochimono != null && taiken_list.mochimono != '')">
                                <br>
                                <span  :style="{ color: shosai_color[13] ,fontWeight:shosai_bold[13] == '0' ? 400 : 700 }">
                                <b>持ち物：</b>
                                {{taiken_list.mochimono}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[21] == 1 && (taiken_list.fukusou != null && taiken_list.fukusou != '')">
                                <br>
                                <span  :style="{ color: shosai_color[21] ,fontWeight:shosai_bold[21] == '0' ? 400 : 700 }">
                                <b>服装：</b>
                                {{taiken_list.fukusou}}
                                </span>
                              </template>
                            </td>
                        </tr>
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (taiken_list.shiryo_url!=null && taiken_list.shiryo_url!='')">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[7] ,fontWeight:shosai_bold[7] == '0' ? 400 : 700 }">
                                {{taiken_list.shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken_list.shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="taiken_list.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="shosai_disp[8] == 1 && (taiken_list.bikou!=null && taiken_list.bikou!='') ">
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- その他（特記事項） -->
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;"  :style="{ color: shosai_color[8] ,fontWeight:shosai_bold[8] == '0' ? 400 : 700 }">
                                {{taiken_list.bikou}}
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    </tbody>
                </table>

                <!--サブプログラム（活動2～）-->
                <template v-for="(result,s) in sub_list" v-bind:key="s">

                  <!-- 施設・地域活動 -->
                <table class="vy-form-table edit_komoku_area" v-if="taiken_list.shubetsu == 1"  style="margin-bottom:0px;margin-top:0px">
    
                    <tbody v-show="KatsudouActive=='sub' + s">

                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1">
                        <tr>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[3] ,fontWeight:shosai_bold[3] == '0' ? 400 : 700 }">
                                {{ sub_list[s].naiyou }}
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 参加の義務 -->
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                        <th>
                            <label for="">参加の義務</label>
                        </th>
                        <td style="text-align: left;"  :style="{ color: shosai_color[27] ,fontWeight:shosai_bold[27] == '0' ? 400 : 700 }">
                          {{ hissu_list[sub_list[s].hissu_flg ]}}
                          </td>
                      </tr>
                     <!-- 開催地名 -->
                     <template v-if="shosai_disp[18] == 1 && sub_list[s].k_name != null && sub_list[s].k_name != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    開催地名
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        開催地名
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;"  :style="{ color: shosai_color[18] ,fontWeight:shosai_bold[18] == '0' ? 400 : 700 }">
                            {{ sub_list[s].k_name }}
                            </td>
                        </tr>
                    </template>
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        施設住所
                                    </label>
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、開催場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" v-on:click="jusho(sub_list[s].k_jusyo)"  :style="{ color: shosai_color[4] ,fontWeight:shosai_bold[4] == '0' ? 400 : 700 }">
                                <u>{{ sub_list[s].k_jusyo }}</u>
                            </td>
                        </tr>
                    </template>
                     <!-- アクセス方法 -->
                     <template v-if="shosai_disp[20] == 1 && sub_list[s].k_access != null && sub_list[s].k_access != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    アクセス方法
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        アクセス方法
                                    </label>
                                </span>
                                
                            </th>
                            <td  :style="{ color: shosai_color[20] ,fontWeight:shosai_bold[20] == '0' ? 400 : 700 }">
                                {{ sub_list[s].k_access }}
                            </td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && sub_list[s].k_tel != null && sub_list[s].k_tel != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer"  :style="{ color: shosai_color[19] ,fontWeight:shosai_bold[19] == '0' ? 400 : 700 }">
                                <u>{{ sub_list[s].k_tel }}</u>
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 日程 -->
                    <!-- 「table」内でv-forを使うときは「template」で囲む -->
                    <template v-for="(result,i) in sub_disp_nittei_list[s]" v-bind:key="i" >
                      
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- 日程 -->
                        <tr>
                            <th>
                                <label for="">
                                    日程{{ result[0].nittei_group }}
                                </label>
                            </th>
                            <td style="text-align: left" :style="{ color: shosai_color[22] ,fontWeight:shosai_bold[2] == '0' ? 400 : 700 }">
                            
                        <b>開催日：</b>
                      
                        <template v-if="result[0].kaisai_start">
                          {{DateSetting(result[0].kaisai_start)}} <span v-if="result[0].kaisai_end && result[0].kaisai_end != result[0].kaisai_start">～{{DateSetting(result[0].kaisai_end)}}</span>
                        </template>
                        <br>
                      <span  v-if="taiken_list.shubetsu == 1">
                        <span style="display:flex">
                        <div>
                            <b>時間帯<template v-if="result.length > 1">1</template>：</b>
                          <span v-if="result[0].jikantai_start">{{TimeSetting(result[0].jikantai_start)}} ～ {{TimeSetting(result[0].jikantai_end)}}</span>
                          <span v-if="sub_list[s].teiin_settei == 0">
                            &nbsp;&nbsp;<b>定員：</b>
                            
                              <template v-if="result[0].teiin_mongon != '' && result[0].teiin_mongon != null">
                                {{result[0].teiin_mongon}}
                              </template>
                              <template v-else>
                                <span v-if="result[0].teiin >= 999">無し</span><span v-else-if="result[0].teiin">{{result[0].teiin}} 名まで</span>
                              </template>
                          </span><br> 
                          <template v-if="result[1]">
                            <b>時間帯2：</b>
                            <span v-if="result[1].jikantai_start">{{TimeSetting(result[1].jikantai_start)}} ～ {{TimeSetting(result[1].jikantai_end)}}</span>
                            <span v-if="sub_list[s].teiin_settei == 0">
                              &nbsp;&nbsp;<b>定員：</b>
                              
                              <template v-if="result[1].teiin_mongon != '' && result[1].teiin_mongon != null">
                                {{result[1].teiin_mongon}}
                              </template>
                              <template v-else>
                                <span v-if="result[1].teiin >= 999">無し</span><span v-else-if="result[1].teiin">{{result[1].teiin}} 名まで</span>
                              </template>
                            </span><br> 
                          </template>
                          <template v-if="result[2]">
                            <b>時間帯3：</b>
                            <span v-if="result[2].jikantai_start">{{TimeSetting(result[2].jikantai_start)}} ～ {{TimeSetting(result[2].jikantai_end)}}</span>
                            <span v-if="sub_list[s].teiin_settei == 0">
                              &nbsp;&nbsp;<b>定員：</b>
                              
                              <template v-if="result[2].teiin_mongon != '' && result[2].teiin_mongon != null">
                                {{result[2].teiin_mongon}}
                              </template>
                              <template v-else>
                                <span v-if="result[2].teiin >= 999">無し</span><span v-else-if="result[2].teiin">{{result[2].teiin}} 名まで</span>
                              </template>
                            </span><br> 
                          </template>
                        </div>
                        </span>
                        <span v-if="taiken_list.shubetsu == 1">
                          <span v-if="result[0].kaisai_youbi != null && result[0].kaisai_youbi != ''"><b>開催曜日：</b>{{youbi_irekae(result[0].kaisai_youbi)}} <br></span>
                          <span v-if="result[0].jogai != null && result[0].jogai != ''"><b>除外曜日：</b>{{youbi_irekae(result[0].jogai)}} <br></span>
                          <span v-if="result[0].jogai_date != null && result[0].jogai_date != ''"><b>除外日：</b>{{result[0].jogai_date}} <br></span>
                       
                        </span>
                        <span v-if="result[0].comment != null && result[0].comment != ''"><b>コメント：</b>{{ result[0].comment }}</span>
                      </span>
                                    
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="sub_list[s].nittei_sentaku == 0">
                        <!-- 日程選択方法が日程ごと（nittei_sentaku == 1）であれば以下の項目は非表示 -->
                        <!-- 活動日数 -->
                        <template v-if="shosai_disp[5] == 1">
                            <tr >
                                <td colspan="2"><div class="vy-dotted"></div></td>
                            </tr>
                            <tr>
                                <th>
                                    <label for="">活動日数</label>
                                </th>
                                <td style="text-align: left" :style="{ color: shosai_color[5] ,fontWeight:shosai_bold[5] == '0' ? 400 : 700 }">
                                        
                                    <template v-if="sub_list[s].nissu_mongon != '' && sub_list[s].nissu_mongon != null ">
                                    {{ sub_list[s].nissu_mongon  }}
                                    </template>
                                    <template v-else>
                                        <span v-if=" sub_list[s].nissu_min == sub_list[s].nissu_max ">
                                        {{ sub_list[s].nissu_min  }}日
                                        </span>                            
                                        <span v-else-if="sub_list[s].nissu_min != sub_list[s].nissu_max ">
                                        <span v-if="sub_list[s].nissu_max == '' || sub_list[s].nissu_max == null ">
                                            {{ sub_list[s].nissu_min  }}日以上
                                        </span>
                                        <span v-else-if="sub_list[s].nissu_min == '' || sub_list[s].nissu_min == null ">
                                            {{ sub_list[s].nissu_max  }}日以下
                                        </span>
                                        <span v-else>
                                            {{sub_list[s].nissu_min}} ～ {{sub_list[s].nissu_max}}日
                                        </span>
                                        </span>&nbsp;&nbsp;
                                        <span v-if="sub_list[s].nissu_joken == 1">連続</span>
                                    </template>
                                </td>
                            </tr>
                        </template>
                        
                        <template v-if="sub_list[s].teiin_settei == 1" >
                            <tr >
                                <td colspan="2"><div class="vy-dotted"></div></td>
                            </tr>
                            <tr>
                                <th>
                                    <label for="">1日の定員</label>
                                </th>
                                <td style="text-align: left" :style="{ color: shosai_color[26] ,fontWeight:shosai_bold[26] == '0' ? 400 : 700 }">
                                  {{ sub_list[s].teiin_mongon }}
                                </td>
                            </tr>

                        </template>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝開催日から〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="sub_list[s].shimekiri_date" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{EuDateTimeSetting(sub_list[s].shimekiri_date)}}</span>
                            <span v-else :style="{ color: shosai_color[16] ,fontWeight:shosai_bold[16] == '0' ? 400 : 700 }">開催日の{{sub_list[s].shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    
                        <!-- 参加条件（対象者） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">参加条件（対象者）</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[24] ,fontWeight:shosai_bold[24] == '0' ? 400 : 700 }">
                              <template v-if="sub_list[s].joken_mongon != '' && sub_list[s].joken_mongon != null">
                                {{sub_list[s].joken_mongon }}
                              </template>
                              <template v-else>
                                {{createJokenText(sub_list[s].joken_all_start,sub_list[s].joken_all_end)}}
                              </template>
                            </td>
                        </tr>
                        
                    
                        <!-- 参加にあたって（参加費、検便、検温等、マスク着用、昼食、持ち物） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                        <tr>
                            <th>
                                <label for="">参加にあたって</label>
                            </th>
                            <td style="text-align: left;">
                              <template v-if="shosai_disp[9] == 1">
                                <span :style="{ color: shosai_color[9] ,fontWeight:shosai_bold[9] == '0' ? 400 : 700 }">
                                <b>参加費：</b>
                                  <span v-if="sub_list[s].sankahi == null || sub_list[s].sankahi == ''">
                                      不要
                                  </span>
                                  <span v-else>
                                  {{sub_list[s].sankahi}}
                                  </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[10] == 1">
                                  <br>
                                  <span :style="{ color: shosai_color[10] ,fontWeight:shosai_bold[10] == '0' ? 400 : 700 }">
                                    <b>検温等：</b>
                                    <span v-if="sub_list[s].kensa == null || sub_list[s].kensa == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{sub_list[s].kensa}}
                                    </span>
                                  </span>
                              </template>
                              <template v-if="shosai_disp[17] == 1">
                                  <br>
                                  <span :style="{ color: shosai_color[17] ,fontWeight:shosai_bold[17] == '0' ? 400 : 700 }">
                                    <b>検便：</b>
                                    <span v-if="sub_list[s].kenben == null || sub_list[s].kenben == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{sub_list[s].kenben}}
                                    </span>
                                  </span>
                              </template>
                              <template v-if="shosai_disp[11] == 1">
                                <br>
                                <span :style="{ color: shosai_color[11] ,fontWeight:shosai_bold[11] == '0' ? 400 : 700 }">
                                    <b>マスク着用：</b>
                                    <span v-if="sub_list[s].mask == null || sub_list[s].mask == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{sub_list[s].mask}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[12] == 1">
                                <br>
                                <span :style="{ color: shosai_color[12] ,fontWeight:shosai_bold[12] == '0' ? 400 : 700 }">
                                    <b>昼食：</b>
                                    <span v-if="sub_list[s].chusyoku == null || sub_list[s].chusyoku == '' || sub_list[s].chusyoku == '不要'">
                                        無し
                                    </span>
                                    <span v-else-if="sub_list[s].chusyoku == '要'">
                                        有り
                                    </span>
                                    <span v-else>
                                    {{sub_list[s].chusyoku}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[13] == 1 && (sub_list[s].mochimono != null && sub_list[s].mochimono != '')">
                                <br>
                                <span :style="{ color: shosai_color[13] ,fontWeight:shosai_bold[13] == '0' ? 400 : 700 }">
                                <b>持ち物：</b>
                                {{sub_list[s].mochimono}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[21] == 1 && (sub_list[s].fukusou != null && sub_list[s].fukusou != '')">
                                <br>
                                <span :style="{ color: shosai_color[21] ,fontWeight:shosai_bold[21] == '0' ? 400 : 700 }">
                                <b>服装：</b>
                                {{sub_list[s].fukusou}}
                                </span>
                              </template>
                            </td>
                        </tr>
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (sub_list[s].shiryo_url!=null && sub_list[s].shiryo_url!='')">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[7] ,fontWeight:shosai_bold[7] == '0' ? 400 : 700 }">
                                {{sub_list[s].shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(sub_list[s].shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="sub_list[s].shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="shosai_disp[8] == 1 && sub_list[s].bikou!=null ">
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- その他（特記事項） -->
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[8] ,fontWeight:shosai_bold[8] == '0' ? 400 : 700 }">
                                {{sub_list[s].bikou}}
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    </tbody>
                </table>

                </template>
                
                <!-- 制作・寄付活動 -->
                <table class="vy-form-table" v-if="taiken_list.shubetsu == 2" style="margin-bottom:0px">

                    <!-- No. プログラム名称 -->
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;" :style="{ color: shosai_color[2] ,fontWeight:shosai_bold[2] == '0' ? 400 : 700 }">
                            <b>{{ taiken_list.taiken_no_text }}：{{ taiken_list.name }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"><div class="vy-dotted pc_only"></div></td>
                    </tr>

                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1 ">
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[3] ,fontWeight:shosai_bold[3] == '0' ? 400 : 700 }">
                                {{ taiken_list.naiyou }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    
                    <!-- 参加の義務 -->
                    <template v-if="sub_list.length != 0">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                        <th>
                            <label for="">参加の義務</label>
                        </th>
                        <td style="text-align: left;" :style="{ color: shosai_color[27] ,fontWeight:shosai_bold[27] == '0' ? 400 : 700 }">
                          {{ hissu_list[taiken_list.hissu_flg ]}}
                          </td>
                      </tr>
                    </template>

                    
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1 ">
                        <tr>
                            <th>

                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、提出場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label for="">施設住所</label>
                                    <span class="balloon_parent">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、提出場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>    
                            </th>
                            <td style="text-align: left;cursor:pointer" v-on:click="jusho(taiken_list.k_jusyo)" :style="{ color: shosai_color[4] ,fontWeight:shosai_bold[4] == '0' ? 400 : 700 }">
                                <u>{{ taiken_list.k_jusyo }}</u>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                     <!-- アクセス方法 -->
                     <template v-if="shosai_disp[20] == 1 && taiken_list.k_access != null && taiken_list.k_access != ''">
                        <tr>
                            <th>
                                <label class="sp_only">
                                    アクセス方法
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        アクセス方法
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left" :style="{ color: shosai_color[20] ,fontWeight:shosai_bold[20] == '0' ? 400 : 700 }">
                                {{ taiken_list.k_access }}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && taiken_list.k_tel != null && taiken_list.k_tel != ''">
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;color:red;cursor:pointer" >
                                <u>{{ taiken_list.k_tel }}</u>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    <!-- 開催期間 -->
                    <tr>
                        <th>
                            <label for="">開催期間</label>
                        </th>
                        <td style="text-align: left" :style="{ color: shosai_color[22] ,fontWeight:shosai_bold[22] == '0' ? 400 : 700 }">
                            
                            {{DateSetting(taiken_list.kaisai_start)}}
                            <span v-if="taiken_list.kaisai_end && taiken_list.kaisai_end != taiken_list.kaisai_start"> ～ {{DateSetting(taiken_list.kaisai_end)}}</span>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>

                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="taiken_list.shimekiri_date" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{EuDateTimeSetting(taiken_list.shimekiri_date)}}</span>
                            <span v-else :style="{ color: shosai_color[16] ,fontWeight:shosai_bold[16] == '0' ? 400 : 700 }">開催日の{{taiken_list.shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 制作・寄付活動条件 -->
                    <template v-if="shosai_disp[14] == 1 && taiken_list.seisaku_joken!=null ">
                        <tr>
                            <th>
                                <label for="seisaku_joken">制作・寄付活動条件</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[14] ,fontWeight:shosai_bold[14] == '0' ? 400 : 700 }">
                                {{taiken_list.seisaku_joken}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                     
                    </template>
                    
                    <!-- 届け先 -->
                    <template v-if="shosai_disp[15] == 1 ">
                        <tr>
                            <th>
                                <label for="todokesaki">届け先</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[15] ,fontWeight:shosai_bold[15] == '0' ? 400 : 700 }">
                                {{taiken_list.todokesaki}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                    </template>
                    
                    <!--定員（制作）-->
                        <tr>
                            <th>
                                <label for="todokesaki">申込人数 / 定員</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[25] ,fontWeight:shosai_bold[25] == '0' ? 400 : 700 }">
                               {{ok_user_count}} 人 / {{taiken_list.seisaku_teiin}} 人
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>


                    <!-- 参加条件（対象者） -->
                    <tr>
                        <th>
                            <label for="">参加条件（対象者）</label>
                        </th>
                        <td style="text-align: left;" :style="{ color: shosai_color[24] ,fontWeight:shosai_bold[24] == '0' ? 400 : 700 }">
                              <template v-if="taiken_list.joken_mongon != '' && taiken_list.joken_mongon != null">
                                {{taiken_list.joken_mongon }}
                              </template>
                              <template v-else>
                                {{createJokenText(taiken_list.joken_all_start,taiken_list.joken_all_end)}}
                              </template>
                        </td>
                    </tr>

                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (taiken_list.shiryo_url!=null && taiken_list.shosai_disp!='')">
                        <tr v-if="taiken_list.shiryo_url!=null && taiken_list.shiryo_url!=''">
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[7] ,fontWeight:shosai_bold[7] == '0' ? 400 : 700 }">
                                {{taiken_list.shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken_list.shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="taiken_list.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>

                    <!-- その他（特記事項） -->
                    <template v-if="shosai_disp[8] == 1 && (taiken_list.bikou!=null && taiken_list.bikou!='') ">
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[8] ,fontWeight:shosai_bold[8] == '0' ? 400 : 700 }">
                                {{taiken_list.bikou}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                </table>
                
                <!--事前説明会-->
                <div style="text-align:left;padding:5px;margin-top:10px" v-if="jizen.length != 0 && taiken_jizen_no.length != 0 && (jizen_jisshi == 1 && taiken_flow == 2)">
                    <label><b>事前説明会</b></label>
                    <!-- PC -->
                    <table style="width: 100%;" class="pc_only">
                    <tr><td>説明会名</td><td>開催日時</td><td>受付〆切日</td><td>体験開始日</td><td>場所・住所</td><td>定員</td><td>参加</td><td>特記事項</td></tr>
                        
                        <tr v-for="(result,i) in jizen" v-bind:key="i" >
                    
                            <td width="14%">{{ result.jizen_name }} </td>
                            <td width="10%">
                                
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    <br>
                                    
                                    {{ TimeSetting(result.jikantai_start) }}
                                    <template v-if="result.jikantai_start && result.jikantai_end">
                                      ～
                                    </template>
                                    {{ TimeSetting(result.jikantai_end) }}
                                  </template>
                            </td>
                            <td width="13%">{{ DateSetting(result.shimekiri_date) }} </td>
                            <td width="13%">{{ DateSetting(result.taikenkaishi_date) }} </td>
                            <td width="20%">{{ result.basyo }}
                                <br>
                                <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                                <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                            </td>
                            <td width="10%">
                                <span v-if="result.syurui == 3">ー</span>
                                <span v-else-if="(result.teiin == '' || result.teiin == null)">ー</span>
                                <span v-else-if="result.teiin >= 999">無し</span>
                                <span v-else>
                                {{ result.sanka_ninzu }} 名 / {{ result.teiin }} 名まで
                                </span>
                            </td>
                            <td width="5%">
                                <span v-if="result.sanka_flg == 0">必須</span>
                                <span v-else>任意</span>
                            </td>
                            <td width="15%">
                                
                                <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                                <span v-else style="white-space: pre-wrap;color:red">
                                {{ result.bikou1}} 
                                </span>
                            </td>
                    </tr>

                    </table>
                    <table style="width: 100%;" class="sp_only">
                        <template v-for="(result,i) in jizen" v-bind:key="i">
                                <tr>
                                    <td width="35%">説明会名</td>
                                    <td width="65%">{{ result.jizen_name }} </td>
                                </tr>
                                <tr >
                                <td>
                                    <template v-if="result.syurui == 3">視聴期間</template>
                                    <template v-else>開催日時</template>
                                </td>
                                <td>
                                   
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    {{ TimeSetting(result.jikantai_start) }}
                                    <template v-if="result.jikantai_start && result.jikantai_end">
                                      ～
                                    </template>
                                    {{ TimeSetting(result.jikantai_end) }}
                                  </template>
                                </td>

                                </tr>
                                <tr >
                                <td>受付〆切日</td>
                                <td>
                                    
                                    <span v-if="result.shimekiri_date == '' || result.shimekiri_date == null|| result.shimekiri_date == 'None'">ー</span>
                                    <span v-else> {{ DateSetting(result.shimekiri_date)  }}</span>
                                </td>

                                </tr>
                                <template  v-if="result.syurui != 3">
                                <tr>
                                <td>体験開始日</td>
                                <td>
                                    <template v-if="result.syurui == 3">ー</template>
                                    <template v-else>{{ DateSetting(result.taikenkaishi_date) }}</template>
                                </td>
                                
                                </tr>
                                    <tr>
                                    <td>場所</td>
                                    <td>
                                        
                                        <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                                        <span v-else> {{ result.basyo }}</span>
                                    </td>
                                    
                                    </tr>
                                </template>
                                <template v-if="result.syurui == '1'">
                                    <!-- 対面時のみ表示 -->
                                    <tr>
                                    <td>住所</td>
                                    <td>
                                        <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                                        <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                                    </td>
                                    </tr>
                                </template>
                                
                                <template  v-if="result.syurui != 3">
                                    <tr>
                                    <td>定員</td>
                                    <td>
                                        <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                                        <span v-else-if="result.teiin >= 999">無し</span>
                                        <span v-else>
                                        {{ result.sanka_ninzu }} 名 / {{ result.teiin }} 名まで
                                        </span>
                                    </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td>参加</td>
                                    <td>
                                    <span v-if="result.sanka_flg == 0">必須</span>
                                    <span v-else>任意</span>
                                    </td>
                                </tr>
                                <tr>
                                <td>特記事項</td>
                                <td>
                                    <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                                    <span v-else style="white-space: pre-wrap;color:red;">{{ result.bikou1 }}</span>
                                </td>
                                </tr>
                            <tr><td style="border:0"></td></tr>
                        </template>
                    
                    </table>
                    <div class="vy-dotted" style="margin-top:10px"></div>
                </div>
                <!--事後集会-->
                <div style="text-align:left;padding:5px;margin-top:10px" v-if="jigo.length != 0 && taiken_jigo_no.length != 0 && jigo_jisshi == 1">
                    <label><b>事後集会</b></label>
                        <!-- PC -->
                        <table style="width: 100%;" class="pc_only">
                            <tr><td>集会名</td><td>集会日時</td><td>場所・住所</td><td>定員</td><td>参加</td><td>特記事項</td></tr>
                                
                            <tr v-for="(result,i) in jigo" v-bind:key="i" >
                            
                                    <td width="14%">{{ result.jigo_name }} </td>
                                    <td width="10%">{{ DateSetting(result.kaisai_date) }}<br>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </td>
                                    <td width="40%">{{ result.basyo }}
                                        <br>
                                        <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                                        <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                                    </td>
                                    <td width="10%">
                                        
                                        <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                                        <span v-else-if="result.teiin >= 999">無し</span>
                                        <span v-else>
                                        {{ result.sanka_ninzu }} 名 / {{ result.teiin }} 名まで
                                        </span>
                                    </td>
                                    <td width="6%">
                                        
                                        <span v-if="result.syomei_flg == 0">必須</span>
                                        <span v-else>任意</span>
                                    </td>
                                    <td width="20%">
                                        
                                        <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                                        <span v-else style="white-space: pre-wrap;color:red">
                                        {{ result.bikou1 }} 
                                        </span>
                                    </td>
                            </tr>

                         </table>
                         <table style="width: 100%;" class="sp_only">
                            <template v-for="(result,i) in jigo" v-bind:key="i">
                                <tr>
                                    <td width="35%">集会名</td>
                                    <td width="65%">{{ result.jigo_name }} </td>
                                </tr>
                                <tr >
                                    <td>集会日時</td>
                                    <td>
                                    {{ DateSetting(result.kaisai_date) }} 
                                    <span v-if="result.syurui != 3">
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </span>
                                    <span v-else>まで</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>場所</td>
                                    <td>
                                        <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                                        <span v-else> {{ result.basyo }}</span>
                                    </td>
                                </tr>
                                <template v-if="result.syurui == '1'">
                                    <!-- 対面時のみ表示 -->
                                    <tr>
                                        <td>住所</td>
                                        <td>
                                        <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                                        <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td>定員</td>
                                    <td>
                                        <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                                        <span v-else-if="result.teiin >= 999">無し</span>
                                        <span v-else>
                                        {{ result.sanka_ninzu }} 名 / {{ result.teiin }} 名まで
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>参加</td>
                                    <td>
                                        <span v-if="result.syomei_flg == 0">必須</span>
                                        <span v-else>任意</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>特記事項</td>
                                    <td>
                                    <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                                    <span v-else style="color:red;white-space: pre-wrap;">{{ result.bikou1 }}</span>
                                    </td>
                                </tr>
                                <tr><td style="border:0"></td></tr>
                            </template>
                        </table>
                    </div>
            </div>
            
        
            <!-- リスト表示タブの中身 -->
            <template v-else-if="TabActive === 'tab_list'">
                <div style="width: 100%;padding:10px 0;text-align: left;display: flex;align-items: center;">
                    <span style="font-size:20px;color:#030ba0"><b>{{ taiken_list.taiken_no_text  }}：{{ taiken_list.name  }}</b></span>
                </div>
                <div id="tab" style="display: flex;justify-content: space-between;" v-if="taiken_list.shubetsu == 1 && sub_list.length != 0">
                  <ul id="katsudou_tabMenu" class="edit_tabMenu" >
                    <template v-if="KatsudouActive=='main'">
                        <li class="tabblue">活動1</li>
                      </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
                      </template>
                      <template v-for="(result,s) in sub_list" v-bind:key="s">
                        <template v-if="KatsudouActive=='sub'+s">
                          <li class="tabblue" >活動{{s+2}}</li>
                        </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                      </template>
                    </template>
                  </ul>
                </div>
                <div style="margin:0 auto;">
                
                <div class="edit_komoku_area"  v-if="KatsudouActive=='main'">
                <div id="katsudou_area">  
                    <div>
                      <b>活動内容：</b>{{taiken_list.naiyou}}
                    </div>
                    <div class="pc_only">
                        <span style="margin-right:10px"  v-if="sub_list.length !=0">
                        <b>参加の義務：</b><u>{{ hissu_list[taiken_list.hissu_flg ]}}</u>
                        </span>
                      <template v-if="taiken_list.k_name != '' && taiken_list.k_name != null">
                         <span style="margin-right:10px">
                        <b >開催地名：</b>{{taiken_list.k_name}}
                         </span>
                      </template>
                      <template v-if="taiken_list.k_jusyo != '' && taiken_list.k_jusyo != null">
                         <span style="margin-right:10px">
                        <b>施設住所：</b><u style="color:red">{{ taiken_list.k_jusyo}}</u>
                         </span>
                      </template>
                    </div>
                    <div class="sp_only">
                        <span  v-if="sub_list.length !=0">
                        <b>参加の義務：</b><u>{{ hissu_list[taiken_list.hissu_flg ]}}</u><br>
                        </span>
                      <template v-if="taiken_list.k_name != '' && taiken_list.k_name != null">
                        <b >開催地名：</b>{{taiken_list.k_name}}<br>
                      </template>
                      <template v-if="taiken_list.k_jusyo != '' && taiken_list.k_jusyo != null">
                        <b>施設住所：</b><u style="color:red">{{ taiken_list.k_jusyo}}</u>
                      </template>
                    </div>
                    <div>
                        <b>申込条件：</b>
                        <template  v-if="taiken_list.nittei_sentaku == 0">
                            {{taiken_list.nissu_mongon}}
                        </template>
                        <template v-else>
                            各日程ごとの全対象日に参加が必要
                        </template>
                    </div>
                </div>
                  
                <template v-if="taiken_list.nittei_sentaku == 0">
                    <template v-if="moushikomi_list.length == 0">
                        <b>選択できる日程がありません。</b>
                    </template>
                    <template v-else>
                        <!--
                      <div id="tab" style="display: flex;justify-content: space-between;" v-if="disp_nittei_list.length > 1">
                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                          <template v-for="(result,i3) in disp_nittei_list" v-bind:key="i3">
                            <template v-if="NitteiActive == i3">
                              <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                            </template>
                            <template v-else>
                              <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group}}</li>
                            </template>
                          </template>
                        </ul>
                      </div>-->
                        <div id="title_area">
                            <div class="list_column_header list_column_left">開催日</div>
                            <div class="list_column_header list_column_center">時間帯</div>
                            <div class="list_column_header list_column_standard">

                                <span class="sp_only">
                                    残り人数
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('当日に別の予定がある場合、選択できません。')" />
                                </span>
                                <span class="pc_only">
                                    残り人数
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon-top-right">
                                            当日に別の予定がある場合、選択できません。
                                        </span>
                                    </span>
                                </span>


                            </div>
                        </div>
                        <template v-for="(row,i2) in moushikomi_list" v-bind:key="i2">
                            
                            <!--
                            <br v-if="i2 != 0">
                            <template v-if="moushikomi_list.length != 1">
                            <div id="katsudou_button_area">
                            <template  v-for="(row3,i3) in moushikomi_list" v-bind:key="i3">
                                <template v-if="i3 == i2">
                                    <input type="button" class="katsudou_green" v-bind:value="'日程' + (i3+1)" v-bind:id="'katsudou_nittei9999_nittei'+(i3)">
                                </template>
                                <template v-else>
                                    <input type="button" class="katsudou_white"  v-on:click="link_katsudou_nittei_nittei(9999,i3)" v-bind:value="'日程' + (i3+1)">
                                </template>
                            </template>
                            </div>
                            </template>
                            -->
                            
                      <!--
                  <div class="edit_komoku_area" style="padding-top:10px" v-if="i2 == NitteiActive">-->
                        <div v-for="(result,i) in row" v-bind:key="i" class="vy-search-result-row">
                            <div id="list_column_area">
                                <!--一番最初の日付、または前の日と別日の場合-->
                                <div class="list_column_left" style="border-top:1px solid #000 ;" v-if=" i==0 || moushikomi_list[i2][i-1].hyoji_date != result.hyoji_date  ">{{ result.hyoji_date }}({{ result.youbi }})</div>
                                
                                <!--前の日と同じ日の場合-->
                                <div class="list_column_left" v-else-if="moushikomi_list[i2][i-1].hyoji_date == result.hyoji_date"></div>
                                
                                <!--時間帯（v-ifで背景色を変えているが中身は一緒なので変更するときは両方直すこと）-->

                                <!-- 未ログイン・未ユーザー登録の場合は時間帯の表示のみ -->
                                <div v-if="mode=='nologin' || mode=='noinfo'" class="list_column_center" >
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                </div>

                                <!--選択済み時間帯の時
                                "select_date[i2].findIndex(({bango}) => bango == i) != -1" -->
                                <!--<div v-else-if="select_date[i2].findIndex(array => array.bango == i && array.nittei_group == moushikomi_list[i2].nittei_group) != -1" -->
                                <div v-else-if="select_date[i2].findIndex(({bango}) => bango == i) != -1" 
                                    style="background-color: #AFA;" class="list_column_center" v-bind:id="['set_id9999'+i2 + i]" v-bind:class="['set_id9999'+i2 + i]">
                                    <!-- 自分が申し込んでいない日、かつ、「定員がオーバーしていない、または、キャンセル待ち機能利用」の場合はクリック可 -->
                                    <span v-if="((result.teiin > result.ninzu) || cancel_setting == 0)  && result.moushikomi_flg == 0">
                                    <a href="#" v-on:click.prevent.stop="Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango,i2,result.teiin,result.ninzu)" class="vy-search-result-row-a">
                                        
                                        <u>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</u>
                                    </a>
                                    </span>

                                    <!-- それ以外はクリック不可 -->
                                    <span v-else>
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </span>
                                
                                </div>

                                <!--未選択時間帯の時-->
                                <div v-else class="list_column_center" v-bind:id="['set_id9999'+i2 + i]" v-bind:class="['set_id9999'+i2 + i]">
                                    <!-- 自分が申し込んでいない日、かつ、「定員がオーバーしていない、または、キャンセル待ち機能利用」の場合はクリック可 -->
                                    <span v-if="((result.teiin > result.ninzu || cancel_setting == 0)  && result.moushikomi_flg == 0 )">
                                    
                                    <a href="#" v-on:click.prevent.stop="Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango,i2,result.teiin,result.ninzu)" class="vy-search-result-row-a">
                                        <u>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</u>
                                    </a>
                                    </span>
                                    <!-- それ以外はクリック不可 -->
                                    <span v-else>
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </span>
                                </div>
                                
                                <!--申込人数-->
                                <template v-if="taiken_list.teiin_settei == 0">
                                    <!--時間帯ごと選択-->

                                    <!-- 申込むユーザーが既に他のプログラムでこの日時を申込んでいた場合 -->
                                    <div v-if="result.moushikomi_flg != 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                        申込済
                                            <span v-if="result.moushikomi_flg == 1" >
                                            (体験)
                                            </span>
                                            <span v-else-if="result.moushikomi_flg == 2" >
                                            (事前)
                                            </span>
                                            <span v-else-if="result.moushikomi_flg == 3" >
                                            (事後)
                                            </span>
                                    </div>

                                    <!--人数が超過しているがキャンセル待ち機能を利用できる場合-->
                                    <div v-else-if="(result.teiin - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                        <template v-if="cancel_setting == 0">
                                            キャンセル待ち
                                            <template v-if="(result.ninzu - result.teiin) > 0">
                                                {{(result.ninzu - result.teiin)}}人
                                            </template>
                                        </template>
                                        <template v-else>
                                            満員
                                        </template>                    
                                    </div>

                                    <div v-else class="list_column_standard" style="border-top:1px solid #000;">
                                        <template v-if="result.teiin >= 999">定員無し</template>
                                        <template v-else>あと {{ result.teiin - result.ninzu }}名</template>
                                        <!--  <span v-if="result.teiin != null"> / {{ result.teiin }}人</span>-->
                                        
                                    </div>
                                </template>
                                <template v-else>
                                    <!--1日ごと定員の場合-->
                                    <template v-if="i == 0 || (moushikomi_list[i2][i-1].hyoji_date != result.hyoji_date)">
                                        <div v-if="result.moushikomi_flg != 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                            申込済
                                            <span v-if="result.moushikomi_flg == 1" >
                                            (体験)
                                            </span>
                                            <span v-else-if="result.moushikomi_flg == 2" >
                                            (事前)
                                            </span>
                                            <span v-else-if="result.moushikomi_flg == 3" >
                                            (事後)
                                            </span>
                                        </div>
                                                        
                                        <div v-else-if="(taiken_list.teiin_oneday - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                            <template v-if="cancel_setting == 0">
                                                キャンセル待ち
                                                <template v-if="(result.ninzu - taiken_list.teiin_oneday) > 0">
                                                    {{(result.ninzu - taiken_list.teiin_oneday)}}人
                                                </template>
                                            </template>
                                            <template v-else>
                                                満員
                                            </template>                    
                                        </div>
                                        <!--定員の扱いが「時間帯ごと」の場合は時間帯ごとに人数を表示-->
                                        <div v-else-if="i==0 || (moushikomi_list[i2][i-1].hyoji_date != result.hyoji_date)" class="list_column_standard" style="border-top:1px solid #000;">
                                            <template v-if="taiken_list.teiin_oneday >= 999">定員無し</template>
                                            <template v-else>あと {{ taiken_list.teiin_oneday - result.ninzu }}名</template>
                                        </div>
                                                        
                                    </template>
                                    <template v-else>
                                        <div v-if="result.moushikomi_flg != 0" class="list_column_standard" style="background-color: pink;">
                                          
                                        </div>
                                                        
                                        <div v-else-if="(taiken_list.teiin_oneday - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;">
                                                      
                                        </div>
                                        <div v-else class="list_column_standard">
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <hr style="margin:0;border: 1px solid #000;">
                        <!--
                    </div>-->
                        </template>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="set_nittei_list.length == 0">
                        <b>申し込める日程がありません。</b>
                    </template>
                    <template v-else>
                        <div id="title_area">
                            <div class="list_column_header list_column_left" style="flex: 3 3 0%;">開催日時</div>
                            <div class="list_column_header list_column_standard" style="flex: 1 1 0%;">残り人数</div>
                        </div>
                        <template v-for="(result,i) in set_nittei_list" v-bind:key="i">
                        <div class="vy-search-result-row" style="display: flex;align-items: center;border: 1px solid #000;">
                            <div class="list_column_header list_column_left" style="flex: 3 3 0%;text-align:left;
                                height:auto;
                                border:0;
                                border-right:1px solid #000;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex-direction: column;">
                                <template v-if="result.all_sanka_ok == 0">
                                    <div v-if="result.kaisai_start == select_date[i]?.[0]?.kaisai_date"
                                    style="background-color: #AFA;width: 100%;height: 100%;display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    flex-direction: column;
                                    cursor:pointer" 
                                    v-on:click="Set_list_click(i,1)"
                                    v-bind:id="['set_list9999'+ i]" v-bind:class="['set_list9999'+ i]">
                                        
                                        <u>{{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                        {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                        <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                        <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                        <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span>
                                        </u>
                                    </div>
                                    <div v-else style="width: 100%;height: 100%;display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    flex-direction: column;
                                    cursor:pointer" 
                                    v-on:click="Set_list_click(i,1)"
                                    v-bind:id="['set_list9999'+ i]" v-bind:class="['set_list9999'+ i]">
                                        
                                        
                                        <u>
                                        {{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                        {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                        <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                        <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                        <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span></u>
                                    </div>
                                </template>
                                <template v-else>
                                    <div style="width: 100%;height: 100%;display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    flex-direction: column;
                                    cursor:pointer" 
                                    v-bind:id="['set_list9999'+ i]" v-bind:class="['set_list9999'+ i]">
                                        {{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                        {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                        <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                        <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                        <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span>
                                    </div>
                                </template>
                                
                                  
                            </div>
                            <template v-if="result.all_sanka_ok == 0">
                                <template v-if="result.teiin <= result.ninzu">
                                <div class="list_column_header list_column_standard" style="flex: 1 1 0%;background-color: pink;text-align:left;border:0">
                                    <template v-if="cancel_setting == 0">
                                        キャンセル待ち 
                                        <template v-if="(result.ninzu - result.teiin) > 0">
                                            {{(result.ninzu - result.teiin)}}人
                                        </template>
                                    </template>
                                    <template v-else>
                                        満員
                                    </template>
                                </div>
                                </template>
                                <template v-else>
                                    
                                    <div class="list_column_header list_column_standard" style="flex: 1 1 0%;text-align:left;border:0">
                                        <template v-if="result.teiin >= 999">
                                            定員なし
                                        </template>
                                        <template v-else>
                                            あと{{result.teiin - result.ninzu}} 名
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div class="list_column_header list_column_standard" style="flex: 1 1 0%;background-color: pink;text-align:left;border:0">申込済</div>
                            </template>
                        </div>
                        </template>
                        <hr style="margin:0;border: 1px solid #000;">
                    </template>
                  </template>
                  
  
                </div>
                </div>
                    <template v-if="sub_list.length !=0">
                        <div v-for="(sub,s) in sub_list" v-bind:key="s" style="margin:0px auto;;">
                            
                        <div class="edit_komoku_area"  v-if="KatsudouActive=='sub'+s">
                            <div id="katsudou_area">  
                                <div>
                                <b>活動内容：</b>{{sub_list[s].naiyou}}
                                </div>

                                <div class="pc_only">
                                    <span style="margin-right:10px"  >
                                    <b>参加の義務：</b><u>{{ hissu_list[sub_list[s].hissu_flg ]}}</u>
                                    </span>
                                    <template v-if="sub_list[s].k_name != '' && sub_list[s].k_name != null">
                                        <span style="margin-right:10px"  >
                                            <b >開催地名：</b>{{sub_list[s].k_name}}
                                        </span>
                                    </template>
                                    <template v-if="sub_list[s].k_jusyo != '' && sub_list[s].k_jusyo != null">
                                        
                                        <span style="margin-right:10px"  >
                                            <b>施設住所：</b><u style="color:red">{{ sub_list[s].k_jusyo}}</u>
                                        </span>
                                    </template>
                                </div>
                                <div class="sp_only">
                                    <b>参加の義務：</b><u>{{ hissu_list[sub_list[s].hissu_flg ]}}</u><br>
                                    <template v-if="sub_list[s].k_name != '' && sub_list[s].k_name != null">
                                      <b>開催地名：</b>{{sub_list[s].k_name}}<br>
                                    </template>
                                    <template v-if="sub_list[s].k_jusyo != '' && sub_list[s].k_jusyo != null">
                                         <b >施設住所：</b><u style="color:red">{{ sub_list[s].k_jusyo}}</u>
                                    </template>
                                </div>
                                <div>
                                    
                                <b>申込条件：</b>
                                <template  v-if="sub_list[s].nittei_sentaku == 0">
                                     {{sub_list[s].nissu_mongon}}
                                </template>
                                <template v-else>
                                    各日程ごとの全対象日に参加が必要
                                </template>
                                </div>
                            </div>
                            
                            <template v-if="sub_list[s].nittei_sentaku == 0">
                                            
                                <template v-if="moushikomi_list_sub[s].length == 0">
                                    <b>選択できる日程がありません。</b>
                                </template>
                                <template v-else>
                                    <!--
                                    <div id="tab" style="display: flex;justify-content: space-between;" v-if="sub_disp_nittei_list[s].length > 1">
                                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                                        <template v-for="(result,i3) in sub_disp_nittei_list[s]" v-bind:key="i3">
                                            <template v-if="NitteiActive == i3">
                                            <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                                            </template>
                                            <template v-else>
                                            <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group}}</li>
                                            </template>
                                        </template>
                                        </ul>
                                    </div>
                                    -->
                                    
                                    <div id="title_area">
                                        <div class="list_column_header list_column_left">開催日</div>
                                        <div class="list_column_header list_column_center">時間帯</div>
                                        <div class="list_column_header list_column_standard">

                                            <span class="sp_only">
                                                残り人数
                                                <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('説明会や他プログラムの参加日は選択できません。')" />
                                            </span>
                                            <span class="pc_only">
                                                残り人数
                                                <span class="balloon_parent ">
                                                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                                                    <span class="balloon-top-right">
                                                        説明会や他プログラムの参加日は選択できません。
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <template v-for="(row,i2) in moushikomi_list_sub[s]" v-bind:key="i2">
                                        <!--
                                    <div class="edit_komoku_area" style="padding-top:10px" v-if="i2 == NitteiActive">
                                    -->
                                    
                                    <div v-for="(result,i) in row" v-bind:key="i" class="vy-search-result-row">
                                        <div id="list_column_area">
                                        <!--一番最初の日付、または前の日と別日の場合-->
                                        <div class="list_column_left" style="border-top:1px solid #000 ;" v-if=" i==0 || moushikomi_list_sub[s][i2][i-1].hyoji_date != result.hyoji_date  ">{{ result.hyoji_date }}({{ result.youbi }})</div> 
                                        
                                        <!--前の日と同じ日の場合-->
                                        <div class="list_column_left" v-else-if=" moushikomi_list_sub[s][i2][i-1].hyoji_date == result.hyoji_date"></div>
                                        
                                        <!--時間帯（v-ifで背景色を変えているが中身は一緒なので変更するときは両方直すこと）-->

                                        <!-- 未ログイン・未ユーザー登録の場合は時間帯の表示のみ -->
                                        <div v-if="mode=='nologin' || mode=='noinfo'" class="list_column_center" >
                                            {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                        </div>

                                        <!--選択済み時間帯の時-->
                                        <div v-else-if="select_date_sub[s][i2].findIndex(({bango}) => bango == i) != -1" style="background-color: #AFA;" class="list_column_center" v-bind:id="['set_id'+s+i2 + i]" v-bind:class="['set_id'+s+i2 + i]">
                                        
                                            <!-- 自分が申し込んでいない日、かつ、「定員がオーバーしていない、または、キャンセル待ち機能利用」の場合はクリック可 -->
                                            <span v-if="(result.teiin > result.ninzu || cancel_setting == 0)  && result.moushikomi_flg == 0">
                                            
                                            <a href="#" v-on:click.prevent.stop="Sub_Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango,s,i2,result.teiin,result.ninzu)" class="vy-search-result-row-a">
                                                
                                                <u>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</u>
                                            </a>
                                            </span>

                                            <!-- それ以外はクリック不可 -->
                                            <span v-else>
                                            {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                            </span>
                                        
                                        </div>

                                        <!--未選択時間帯の時-->
                                        <div v-else class="list_column_center" v-bind:id="['set_id'+s+i2 + i]" v-bind:class="['set_id'+s+i2 + i]">
                                            <!-- 自分が申し込んでいない日、かつ、「定員がオーバーしていない、または、キャンセル待ち機能利用」の場合はクリック可 -->
                                            <span v-if="(result.teiin > result.ninzu  || cancel_setting == 0) && result.moushikomi_flg == 0">
                                            
                                            <a href="#" v-on:click.prevent.stop="Sub_Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango,s,i2,result.teiin,result.ninzu)" class="vy-search-result-row-a">
                                                <u>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</u>
                                            </a>
                                            </span>
                                            <!-- それ以外はクリック不可 -->
                                            <span v-else>
                                            {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                            </span>
                                        </div>
                                        
                                        <!--申込人数-->
                                        <template v-if="sub_list[s].teiin_settei == 0">
                                        <!-- 申込むユーザーが既に他のプログラムでこの日時を申込んでいた場合 -->

                                            <div v-if="result.moushikomi_flg != 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                                申込済
                                                <span v-if="result.moushikomi_flg == 1" >
                                                (体験)
                                                </span>
                                                <span v-else-if="result.moushikomi_flg == 2" >
                                                (事前)
                                                </span>
                                                <span v-else-if="result.moushikomi_flg == 3" >
                                                (事後)
                                                </span>
                                                
                                            </div>
                                            
                                            <div v-else-if="(result.teiin - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                                <template v-if="cancel_setting == 0">
                                                    キャンセル待ち
                                                <template v-if="(result.ninzu - result.teiin ) > 0">
                                                    {{(result.ninzu - result.teiin) }}人
                                                </template>
                                                </template>
                                                <template v-else>
                                                    満員
                                                </template>                
                                            </div>
                                            
                                            <!--定員の扱いが「時間帯ごと」の場合は時間帯ごとに人数を表示-->
                                            <div v-else-if="i==0 || (moushikomi_list_sub[s][i2][i-1].hyoji_date != result.hyoji_date)" class="list_column_standard" style="border-top:1px solid #000;">
                                                
                                                    <template v-if="result.teiin >= 999">定員無し</template>
                                                    <template v-else>あと {{ result.teiin - result.ninzu }}名</template>
                                                
                                            </div>
                                            
                                            <div v-else class="list_column_standard"></div>
                                        </template>
                                        <template v-else>
                                            
                                            <!--1日ごと定員の場合-->
                                            <template v-if="i == 0 || (moushikomi_list_sub[s][i2][i-1].hyoji_date != result.hyoji_date)">
                                                <div v-if="result.moushikomi_flg != 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                                    申込済
                                                    <span v-if="result.moushikomi_flg == 1" >
                                                    (体験)
                                                    </span>
                                                    <span v-else-if="result.moushikomi_flg == 2" >
                                                    (事前)
                                                    </span>
                                                    <span v-else-if="result.moushikomi_flg == 3" >
                                                    (事後)
                                                    </span>
                                                </div>
                                                                
                                                <div v-else-if="(sub_list[s].teiin_oneday - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;border-top:1px solid #000;">
                                                    <template v-if="cancel_setting == 0">
                                                        キャンセル待ち
                                                            
                                                        <template v-if="(result.ninzu - sub_list[s].teiin_oneday) > 0">
                                                            {{(result.ninzu - sub_list[s].teiin_oneday)}}人
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        満員
                                                    </template>                    
                                                </div>
                                                <!--定員の扱いが「時間帯ごと」の場合は時間帯ごとに人数を表示-->
                                                <div v-else-if="i==0 || (moushikomi_list_sub[s][i2][i-1].hyoji_date != result.hyoji_date)" class="list_column_standard" style="border-top:1px solid #000;">
                                                    <template v-if="sub_list[s].teiin_oneday >= 999">定員無し</template>
                                                    <template v-else>あと {{ sub_list[s].teiin_oneday - result.ninzu }}名</template>
                                                </div>
                                                                
                                            </template>
                                            <template v-else>
                                                <div v-if="result.moushikomi_flg != 0" class="list_column_standard" style="background-color: pink;">
                                                
                                                </div>
                                                                
                                                <div v-else-if="(sub_list[s].teiin_oneday - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;">
                                                            
                                                </div>
                                                <div v-else class="list_column_standard">
                                                </div>
                                            </template>
                                        </template>
                                        </div>
                                    </div>
                                    <hr style="margin:0;border: 1px solid #000;">
                                    <!-- </div>-->
                                </template>
                                </template>
                            </template>
                            <template v-else>
                                
                                <template v-if="sub_set_nittei_list[s].length == 0">
                                    <b>申し込める日程がありません。</b>
                                </template>
                                <template v-else>
                                    <div id="title_area">
                                        <div class="list_column_header list_column_left" style="flex: 3 3 0%;">開催日時</div>
                                        <div class="list_column_header list_column_standard" style="flex: 1 1 0%;">残り人数</div>
                                    </div>
                                    <template v-for="(result,i) in sub_set_nittei_list[s]" v-bind:key="i">
                                    <div class="vy-search-result-row" style="display: flex;align-items: center;border: 1px solid #000;">
                                        <!--
                                        <div class="list_column_header list_column_left" style="flex: 1 1 0%;text-align:left;height:50px;">
                                           
                                        </div>
                                        -->
                                        <div class="list_column_header list_column_left" style="flex: 3 3 0%;text-align:left;
                                            height:auto;
                                            border:0;
                                            border-right:1px solid #000;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            flex-direction: column;">
                                        
                                            <template v-if="result.all_sanka_ok == 0">
                                                <div v-if="result.kaisai_start == select_date_sub[s]?.[i]?.[0]?.kaisai_date"
                                                style="background-color: #AFA;width: 100%;height: 100%;display: flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                    cursor: pointer;
                                                    flex-direction: column;
                                                    cursor:pointer" 
                                                v-on:click="Sub_Set_list_click(i,s,1)"
                                                v-bind:id="['set_list'+s+ i]" v-bind:class="['set_list'+s+ i]">
                                                    <u>
                                                        {{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                                    {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                                    
                                                    <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                                    <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                                    <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span>
                                                    </u>
                                                </div>
                                                <div v-else style="width: 100%;height: 100%;display: flex;
                                                align-items: center;
                                                justify-content: center;
                                                cursor: pointer;
                                                flex-direction: column;
                                                cursor:pointer" 
                                                v-on:click="Sub_Set_list_click(i,s,1)"
                                                v-bind:id="['set_list'+s+ i]" v-bind:class="['set_list'+s+ i]">
                                                    
                                                    <u>{{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                                    {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                                    <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                                    <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                                    <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span></u>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div style="width: 100%;height: 100%;display: flex;
                                                align-items: center;
                                                justify-content: center;
                                                cursor: pointer;
                                                flex-direction: column;
                                                cursor:pointer" 
                                                v-bind:id="['set_list'+s+ i]" v-bind:class="['set_list'+s+ i]">
                                                   {{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                                    {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                                    <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                                    <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                                    <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span>
                                                </div>
                                            </template>
                                            
                                        </div>
                                        <template v-if="result.all_sanka_ok == 0">
                                            <template v-if="result.ninzu >= result.teiin">
                                            <div class="list_column_header list_column_standard" style="flex: 1 1 0%;background-color: pink;text-align:left;border:0;">
                                                <template v-if="cancel_setting == 0">
                                                    キャンセル待ち
                                                    
                                                    <template v-if="(result.ninzu - result.teiin  ) > 0">
                                                        {{(result.ninzu - result.teiin) }}人
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    満員
                                                </template>
                                            </div>
                                            </template>
                                            <template v-else>
                                                
                                                <div class="list_column_header list_column_standard" style="flex: 1 1 0%;text-align:left;border:0;">
                                                    <template v-if="result.teiin >= 999">
                                                        定員なし
                                                    </template>
                                                    <template v-else>
                                                        あと{{result.teiin - result.ninzu}} 名
                                                    </template>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <div class="list_column_header list_column_standard" style="flex: 1 1 0%;background-color: pink;text-align:left;border:0;">申込済</div>
                                        </template>
                                    </div>
                                </template>
                            <hr style="margin:0;border: 1px solid #000;">
                            </template>
                            </template>
                        </div>
                        </div>
                    </template>
            </template>

                <!-- カレンダー表示タブの中身 -->
                <div v-else-if="TabActive === 'tab_calendar'" style="margin: 0 auto 10px; ; ">
                    
                    <div style="width: 100%;text-align: left;padding-top: 10px;margin-bottom:10px;display: flex;align-items: center;">
                        <span style="font-size:20px;color:#030ba0"><b>{{ taiken_list.taiken_no_text  }}：{{ taiken_list.name  }}</b></span>
                    </div>
                    <div id="tab" style="display: flex;justify-content: space-between;" v-if="taiken_list.shubetsu == 1 && sub_list.length != 0">
                    <ul id="katsudou_tabMenu" class="edit_tabMenu">
                        <template v-if="KatsudouActive=='main'">
                            <li class="tabblue">活動1</li>
                        </template>
                        <template v-else>
                            <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
                        </template>
                        <template v-for="(result,s) in sub_list" v-bind:key="s">
                            <template v-if="KatsudouActive=='sub'+s">
                            <li class="tabblue" >活動{{s+2}}</li>
                            </template>
                        <template v-else>
                            <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                        </template>
                        </template>
                    </ul>
                    </div>
                    <div class="edit_komoku_area" v-if="KatsudouActive=='main'">
                        <div id="katsudou_area">  
                            <div>
                                <b>活動内容：</b>{{taiken_list.naiyou}}
                            </div>
                            <div class="pc_only">
                                <template v-if="sub_list.length !=0">
                                    
                                    <span style="margin-right:10px"  >
                                        <b>参加の義務：</b><u>{{ hissu_list[taiken_list.hissu_flg]}}</u>
                                    </span>
                                </template>
                                <template v-if="taiken_list.k_name != '' && taiken_list.k_name != null">
                                    
                                <span style="margin-right:10px"  >
                                <b>開催地名：</b>{{taiken_list.k_name}}
                                </span>
                                </template>
                                <template v-if="taiken_list.k_jusyo != '' && taiken_list.k_jusyo != null">
                                    
                                    <span style="margin-right:10px">
                                    <b >施設住所：</b><u style="color:red">{{ taiken_list.k_jusyo}}</u>
                                    </span>
                                </template>
                            </div>
                            <div class="sp_only">
                                <template v-if="sub_list.length !=0">
                                <b>参加の義務：</b><u>{{ hissu_list[taiken_list.hissu_flg]}}</u><br>
                                </template>
                                <template v-if="taiken_list.k_name != '' && taiken_list.k_name != null">
                                <b >開催地名：</b>{{taiken_list.k_name}}<br>
                                </template>
                                <template v-if="taiken_list.k_jusyo != '' && taiken_list.k_jusyo != null">
                                <b >施設住所：</b><u style="color:red">{{ taiken_list.k_jusyo}}</u>
                                </template>
                            </div>
                            <div>
                                <b>申込条件：</b>
                                <template  v-if="taiken_list.nittei_sentaku == 0">
                                {{taiken_list.nissu_mongon}}
                                </template>
                                <template v-else>
                                    各日程ごとの全対象日に参加が必要
                                </template>
                            </div>
                        </div>
                        
                        <!--
                        <div id="tab" style="display: flex;justify-content: space-between;" v-if="disp_nittei_list.length > 1">
                            <ul id="nittei_tabMenu" class="edit_tabMenu">
                            <template v-for="(result,i3) in disp_nittei_list" v-bind:key="i3">
                                <template v-if="NitteiActive == i3">
                                <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                                </template>
                                <template v-else>
                                <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group}}</li>
                                </template>
                            </template>
                            </ul>
                        </div>
                        -->

                        <div id="calendar_area" v-html="Calendar" v-on:click="htmlColumnClick" class="pc_only edit_komoku_area"></div>
                        <div id="calendar_area" v-html="CalendarSp" v-on:click="htmlColumnClickSp" class="sp_only edit_komoku_area"></div>
                    </div>
                
                    <div class="edit_komoku_area" v-else>
                        
                         <div id="katsudou_area">  
                    <div>
                      <b>活動内容：</b>{{sub_list[KatsudouActive_no].naiyou}}
                    </div>
                    <div>
                      <template v-if="sub_list.length !=0">
                        <span style="margin-right:10px">
                        <b>参加の義務：</b><u>{{ hissu_list[sub_list[KatsudouActive_no].hissu_flg ]}} </u>
                        </span><br>
                      </template>
                      <template v-if="sub_list[KatsudouActive_no].k_name != '' && sub_list[KatsudouActive_no].k_name != null">
                        <span style="margin-right:10px">
                        <b >開催地名：</b>
                        {{sub_list[KatsudouActive_no].k_name}}
                        </span><br>
                      </template>
                      <template v-if="sub_list[KatsudouActive_no].k_jusyo != '' && sub_list[KatsudouActive_no].k_jusyo != null">
                        <b >施設住所：</b><u style="color:red">{{ sub_list[KatsudouActive_no].k_jusyo}}</u><br>
                      </template>
                    </div>
                    
                    <div>
                     <b>申込条件：</b>
                     <template  v-if="sub_list[KatsudouActive_no].nittei_sentaku == 0">
                     {{sub_list[KatsudouActive_no].nissu_mongon}}
                     </template>
                        <template v-else>
                        各日程ごとの全対象日に参加が必要
                     </template>
                    </div>
                  </div>
                  <!--
                  <div id="tab" style="display: flex;justify-content: space-between;" >
                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                          <template v-for="(result,i3) in sub_disp_nittei_list[KatsudouActive_no]" v-bind:key="i3">
                            <template v-if="NitteiActive == i3">
                              <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                            </template>
                            <template v-else>
                              <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group}}</li>
                            </template>
                          </template>
                        </ul>
                      </div>
                      -->
                        <div id="calendar_area" v-html="Calendar_sub" v-on:click="sub_htmlColumnClick" class="pc_only edit_komoku_area"></div>
                        <div id="calendar_area" v-html="CalendarSp_sub" v-on:click="sub_htmlColumnClickSp" class="sp_only edit_komoku_area"></div>
                    </div>

                </div>
            </div>
        </div>
        <!-- ボタン（PCのみ） -->
        <div class="pc_only" style="text-align:center;padding:6px;width:100%">
            <!-- 体験OKフラグが立ってないと表示できない-->
            <template v-if="taiken_ok == 1">
             <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right: 10px;"  v-on:click="moushikomi_set()" v-if="shakyo_moushikomi_flg == true && seisaku_moushikomi_flg == true && joken_moushikomi_flg == true">申込み</button>
            </template>
          <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;"  v-on:click="ichiran()">戻る</button>
        </div>
      </div>
          
    
        <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
    <div class="vy-responsive-menu-container floating_over" style="
        margin-bottom: 50px;
        padding: 10px 0;
        background: rgba(0, 0, 0, .5);
        border: 0px;
        justify-content: space-evenly;">
        <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;margin-right:10px;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="ichiran()">一覧に戻る</button>
            
        <!-- 体験OKフラグが立ってないと表示できない-->
        <template v-if="taiken_ok == 1">
            <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0" v-on:click="moushikomi_set()" v-if="shakyo_moushikomi_flg == true && seisaku_moushikomi_flg == true && joken_moushikomi_flg == true">申込み</button>
        </template>
    </div>

      <!-- スマホ用・カレンダー日時を表示するモーダルウィンドウ-->
      <component v-if="smart_calendar_area"
               v-bind:is="contentCalendar"
               v-bind:param="paramCalendar"
               v-on:call="call"></component>

      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>
</template>

<script setup>
/* eslint-disable */

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

/* スマホ用・カレンダーで選択した日付の時間帯を表示するモーダルウィンドウ */
import UserCalendarSmart from './UserCalendarSmart.vue'  

const contentCalendar = ref('')// 表示する子コンポーネントの情報（カレンダー日時エリア）
contentCalendar.value = null // 表示する子コンポーネント
let paramCalendar = {}//子コンポーネントに送る値の連想配列
let smart_calendar_area = ref(false)//表示・非表示フラグ


import { useRouter,useRoute } from 'vue-router'
import { GlobalData, DateSetting,TimeSetting,DateTimeSetting,youbi_irekae,ShimekiriSetting  } from '../js/userdata.js'
import AWS from 'aws-sdk';
import axios from 'axios'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()
const props = defineProps(['param'])

// 参加条件（学生区分）の利用可不可と名称
let gakusei_kbn_list = ref(props.param.gakusei_kbn_list)
let gakusei_meisho_list = ref(props.param.gakusei_meisho_list)

const taiken_list = ref(props.param.shosai)
//const jisseki = props.param.jisseki // 体験プログラムに申込まれている実績（活動１のみ）
const jisseki_all = props.param.jisseki_all // 体験プログラムに申込まれている実績（活動１と活動２以降すべて）
const jisseki_all_user = props.param.jisseki_all_user // 体験プログラムに申込んだユーザー数（活動１と活動２以降すべて）
const myjisseki = props.param.myjisseki  // ユーザーが申込んだ実績
const cityname = props.param.cityname

let sub_list = ref(taiken_list.value.sub_list) // 他の活動条件

  let nittei_list = ref([]) // 日程全てのリスト
  let disp_nittei_list = ref([]) // 日程選択方法が「時間帯ごと」の場合の日程リスト
  let set_nittei_list = ref([]) // 日程選択方法が「1日ごと」の場合の日程リスト

  let sub_nittei_list = ref([]) // サブプログラムの日程全てのリスト
  let sub_disp_nittei_list = ref([]) // サブプログラムの日程選択方法が「時間帯ごと」の場合の日程リスト
  let sub_set_nittei_list = ref([]) // サブプログラムの日程選択方法が「1日ごと」の場合の日程リスト

let holidays_list = []


// ユーザーが本来所属する社協の名前
let shozoku_name = ref(props.param.shozoku_name)

// アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし、3：未確認）
const enqete_ok = ref(GlobalData.enqete_flg)


// ？マークをタップしたときのウィンドウ（スマホのみ）
let q_open = function(text){
    message.value = text
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "q_open";
    contentMessage.value = MessageModal

}

// キャンセルに関する情報
let cancel_count = 0 // 申込キャンセル可能回数 0はキャンセル不可
let cancel_day = 1 // 申込キャンセル可能日数
let cancel_setting = 0 // キャンセル待ち機能 0：利用する、1：しない

  // 詳細表示フラグ、文字色、太さ
  // 分類1（表示は固定） 0
  // 分類2 1
  // プログラム名（表示は固定） 2
  // 活動内容 3
  // 施設住所 4
  // 活動日数 5
  // 受入先からのコメント 6
  // 添付資料 7
  // その他（特記事項） 8
  // 参加費 9 ---- 施設・地域のみ
  // 検温等 10
  // マスク着用 11
  // 昼食 12
  // 持ち物 13
  // 制作・寄付活動条件 14 ---- 制作・寄付のみ
  // 届け先 15 ---- 制作・寄付のみ
  // 申込〆切日数 16 ---- 施設・地域のみ
  // 検便 17 ---- 施設・地域のみ
  // 開催地名 18
  // 連絡先 19
  // アクセス方法 20
  // 服装 21
  // 日程、開催期間 22 ---- 色・太さの関係で追加（表示は固定）
  // 申込〆切日時 23 ---- 色・太さの関係で追加（表示は固定）
  // 参加条件 24 ---- 色・太さの関係で追加（表示は固定）
  // 全体の定員 25 ---- 色・太さの関係で追加（表示は固定）
  // 一日の定員 26 ---- 施設・地域のみ 色・太さの関係で追加（表示は固定）
  // 参加の義務 27 ---- 施設・地域のみ 色・太さの関係で追加（表示は固定）
  let shosai_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
  let shosai_color = ref(['black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black'])
  let shosai_bold = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])

// 事前説明会（全件）取得
let all_jizen_list = props.param.jizen

// 実際に表示する事前説明会
let jizen = []
let jizen_count = 0

// このプログラムの事前説明会No.を格納する配列
let taiken_jizen_no = [];
  
// 体験プログラムの割付事前説明会No.を取り出す
if(taiken_list.value.jizenkensyu_no != "" && taiken_list.value.jizenkensyu_no != null){
  taiken_jizen_no = taiken_list.value.jizenkensyu_no.split(',')
}



for(let i = 0;i < all_jizen_list.length;i++){

    let ok_flg = 0
    // 体験プログラムに設定された事前説明会No.と同じ説明会があれば追加（Okフラグを立てる）
    for(let t = 0;t<taiken_jizen_no.length;t++){
      if(taiken_jizen_no[t] == all_jizen_list[i]["jizen_no"]){
        ok_flg = 1
      }
    }

    // Okフラグが立っている場合でも、参加済の実績である場合、追加しない（OKフラグを下げる）
    if(ok_flg == 1){

            for(let j = 0;j<myjisseki.length;j++){
                let jisseki_kobetsu = myjisseki[j]
                // 実績にプログラム区分２（事前説明会）がある場合
                if(jisseki_kobetsu["program_kbn"] == 2){
                    if(jisseki_kobetsu["jokyo"] == '2'){
                        if(all_jizen_list[i]["jizen_id"] == jisseki_kobetsu["program_id"]){
                            ok_flg = 0
                        }
                    }
                }
            }
    }

    if(ok_flg == 0){
      continue
    }

    jizen[jizen_count] = all_jizen_list[i];
    jizen_count++
}

// 事後集会（全件）取得
let all_jigo_list = props.param.jigo

// 実際に表示する事前説明会
let jigo = []
let jigo_count = 0

// このプログラムの事後集会No.を格納する配列
let taiken_jigo_no = [];
  
// 体験プログラムの割付事後集会No.を取り出す
if(taiken_list.value.jigosyukai_no != "" && taiken_list.value.jigosyukai_no != null){
    taiken_jigo_no = taiken_list.value.jigosyukai_no.split(',')
}

for(let i = 0;i < all_jigo_list.length;i++){
    
    let ok_flg = 0
    for(let t = 0;t<taiken_jigo_no.length;t++){
      if(taiken_jigo_no[t] == all_jigo_list[i]["jigo_no"]){
        ok_flg = 1
      }
    }

    if(ok_flg == 0){
      continue
    }

    jigo[jigo_count] = all_jigo_list[i];
    jigo_count++

}



// 体験申込までの流れ（フロー）
// １：体験申込時に事前説明会も申込む
// ２：事前説明会の参加が確認できないと体験プログラムに申込めない
const taiken_flow = props.param.taiken_flow
let taiken_ok = 0;// 0:申込不可、1:申込可
let jizen_ok = 0 // 0:事前説明会申込なし、1:事前説明会申込済み


// アンケート未回答の場合は申込不可
if(enqete_ok.value == 0){
    /*
    // 事前説明会が割り付けられていないときはフローに関わらずOK
    else if(taiken_jizen_no == '' || taiken_jizen_no == [] || taiken_jizen_no == null){
        taiken_ok = 1
    }
    */
}else{
    // フローが1の時
    if(taiken_flow == 1){
        for(let j = 0;j<myjisseki.length;j++){
            let jisseki_kobetsu = myjisseki[j]
            // 実績にプログラム区分２（事前説明会）がある場合
            if(jisseki_kobetsu["program_kbn"] == 2){
                // その実績が参加済である場合
                if(jisseki_kobetsu["jokyo"] == '2'){
                    taiken_ok = 1
                    jizen_ok = 1
                }else if(jisseki_kobetsu["jokyo"] == '1'){
                    // その実績が未参加である場合
                    jizen_ok = 1
                }
                /*
                for(let t = 0;t<taiken_jizen_no.length;t++){
                    // その実績の事前説明会No.が、プログラムに紐づいているものである場合
                    if(jisseki_kobetsu["jizen_no"] == taiken_jizen_no[t]){
                        // その実績が参加済である場合
                        if(jisseki_kobetsu["jokyo"] == '2'){
                            taiken_ok = 1
                        }
                    }
                }*/
            }
        }
    }else{
        // フローが2の時
        taiken_ok = 1
    }
}


const emit = defineEmits(['call'])
const mode = ref("dsp")
const error_message = ref("")


// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]

  // プログラムの種別配列
  const shubetsu_list = ["（未設定）","施設・地域活動","制作・寄付活動"]
  
  // 参加の義務の配列
  const hissu_list = ["任意","必須","条件付き"]

  // 定員の扱いの配列
  const teiin_list = ["時間帯ごと","1日ごと"]

  // 日程選択方法の配列
  const nittei_sentaku_list = ["参加日ごと","日程ごと"]

let TabActive = ref("tab_detail") // どのタブを選択しているか tab_list：日程一覧、tab_calendar：カレンダー、tab_detail：詳細

// 現在開いているタブ（活動内容）
let KatsudouActive = ref("main")
let KatsudouActive_no = ref(9999)

// 現在開いているタブ（日程）
let NitteiActive = ref(0)


// 詳細部分の背景色を切り替えるためのクラス
let contents_color = ref("contentswhite")

// タブ部分の背景色を切り替えるためのクラス
let list_color = ref("tabgray")
let calendar_color = ref("tabgray")
let detail_color = ref("tabblue")

let user_taiken_jyokyo = [] //ユーザーの体験プログラム申込み状況（ログイン中かつユーザー登録済みの場合に利用）
let user_ok_jyokyo = [] //ユーザーの体験プログラム申込み状況のうち、キャンセルを除いたもの（ログイン中かつユーザー登録済みの場合に利用）
let ok_user_count = ref(0) // キャンセルを除いた申込済みユーザーの数
if(jisseki_all_user){
    for(let j = 0;j<jisseki_all_user.length;j++){
        console.log(j+"/"+jisseki_all_user[j].length)
        ok_user_count.value += jisseki_all_user[j].length
    }
}

// 申込める全ての日時を保存するリスト
let moushikomi_list = ref([]) // メイン（活動１の日程配列のみ）
let moushikomi_list_sub = ref([]) // サブ（配列の中に、さらに配列を複数個持つ）

// 表示するカレンダー（htmlタグをそのまま記述）
let Calendar = ref("")
let CalendarSp = ref("")

let Calendar_sub = ref("")
let CalendarSp_sub = ref("")

// 選択した日時（活動１）
let select_date = ref([])

// 選択した日時（活動２～）
let select_date_sub = ref([])
for(let s = 0;s<sub_list.value.length;s++){
    select_date_sub.value[select_date_sub.value.length] = []
}

// 今日の日付
let today = new Date()

// ユーザー情報と参加条件から参加可能かどうかチェック
function isUserEligible(startText,endText) {

/*

    const KUBUN_ORDER = ['小', '中', '高', '大', '一般'];
    "小", "中","高", "高専", "専", "大", "院", "一般"
*/

console.log(startText)
console.log(endText)

  // user = {
  //   shokugyo_kbn,
  //   gakusei_kbn,
  //   gakunen
  // }
  const KUBUN_TO_GAKUSEI = {
    "小": 0,
    "中": 1,
    "高": 2,
    "高専":3,
    "専":4,
    "大": 5,
    "院":6,
    "一般":7
    };

    const KUBUN_ORDER = Object.keys(KUBUN_TO_GAKUSEI)
console.log(KUBUN_ORDER)
    if(!startText) return true

  const parse = (text) => {
    const [kubun, gradeStr] = text.split(':');
    return { kubun, grade: Number(gradeStr) };
  };

  const start = parse(startText);
  const end = parse(endText);
  // ===== 一般ユーザー =====
  console.log(GlobalData)
  if (parseInt(GlobalData.shokugyo_kbn) === 1) {
    // 条件に「一般」が含まれていないならここで終了
    if(!(start.kubun === '一般' || end.kubun === '一般')){
        return false;
    }else{
        return true
    }
  }else{

    // ===== 学生ユーザー =====
    // 条件が一般のみ
    if (start.kubun === '一般' && end.kubun === '一般') {
        return false; // 参加不可
    }

    const startIdx = KUBUN_ORDER.indexOf(start.kubun);
    const endIdx = KUBUN_ORDER.indexOf(end.kubun);

    // 学生区分が条件の範囲外
    const userKubunIdx = KUBUN_ORDER.indexOf(
        Object.keys(KUBUN_TO_GAKUSEI).find(
        k => KUBUN_TO_GAKUSEI[k] === GlobalData.gakusei_kbn
        )
    );

    console.log(startIdx +"<"+ userKubunIdx + "<" + endIdx )

    if (userKubunIdx < startIdx || userKubunIdx > endIdx) {
        return false;
    }

    // 学年チェック（開始区分）
    if (userKubunIdx === startIdx && start.grade > 0) {
        if (GlobalData.gakunen < start.grade) {
        return false;
        }
    }

    // 学年チェック（終了区分）
    if (userKubunIdx === endIdx && end.grade > 0) {
        if (GlobalData.gakunen > end.grade) {
        return false;
        }
    }

    return true; // 参加可能
  }
}

// 社協の申込日の関係で申込めるかどうかの判断
let shakyo_moushikomi_flg = ref()
let moushikomi_message = ref("")

// 制作・寄付の場合、定員オーバーだったら申込めない
let seisaku_moushikomi_flg = ref()

// 受付〆切日を事業単位(1)で見るか、プログラム単位(2)で見るか
let end_shubetsu = ref(1)

// 受付〆切日（事業単位）
let end_datetime = ref(new Date(today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+" 23:59:59"))

// 申込み可能回数を利用するかどうか（1:する、2:しない）
let program_shubetsu = ref(2)

// 申込み可能回数
let program_count = ref(5)


// 総申込者数に関する情報
let all_moshikomi_flg = ref(0) // 総申込者数を利用するかどうか　1：利用する、2：しない
let all_moshikomi_count = ref(1000) // 総申込者数の上限
let now_moshikomi_count = ref(0) // 現在の総申込者数

let jizen_jisshi = ref(0)
let jigo_jisshi = ref(0)

//---------------- 社協英名から申込開始日を取得し、申込んでいいかどうかをチェック
let shakyo_error = 0
let shakyo_read = function(){
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {
        let Shakyo_data =  response["data"]

        jizen_jisshi.value = Shakyo_data.jizen_jisshi
        jigo_jisshi.value = Shakyo_data.jigo_jisshi
        
        /*
        // キャンセルに関する情報
        let cancel_count = 0 // 申込キャンセル可能回数 0はキャンセル不可
        let cancel_day = 1 // 申込キャンセル可能日数
        let cancel_setting = 0 // キャンセル待ち機能 0：利用する、1：しない
        */
        cancel_count = Shakyo_data.cancel_count
        cancel_day = Shakyo_data.cancel_day
        cancel_setting = Shakyo_data.cancel_setting

        shosai_disp.value = Shakyo_data.program_shosai_disp.split(',')
        shosai_color.value = Shakyo_data.program_shosai_color.split(',')
        shosai_bold.value = Shakyo_data.program_shosai_bold.split(',')

        if(Shakyo_data.moushikomi_start == ""){
                Shakyo_data.moushikomi_start = "00:00:00"
        }
        let moushikomi_date = new Date(Shakyo_data.moshikomi_date+" "+Shakyo_data.moshikomi_start)
        let today = new Date()

        moushikomi_date = moushikomi_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        moushikomi_date = new Date(moushikomi_date);
        moushikomi_date.setHours(moushikomi_date.getHours());

        if (moushikomi_date < today) {
            shakyo_moushikomi_flg.value = true;
            
            // 社協の申込み可不可を確認した後、制作・寄付の場合は定員も確認する
            if(taiken_list.value.shubetsu == 2){
                // 定員オーバーの場合は申込不可
                if(taiken_list.value.seisaku_teiin <= jisseki_all[0].length){
                    seisaku_moushikomi_flg.value = false;
                }else{
                    seisaku_moushikomi_flg.value = true;
                }
            }else{
                seisaku_moushikomi_flg.value = true;
            }

        } else {
            shakyo_moushikomi_flg.value = false;
            moushikomi_message.value = "申込開始日まで今しばらくお待ちください。"
        }
        
            // 受付〆切日の種別を取得
            end_shubetsu.value = response["data"].end_shubetsu

            // 受付〆切日の確認
            if(response["data"].end_date){
              let set_time = " 23:59:59"
              if(response["data"].end_time) {
                set_time = response["data"].end_time
              }
              let end_date = new Date(response["data"].end_date + " "+set_time)
              end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              end_date = new Date(end_date);
              end_date.setHours(end_date.getHours());
              end_datetime.value = end_date
            }

            // 申込み可能回数の確認
            if(response["data"].program_shubetsu == 1){
              program_shubetsu.value = response["data"].program_shubetsu
              program_count.value = response["data"].program_count

            }
            /*
            // ユーザー登録後アンケートの実施状況確認
            if(response["data"].enqete_shubetsu == 1){
              setTimeout(function(){Form_answer_check()},"1000")
            }else{
              enqete_ok.value = 2
            }*/

           
            // 総申込者数を利用する場合
            if(response["data"].all_moshikomi_flg == 1){
                all_moshikomi_count.value = response["data"].all_moshikomi_count
                all_moshikomi_flg.value = response["data"].all_moshikomi_flg
            }

            // 満員・〆切日の確認と申込ボタンの表示処理へ
            setTimeout(function(){
                over_check()
                LeftBar_moshkomi_ok()
            },"1000")


    })
    .catch(error => {
            if(shakyo_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "shakyo_error";
                contentMessage.value = MessageModal
            }else{
                shakyo_error++
                setTimeout(function(){
                  shakyo_read()
                },"1000")
            }
        
    })
}

// 総申込者数を取得する
    let count_read_error = 0
    let moshikomi_count_read = function() { 
        let set_url = GlobalData.$API_URL + "Taikenuser_moshikomi_count"
        axios.post(set_url,
        {choson_code:route.params.shakyo})  //市区町村コードを指定
        .then(response => {

          now_moshikomi_count.value = response.data.count
          
          console.log(all_moshikomi_flg.value)
          console.log(user_ok_jyokyo)
          console.log(all_moshikomi_count.value+"/"+now_moshikomi_count.value)

            // 体験者が申し込んでいない場合
            if(user_ok_jyokyo.length == 0){
              // 総申込者数が現在の申込者数以下の場合は申込不可
              if(all_moshikomi_count.value <= now_moshikomi_count.value){
                message.value = "この社協における総申込者数を超過しました。\nこれ以上、お申込みはできません。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "all_moshikomi_error";
                contentMessage.value = MessageModal
              }
            }
        })
        .catch(error => {
            if(count_read_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                count_read_error++
                setTimeout(function(){moshikomi_count_read()},"1000")
            }
        })
    }

    nittei_list.value = taiken_list.value.nittei

    // 同じグループの日程レコードをセットにするためのカウント
    let nittei_set_no = 0

    let before_nittei = []

    // 日程データの各曜日テキストを配列に直す
    for(let n = 0;n<nittei_list.value.length;n++){
        nittei_list.value[n]["kaisai_array"] = []
      if(nittei_list.value[n].kaisai_youbi != null && nittei_list.value[n].kaisai_youbi != ""){
        
        nittei_list.value[n].kaisai_youbi = nittei_list.value[n].kaisai_youbi.replace(/､/g, '、')
        nittei_list.value[n]["kaisai_array"] = nittei_list.value[n].kaisai_youbi.split("、")
      }

      nittei_list.value[n]["jogai_array"] = []
      if(nittei_list.value[n].jogai != null && nittei_list.value[n].jogai != ""){
        nittei_list.value[n].jogai = nittei_list.value[n].jogai.replace(/､/g, '、')
        nittei_list.value[n]["jogai_array"] = nittei_list.value[n].jogai.split("、")
      }


      // グループが前の日程と別の場合は現在のセットNo.を加算して区別する
      if(nittei_list.value[n]["nittei_group"] != before_nittei["nittei_group"]){
        nittei_set_no = nittei_set_no + 1
      }

      // 日程レコードに日程セットNo.を格納
      nittei_list.value[n]["nittei_set_no"] = nittei_set_no

      // 今の日程を格納
      before_nittei = nittei_list.value[n]
    }

    
    sub_nittei_list.value = taiken_list.value.sub_nittei
    console.log("sub_nittei_list"+JSON.stringify(sub_nittei_list.value))

    // サブプログラムの数だけ日程データがある
    let sub_setting_list = [] // プログラム毎の日程（配列）
    for(let s = 0;s<sub_nittei_list.value.length;s++){

      moushikomi_list_sub.value[s] = []

      let program_nittei = [] // プログラムごとの日程を格納

      // サブの、時間帯以外が同じ日程レコードをセットにするためのカウント
      let nittei_set_no = 0
      let before_nittei = []

      // 日程データの各曜日テキストを配列に直す
      for(let n = 0;n<sub_nittei_list.value[s].length;n++){
        sub_nittei_list.value[s][n]["kaisai_array"] = []
        if(sub_nittei_list.value[s][n].kaisai_youbi != null && sub_nittei_list.value[s][n].kaisai_youbi != ""){
          
          sub_nittei_list.value[s][n].kaisai_youbi = sub_nittei_list.value[s][n].kaisai_youbi.replace(/､/g, '、')
          sub_nittei_list.value[s][n]["kaisai_array"] = sub_nittei_list.value[s][n].kaisai_youbi.split("、")
        }

        sub_nittei_list.value[s][n]["jogai_array"] = []
        if(sub_nittei_list.value[s][n].jogai != null && sub_nittei_list.value[s][n].jogai != ""){
          sub_nittei_list.value[s][n].jogai = sub_nittei_list.value[s][n].jogai.replace(/､/g, '、')
          sub_nittei_list.value[s][n]["jogai_array"] = sub_nittei_list.value[s][n].jogai.split("、")
        }

        // グループが前の日程と別の場合は現在のセットNo.を加算して区別する
        if(sub_nittei_list.value[s][n]["nittei_group"] != before_nittei["nittei_group"]){
          nittei_set_no = nittei_set_no + 1
        }

        // 日程レコードに日程セットNo.を格納
        sub_nittei_list.value[s][n]["nittei_set_no"] = nittei_set_no

        // 今の日程を格納
        before_nittei = sub_nittei_list.value[s][n]
        program_nittei[program_nittei.length] = before_nittei
      }
    }

// 日程からコメントを抽出
let nittei_comment = ""
for(let n = 0;n<nittei_list.value.length;n++){
    let nittei_kobetsu = nittei_list.value[n]
    if(nittei_comment != "") nittei_comment += "、"
    if(nittei_kobetsu.comment != "" && nittei_kobetsu.comment != null){
        nittei_comment += nittei_kobetsu.comment
    }
}
 
  // 指定した活動のタブを表示する
  let Change_katsudou = function(program_num){
    // 日程タブは１に戻す
    NitteiActive.value = 0

    if(program_num == 9999){
      KatsudouActive.value = "main"
    }else{
      KatsudouActive.value = "sub"+program_num
    }

    KatsudouActive_no.value = program_num
    Calendar_set()
    Sub_Calendar_set(program_num)
  }

  // 日程タブ切り替え
  let Change_nittei = function(num){
    NitteiActive.value = num
    Calendar_set()
    Sub_Calendar_set(KatsudouActive_no.value)
  }

  
  // 指定した活動に移動する（詳細）
  let link_katsudou_shosai = function(program_num,tanmatsu){
    
    let id = "katsudou_shosai" + program_num
    if(tanmatsu == "sp"){
        id = id + "_sp"
    }
    Page_id_focus(id)
  }
  
  // 指定した活動に移動する（日程一覧）
  let link_katsudou_nittei = function(program_num,tanmatsu){
    let id = "katsudou_nittei" + program_num
    if(tanmatsu == "sp"){
        id = id + "_sp"
    }
    Page_id_focus(id)
  }

  // 指定した活動の日程に移動する（日程一覧）
  let link_katsudou_nittei_nittei = function(program_num,nittei_num,tanmatsu){
    let id = "katsudou_nittei"+program_num+"_nittei"  + nittei_num
    if(tanmatsu == "sp"){
        id = id + "_sp"
    }
    Page_id_focus(id)
  }
  // 指定した活動に移動する（カレンダー）
  let link_katsudou_cal = function(program_num,tanmatsu){
    let id = "katsudou_cal" + program_num
    if(tanmatsu == "sp"){
        id = id + "_sp"
    }
    Page_id_focus(id)
  }
  // 指定した活動の日程に移動する（カレンダー）
  let link_katsudou_cal_nittei = function(program_num,nittei_num,tanmatsu){
    let id = "katsudou_cal"+program_num+"_nittei"  + nittei_num
    if(tanmatsu == "sp"){
        id = id + "_sp"
    }
    Page_id_focus(id)
  }

    // カレンダーで表示する月を算出するための変数（活動１）
    let calendar_hyoji_date = []
    let calendar_year = []
    let calendar_month = []
    let holiday_year_month = []
    let kaisai_start = []
    let kaisai_end = []

    // カレンダーで表示する月を算出するための変数（活動２～）
    let sub_calendar_hyoji_date = []
    let sub_calendar_year = []
    let sub_calendar_month = []
    let sub_holiday_year_month = []
    let sub_kaisai_start = []
    let sub_kaisai_end = []

  // タブをクリックしたときの処理
  let TabSelect = function(id){

    let email = GlobalData.$User_email
    let user_id = GlobalData.user_id
    //seltbl.length = 0
    //alert("user_id:"+user_id)
    if (email) {                    // ログインしているかチェック
        if (user_id) {              // ユーザー情報があるかチェック
            mode.value = "sel"
        } else {
            mode.value = "noinfo"   // ユーザー情報を登録していない場合
        }
    } else {
        mode.value = "nologin"        // ログインしていない場合
    }
    // 選択したタブに切り替える（タブ側ではv-ifで表示・非表示を制御）
    TabActive.value = id
    
    // いったんコンテンツの背景を白にする（事前にcontentswhiteクラスを用意）
    contents_color.value = "contentswhite"

    // いったんすべてのタブの背景を灰色にする（事前にtabgrayクラスを用意）
    calendar_color.value = "tabgray"
    detail_color.value = "tabgray"
    list_color.value = "tabgray"

    // アクティブになるタブを青に変更（事前にtabblueクラスを用意）
    if(id == 'tab_list'){
        // 日程一覧を表示
        list_color.value = "tabblue"

        // ログイン・ユーザー登録が済んでいない場合
        // または体験フローが1で事前説明会が申込まれていない場合
        if(mode.value != "sel"|| taiken_ok == 0){
            contents_color.value = "contentsred"
        }
    }else if(id == 'tab_calendar'){
        // カレンダーを表示
        calendar_color.value = "tabblue"
        Calendar_set()
        Sub_Calendar_set(KatsudouActive_no.value)

        // ログイン・ユーザー登録が済んでいない場合
        // または体験フローが1で事前説明会が申込まれていない場合
        if(mode.value != "sel"|| taiken_ok == 0){
            contents_color.value = "contentsred"
        }
    }else if(id == 'tab_detail'){
        // 詳細を表示
        detail_color.value = "tabblue"
        
        // 種別が2かつログイン・ユーザー登録が済んでいない場合
        // または体験フローが1で事前説明会が申込まれていない場合
        if((taiken_list.value.shubetsu == 2 && mode.value != "sel") || taiken_ok == 0){
            contents_color.value = "contentsred"
        }
    }
  }
  
let douitsu_flg = ref(0) // 同じ日に複数日程を持つ日付が1つでもある場合はこのフラグを立てる
  // 申込める日時を配列として作成する
  let nittei_set = function(){

    set_nittei_list.value = []
    let today = new Date()
    today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    today = new Date(today)
    today.setHours(0, 0, 0, 0);//0時0分0秒に設定

    douitsu_flg.value = 0
    
    // 申込める日時のカウント
    let moushikomi_count = 0

    let nittei_list_count = 0
    
    // 日程グループを格納
    let before_set_no = 0

    moushikomi_list.value = []

    if(taiken_list.value.nittei_sentaku == 0){

    // 日程レコードから申込める日時を作成する
    nittei_list.value.forEach(function(nittei) {
        let all_sanka_ok = 0 // 日程のすべての日付にに参加可能かどうか
        if(!moushikomi_list.value[0]){
          moushikomi_list.value[0] = []
        }
        
        /*
        // 日程グループが変わったら申込カウントをリセット
        if(before_set_no != nittei["nittei_set_no"]){
          moushikomi_count = 0
        }

        before_set_no = nittei["nittei_set_no"]*/
        

      // 開催日（自・至）から日数を求める
        let start_date = new Date(nittei["kaisai_start"]);

        if(!calendar_hyoji_date[0]){
            calendar_hyoji_date[0] = []
            calendar_hyoji_date[0] = new Date(start_date)
            calendar_year[0] = []
            calendar_year[0] = calendar_hyoji_date[0].getFullYear()
            calendar_month[0] = []
            calendar_month[0] = calendar_hyoji_date[0].getMonth() + 1  
            holiday_year_month[0] = []
            holiday_year_month[0] = calendar_year[0]+"-"+calendar_month[0]+"-01"
            
            let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日

            // 開催日（至）がnullの場合は、その月の最後までを対象とする
            if(kaisai_end[0] == null){
              let nissu = mondate[calendar_month-1];
                  if(calendar_month[0]  == 2){
                    if(calendar_year[0] %4 == 0){
                      if(calendar_year[0] %100 == 0){
                        if(calendar_year[0] %400 == 0){
                          nissu = 29;
                        }
                      }else{
                        nissu = 29;
                          
                      }
                    }
                  }
              kaisai_end[0]  = calendar_year[0] +"-"+calendar_month[0] +"-"+nissu
            }
            
          }
      let set_kaisai_end = nittei["kaisai_end"] 

      // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
      if(nittei["kaisai_end"] == null){
        set_kaisai_end = kaisai_end
      }
      const end_date = new Date(set_kaisai_end);
      // 差日を求めた上で＋1することで日数になる
      const termDay = ((end_date - start_date) / 86400000) + 1;

      // 申込める時間帯を取得
      const jikantai_start = nittei["jikantai_start"]
      const jikantai_end = nittei["jikantai_end"]

      // この日程の各日の定員を取得
      let teiin = nittei["teiin"]
      // 定員の扱いが1日ごとの場合は1日ごとの定員を格納
      if(taiken_list.value.teiin_settei == 1){
        teiin = taiken_list.value.teiin_oneday
      }

      // 開催曜日を取得
      let kaisai_list = []
      if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
        nittei["kaisai_youbi"] = nittei["kaisai_youbi"].replace(/､/g, '、')
        kaisai_list = nittei["kaisai_youbi"].split("、")
      }
      // 除外曜日を取得
      let jogai_list = []
      if(nittei["jogai"] != "" && nittei["jogai"] != null){
        nittei["jogai"] = nittei["jogai"].replace(/､/g, '、')
        jogai_list = nittei["jogai"].split("、")
      }
      
      // 除外日を取得
      let jogai_date = []
      if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
        jogai_date = nittei["jogai_date"].split("、")
      }

      let nittei_group = nittei["nittei_group"] 
      for(let i = 0;i < termDay;i++){
        let date = new Date();
        if(i != 0) {
          date = start_date.setDate(start_date.getDate() + 1);
        }else{
          date = start_date.setDate(start_date.getDate());
        }
        let set_date = new Date(date)

        let set_year = set_date.getFullYear()
        let set_month = set_date.getMonth() + 1
        let set_day = set_date.getDate()
        let set_youbi = set_date.getDay()

        let moushikomibi = set_year+"/"+set_month+"/"+set_day
        let jogai_day = set_month+"/"+set_day
        
        
        // 開催曜日の指定がある場合
        if(kaisai_list.length != 0){
            
          // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
          if(kaisai_list.includes(youbi_list[set_youbi])) {

          }else{

            // 開催曜日に祝日がある場合
            if(kaisai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日でなければスルー
              if(!holidays_list.includes(moushikomibi)) continue
              
            }else{
                continue
            }
          }
        }

        // 除外曜日の指定がある場合
        if(jogai_list.length != 0){
          // 除外曜日に指定した曜日に該当する日の場合
          // 飛ばして次へ
          if(jogai_list.includes(youbi_list[set_youbi])) continue

          // 除外曜日に祝日がある場合
          if(jogai_list.includes("祝")){
            // 日付が祝日かどうかを確認
            // 祝日であれば飛ばして次へ
            if(holidays_list.includes(moushikomibi)) continue
            
          }
        }

        // 除外日の指定がある場合
        if(jogai_date.length){
          
          // 除外日に該当する日の場合
          // 飛ばして次へ
          if(jogai_date.includes(jogai_day)) continue
        }

        let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);
        
        // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
        let add_flg = 0
        moushikomi_list.value[0].filter( function (value) {
          if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
            // 同じ日時がすでにある場合は飛ばす
            add_flg = 1
          }
        })
        
        

        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date)
        set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

        // 開催日と今日の日付を比較して日数を取得
        var checkDay = (set_date - today) / 86400000 ;

        let set_nissu = 1

        // 受付〆切日時がプログラム単位の場合
        if(end_shubetsu.value == 2){
            // 受付〆切日が設定されていない場合
            if(!taiken_list.value.shimekiri_date){
                set_nissu = taiken_list.value.shimekiri_nissu
            }
        }
        

        if (checkDay < set_nissu) {
            add_flg = 1
            
        }
    
        // 追加済みの日時であれば飛ばして次へ
        if(add_flg == 0){ 
          let moushikomi_flg = 0 // 0：申込みなし、1:体験プログラムに申込み済み、2：事前説明会に申込み済み、3：事後集会に申込み済み

          // ログイン中かつユーザー登録済みの場合、申込むユーザーは該当日に申込み済みか確認する
          if(user_taiken_jyokyo.length != 0){
            for(let j = 0;j<user_taiken_jyokyo.length;j++){
              let kaisai_date = new Date(user_taiken_jyokyo[j].kaisai_date)
              let check_kaisai_date = kaisai_date.getFullYear()+"-"+('00'+(kaisai_date.getMonth()+1)).slice(-2)+"-"+('00'+kaisai_date.getDate()).slice(-2);
              
              // 申込み済みの場合はフラグを立てる（キャンセルした体験プログラムは除く）
              if(check_kaisai_date == check_date && user_taiken_jyokyo[j].jokyo != 9){
                // 実績が事前説明会の場合
                if(user_taiken_jyokyo[j].program_kbn == 2){
                    if(user_taiken_jyokyo[j].syurui == 3){
                        // 動画視聴の場合は申込無しとする
                    }else{
                        // 動画視聴以外の場合はフラグを立てる
                        moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                    }
                }else{
                    moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                }
              }
          console.log(kaisai_date+"/"+moushikomi_flg)
            }
          }
          
          if(moushikomi_flg != 0) all_sanka_ok = moushikomi_flg
            
          // Dateは並び替え用のdate、申込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
          moushikomi_list.value[0][moushikomi_count] = 
                                    {"all_count":i,"moushikomi_count":moushikomi_count,
                                    "date":set_date,"check_date":check_date,
                                    "nittei_group":nittei_group,
                                    "hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],
                                    "jikantai_start":jikantai_start,"jikantai_end":jikantai_end,
                                    "ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
          moushikomi_count++
        }
      }
      
        // 開催日の開始日が今日より後ならリストに追加
        if(today < start_date){
            // 他のプログラムや説明会などにより参加の有無を示すフラグを追加
            nittei_list.value[nittei_list_count]["all_sanka_ok"] = all_sanka_ok
            set_nittei_list.value[set_nittei_list.value.length] = nittei_list.value[nittei_list_count]
        }
        nittei_list_count++
    });
    
    }
    else{
    nittei_list.value.forEach(function(nittei) {
        let all_sanka_ok = 0 // 日程のすべての日付にに参加可能かどうか
        if(!moushikomi_list.value[nittei["nittei_set_no"]-1]){
          moushikomi_list.value[nittei["nittei_set_no"]-1] = []
        }
        
        // 日程グループが変わったら申込カウントをリセット
        if(before_set_no != nittei["nittei_set_no"]){
          moushikomi_count = 0
        }

        before_set_no = nittei["nittei_set_no"]
        

      // 開催日（自・至）から日数を求める
        let start_date = new Date(nittei["kaisai_start"]);

        if(!calendar_hyoji_date[nittei["nittei_set_no"]-1]){
            calendar_hyoji_date[nittei["nittei_set_no"]-1] = []
            calendar_hyoji_date[nittei["nittei_set_no"]-1] = new Date(start_date)
            calendar_year[nittei["nittei_set_no"]-1] = []
            calendar_year[nittei["nittei_set_no"]-1] = calendar_hyoji_date[nittei["nittei_set_no"]-1].getFullYear()
            calendar_month[nittei["nittei_set_no"]-1] = []
            calendar_month[nittei["nittei_set_no"]-1] = calendar_hyoji_date[nittei["nittei_set_no"]-1].getMonth() + 1  
            holiday_year_month[nittei["nittei_set_no"]-1] = []
            holiday_year_month[nittei["nittei_set_no"]-1] = calendar_year[nittei["nittei_set_no"]-1]+"-"+calendar_month[nittei["nittei_set_no"]-1]+"-01"
            
            let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日

            // 開催日（至）がnullの場合は、その月の最後までを対象とする
            if(kaisai_end[nittei["nittei_set_no"]-1] == null){
              let nissu = mondate[calendar_month-1];
                  if(calendar_month[nittei["nittei_set_no"]-1]  == 2){
                    if(calendar_year[nittei["nittei_set_no"]-1] %4 == 0){
                      if(calendar_year[nittei["nittei_set_no"]-1] %100 == 0){
                        if(calendar_year[nittei["nittei_set_no"]-1] %400 == 0){
                          nissu = 29;
                        }
                      }else{
                        nissu = 29;
                          
                      }
                    }
                  }
              kaisai_end[nittei["nittei_set_no"]-1]  = calendar_year[nittei["nittei_set_no"]-1] +"-"+calendar_month[nittei["nittei_set_no"]-1] +"-"+nissu
            }
            
          }
      let set_kaisai_end = nittei["kaisai_end"] 

      // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
      if(nittei["kaisai_end"] == null){
        set_kaisai_end = kaisai_end
      }
      const end_date = new Date(set_kaisai_end);
      // 差日を求めた上で＋1することで日数になる
      const termDay = ((end_date - start_date) / 86400000) + 1;

      // 申込める時間帯を取得
      const jikantai_start = nittei["jikantai_start"]
      const jikantai_end = nittei["jikantai_end"]

      // この日程の各日の定員を取得
      let teiin = nittei["teiin"]
      // 定員の扱いが1日ごとの場合は1日ごとの定員を格納
      if(taiken_list.value.teiin_settei == 1){
        teiin = taiken_list.value.teiin_oneday
      }

      // 開催曜日を取得
      let kaisai_list = []
      if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
        nittei["kaisai_youbi"] = nittei["kaisai_youbi"].replace(/､/g, '、')
        kaisai_list = nittei["kaisai_youbi"].split("、")
      }
      // 除外曜日を取得
      let jogai_list = []
      if(nittei["jogai"] != "" && nittei["jogai"] != null){
        nittei["jogai"] = nittei["jogai"].replace(/､/g, '、')
        jogai_list = nittei["jogai"].split("、")
      }
      
      // 除外日を取得
      let jogai_date = []
      if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
        jogai_date = nittei["jogai_date"].split("、")
      }

      let nittei_group = nittei["nittei_group"] 
      for(let i = 0;i < termDay;i++){
        let date = new Date();
        if(i != 0) {
          date = start_date.setDate(start_date.getDate() + 1);
        }else{
          date = start_date.setDate(start_date.getDate());
        }
        let set_date = new Date(date)

        let set_year = set_date.getFullYear()
        let set_month = set_date.getMonth() + 1
        let set_day = set_date.getDate()
        let set_youbi = set_date.getDay()

        let moushikomibi = set_year+"/"+set_month+"/"+set_day
        let jogai_day = set_month+"/"+set_day
        
        
        // 開催曜日の指定がある場合
        if(kaisai_list.length != 0){
            
          // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
          if(kaisai_list.includes(youbi_list[set_youbi])) {

          }else{

            // 開催曜日に祝日がある場合
            if(kaisai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日でなければスルー
              if(!holidays_list.includes(moushikomibi)) continue
              
            }else{
                continue
            }
          }
        }

        // 除外曜日の指定がある場合
        if(jogai_list.length != 0){
          // 除外曜日に指定した曜日に該当する日の場合
          // 飛ばして次へ
          if(jogai_list.includes(youbi_list[set_youbi])) continue

          // 除外曜日に祝日がある場合
          if(jogai_list.includes("祝")){
            // 日付が祝日かどうかを確認
            // 祝日であれば飛ばして次へ
            if(holidays_list.includes(moushikomibi)) continue
            
          }
        }

        // 除外日の指定がある場合
        if(jogai_date.length){
          
          // 除外日に該当する日の場合
          // 飛ばして次へ
          if(jogai_date.includes(jogai_day)) continue
        }

        let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);
        
        // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
        let add_flg = 0
        moushikomi_list.value[nittei["nittei_set_no"]-1].filter( function (value) {
          if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
            // 同じ日時がすでにある場合は飛ばす
            add_flg = 1
          }
        })
        
        

        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date)
        set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

        // 開催日と今日の日付を比較して日数を取得
        var checkDay = (set_date - today) / 86400000 ;

        let set_nissu = 1

        // 受付〆切日時がプログラム単位の場合
        if(end_shubetsu.value == 2){
            // 受付〆切日が設定されていない場合
            if(!taiken_list.value.shimekiri_date){
                set_nissu = taiken_list.value.shimekiri_nissu
            }
        }
        

        if (checkDay < set_nissu) {
            add_flg = 1
            
        }
    
        // 追加済みの日時であれば飛ばして次へ
        if(add_flg == 0){ 
          let moushikomi_flg = 0 // 0：申込みなし、1:体験プログラムに申込み済み、2：事前説明会に申込み済み、3：事後集会に申込み済み

          // ログイン中かつユーザー登録済みの場合、申込むユーザーは該当日に申込み済みか確認する
          if(user_taiken_jyokyo.length != 0){
            for(let j = 0;j<user_taiken_jyokyo.length;j++){
              let kaisai_date = new Date(user_taiken_jyokyo[j].kaisai_date)
              let check_kaisai_date = kaisai_date.getFullYear()+"-"+('00'+(kaisai_date.getMonth()+1)).slice(-2)+"-"+('00'+kaisai_date.getDate()).slice(-2);
              
              // 申込み済みの場合はフラグを立てる（キャンセルした体験プログラムは除く）
              if(check_kaisai_date == check_date && user_taiken_jyokyo[j].jokyo != 9){
                // 実績が事前説明会の場合
                if(user_taiken_jyokyo[j].program_kbn == 2){
                    if(user_taiken_jyokyo[j].syurui == 3){
                        // 動画視聴の場合は申込無しとする
                    }else{
                        // 動画視聴以外の場合はフラグを立てる
                        moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                    }
                }else{
                    moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                }
              }
          console.log(kaisai_date+"/"+moushikomi_flg)
            }
          }
          
          if(moushikomi_flg != 0) all_sanka_ok = moushikomi_flg
            
          // Dateは並び替え用のdate、申込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
          moushikomi_list.value[nittei["nittei_set_no"]-1][moushikomi_count] = 
                                    {"all_count":i,"moushikomi_count":moushikomi_count,
                                    "date":set_date,"check_date":check_date,
                                    "nittei_group":nittei_group,
                                    "hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],
                                    "jikantai_start":jikantai_start,"jikantai_end":jikantai_end,
                                    "ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
          moushikomi_count++
        }
      }
      
        // 開催日の開始日が今日より後ならリストに追加
        if(today < start_date){
            // 他のプログラムや説明会などにより参加の有無を示すフラグを追加
            nittei_list.value[nittei_list_count]["all_sanka_ok"] = all_sanka_ok
            set_nittei_list.value[set_nittei_list.value.length] = nittei_list.value[nittei_list_count]
        }
        nittei_list_count++
    });
    }
    // 割り振った番号（日程グループ）ごとにリストを整える
    for(let n = 0;n<moushikomi_list.value.length;n++){
        
      // 時間帯順で並び替え
      moushikomi_list.value[n].sort((a, b) => b.jikantai_start - a.jikantai_start);

      // 日付順で並び替え
      moushikomi_list.value[n].sort((a, b) => a.date - b.date);

      let before_date = ""
      let date_bango = 0 // 日付ごとの番号

      // 同じ日付には同じ番号を振るようにする
      for(let md = 0;md<moushikomi_list.value[n].length;md++){
          if(moushikomi_list.value[n][md].hyoji_date != before_date){
              date_bango = date_bango + 1
          }
          //alert(before_date = moushikomi_list.value[n][md].hyoji_date)
          before_date = moushikomi_list.value[n][md].hyoji_date
          moushikomi_list.value[n][md].date_bango = date_bango
      }
    }

    let nittei_count = 0

    console.log(jisseki_all)

    for(let n = 0;n<moushikomi_list.value.length;n++){
      // 申込状況レコードから、申込まれた日時の人数を確認する
      for(let j = 0;j<jisseki_all.length;j++){
        
        jisseki_all[j].forEach(function(jyokyo) {

            if(jyokyo.program_id == taiken_list.value.taiken_id){
                // 申込める日時配列内を、申込状況レコードでフィルター検索
                moushikomi_list.value[n].filter( function (value) {

                    if(taiken_list.value.teiin_settei == 1){
                        // 定員の扱いが1日ごとの場合は開催日が合致したら
                        if(jyokyo["kaisai_date"] == value.check_date){
                            // 合致した条件の人数を加算する
                            value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                        }
                    }else{
                        // 定員の扱いが時間帯ごとの場合は開催日・開催時間が合致したら
                        if(jyokyo["kaisai_date"] == value.check_date 
                            && jyokyo["jikantai_start"] == value.jikantai_start
                            && jyokyo["jikantai_end"] == value.jikantai_end){
                            // 合致した条件の人数を加算する
                            value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                        }
                    }
                })
                nittei_count++
            }
        });
      }
    }
        // 日程ごとに選択する場合、1日目の参加人数を取得（1日目の人数＝他の日付の人数と同じ）
        for(let s2 = 0;s2<set_nittei_list.value.length;s2++){
            set_nittei_list.value[s2]["ninzu"] = 0
            jisseki_all[0].forEach(function(jyokyo) {
                if(jyokyo["kaisai_date"] == set_nittei_list.value[s2]["kaisai_start"] 
                    && jyokyo["jikantai_start"] == set_nittei_list.value[s2]["jikantai_start"]){
                        // 合致した条件の人数を加算する
                        set_nittei_list.value[s2]["ninzu"] = jyokyo["ninzu"]
                }
            });
        }

    // サブがない場合
    if(sub_list.value.length == 0){
        // ローディングアイコンストップ
        emit('call',{ cmd:'loading_end_noreload' })
    }
  }
  
  // カレンダーを表示する
  let Calendar_set = function(){
    
    let calendarHtml = ''// HTMLを組み立てる変数
    let spHtml = '' // HTMLを組み立てる変数（スマホ）
    
    // メインプログラムの日程をグループごとに処理する
    console.log(moushikomi_list.value)
    for(let m = 0;m<moushikomi_list.value.length;m++){

                
        let check_array = []
        if(select_date.value[m]){
            check_array = select_date.value[m]
        }

       // if(NitteiActive.value == m) {

            if(moushikomi_list.value[m].length == 0){
                
                calendarHtml = '<br>選択できる日程がありません。' // HTMLを組み立てる変数
                spHtml = '<br>選択できる日程がありません。'
        
            }else{
                        
                const date = new Date(calendar_year[m],calendar_month[m],1)
                const year = date.getFullYear()
                const month = date.getMonth() 

                const startDate = new Date(year, month - 1, 1) // 月の最初の日を取得
                const endDate = new Date(year, month,  0) // 月の最後の日を取得
                const endDayCount = endDate.getDate() // 月の末日
                const startDay = startDate.getDay() // 月の最初の日の曜日を取得
                let dayCount = 1 // 日にちのカウント

                console.log(moushikomi_list.value[m])
                
                // キャンセル待ち機能を利用する場合
                if(cancel_setting == 0){
                    calendarHtml += '<div style="fonr-weight:700;width:100%;padding:10px 10px 0;text-align:left">※ 赤表示は<span style="color:red">キャンセル待ち人数</span>になります。</div>'
                    spHtml += '<div style="padding-top:10px">※ 赤（<span style="color:red">▲</span>）はキャンセル待ちです。</div>'
                }
                let calendar_button = ''
                calendar_button += '<div id="calendar_button_area">';
                
                calendar_button += '<div id="month_change_prev,'+m+'" class="month_change">＜＜前月</div>'+
                                '<div><h2 style="margin:0">'+(calendar_month[m])+' 月</h2></div>'+
                                '<div id="month_change_next,'+m+'" class="month_change">翌月＞＞</div>'+
                            '</div>'+
                            '<div id="title_area" style="border-bottom: 1px solid #000;">'+
                                '<div class="list_column_header calendar_column_left" style="color: red;">日</div>'+
                                '<div class="list_column_header calendar_column">月</div>'+
                                '<div class="list_column_header calendar_column">火</div>'+
                                '<div class="list_column_header calendar_column">水</div>'+
                                '<div class="list_column_header calendar_column">木</div>'+
                                '<div class="list_column_header calendar_column">金</div>'+
                                '<div class="list_column_header calendar_column_right" style="color:blue">土</div>'+
                            '</div></div>'

                calendarHtml += calendar_button
                spHtml += calendar_button



                // リスト全体の番号を割り振る
                for(let i = 0;i<moushikomi_list.value[m].length;i++){
                    moushikomi_list.value[m][i].all_count = i
                }

                for (let w = 0; w < 6; w++) {

                    // 1週間のうち、日付を入れたカラムを判定する
                    let setCount = 0

                    // PC用とスマホ用の2つを用意
                    let set_html = '<div id="calendar_column_area" >'
                    let set_sp_html = '<div id="calendar_column_area" >'

                    for (let d = 0; d < 7; d++) {
                        // 時間帯をいくつ配置したか
                        let datetime_count = 0
                        set_html += '<div class="'
                        set_sp_html += '<div class="'
                        if(d == 0) {
                            set_html += 'calendar_column_left'
                            set_sp_html += 'calendar_column_left'
                        }else if(d == 6){
                            set_html += 'calendar_column_right'
                            set_sp_html += 'calendar_column_right'

                        }else{
                            set_html += 'calendar_column'
                            set_sp_html += 'calendar_column'
                        
                        }
                        set_html += '">'
                        // spの閉じは後で
                        if (w == 0 && d < startDay) {
                            
                            set_sp_html += '">'

                            // 1行目で1日の曜日の前
                            set_html += '<div class="column_date_blank"></div>'
                            set_sp_html += '<div class="column_date_blank"></div>'
                        } else if (dayCount > endDayCount) {
                            set_sp_html += '">'
                            // 末尾の日数を超えた
                            set_html += '<div class="column_date_blank"></div>'
                            set_sp_html += '<div class="column_date_blank"></div>'
                        } else {
                            
                            // 申込リスト内に日付がある場合は申込まれた人数を表示
                            // 現在表示する日付をセット
                            let setDate = calendar_year[m]+"-"+('00'+(calendar_month[m])).slice(-2)+"-"+('00'+dayCount).slice(-2)
                            let checkHoliday = calendar_year[m]+"/"+calendar_month[m] + "/"+ dayCount
                        
                            set_sp_html += '"'
                            set_sp_html += ' id="'+setDate+'9999'+m+'"'
                            // スマホの場合はここで、選択した日付が存在するなら背景色を変える
                            if(check_array.findIndex(({kaisai_date}) => kaisai_date == setDate) != -1){
                                set_sp_html += 'style="background-color:#AFA;"'
                            }
                            set_sp_html += '>'
                            // 日付を入力
                            set_html += '<div class="column_date">'

                            set_sp_html += '<div class="column_date"  ';
                            set_sp_html += '>'
                        
                            set_html += '<div class="column_date_day"><span '
                        // set_sp_html += '<div class="column_date_day" id="'+setDate+'" ><span  id="'+setDate+'" '
                            set_sp_html += '<div class="column_date_day" ><span '
                            // 祝 or 日なら赤
                            if(holidays_list.includes(checkHoliday) || d == 0){
                            set_html += "style='color:red'"
                            set_sp_html += "style='color:red'"
                            }else if(d == 6){
                            // 土なら青
                            set_html += "style='color:blue'"
                            set_sp_html += "style='color:blue'"
                            }
                        
                            set_html += '/>'
                        set_sp_html += '/>'
                        
                        set_html +=  dayCount
                        set_sp_html +=  dayCount
                        
                        set_html += '</span></div>'
                        set_sp_html += '</span></div>'

                        let before_date = 0
                        moushikomi_list.value[m].filter( function (value) {

                            // 申込める日付リストに存在していたら時間帯（PC）or申込可不可マーク（スマホ）を表示
                            if(setDate == value.check_date ){

                                // 申込人数 / 定員は定員の扱いが「1日ごと」なら時間帯の上に1つだけ表記（PCのみ）
                                if(taiken_list.value.teiin_settei == 1 && datetime_count == 0){
                                        set_html += " <b style='"
                                        // 申込人数が定員より少ないときは青色
                                        if(value.ninzu < taiken_list.value.teiin_oneday){
                                            set_html += "color:blue"
                                        }else{// 申込人数が定員のときは赤色
                                            set_html += "color:red"
                                        }
                                        set_html += "'>"
                                        set_html += value.ninzu
                                        
                                        // 定員がnullの場合は表示しない
                                        if(taiken_list.value.teiin_oneday != null){
                                        set_html +=  "/"+ taiken_list.value.teiin_oneday
                                        }
                                        set_html += '</b>'
                                }
                                    
                                set_html += '<div class="column_date_time">'
                                // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                if(value.check_date != before_date){
                                    set_sp_html += '<div class="column_date_time" >'
                                }

                                // 参加日がある（申込OK）かどうか
                                let moushikomi_flg = 0
                                if(taiken_list.value.nittei_sentaku == 0){
                                    // 日程選択が1日なら1日ごとの申込状況をチェック
                                    moushikomi_flg = value.moushikomi_flg
                                }else{
                                    // 日程選択が日程なら日程全体の申込状況をチェック
                                    if(set_nittei_list.value[m]?.all_sanka_ok) {
                                        moushikomi_flg = set_nittei_list.value[m].all_sanka_ok
                                         console.log("all_sanka_ok:"+set_nittei_list.value[m]?.all_sanka_ok)
                                    }else{
                                        moushikomi_flg = 0
                                    }
                                    console.log("all_sanka_ok:"+set_nittei_list.value[m]?.all_sanka_ok +"/moushikomi_flg:"+moushikomi_flg)
                                }

                                // 時間帯
                                // 未ログイン・未ユーザー登録の場合
                                if(mode.value == 'nologin' || mode.value == 'noinfo' ){
                                    // PCの場合は時間帯と人数を表示
                                    set_html += '<div >'
                                    set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)
                                    
                                    // 定員は、「定員の扱い」が「時間帯ごと」なら時間帯の後に表記
                                    if(taiken_list.value.teiin_settei == 0){
                                        set_html += " <b style='font-size:15px;margin-left:10px;"
                                        
                                        // 申込人数が定員より少ないときは青色
                                        if(value.ninzu < value.teiin){
                                            set_html += "color:blue"
                                        }else{// 申込人数が定員のときは赤色
                                            set_html += "color:red"
                                        }
                                        
                                        set_html += "'>"
                                        // 申込人数 / 定員
                                        let nokori_ninzu = (value.teiin - value.ninzu)

                                        // 満員の場合は0に補正
                                        if(nokori_ninzu < 0){
                                            nokori_ninzu = 0
                                        }
                                        if(value.teiin < 999){
                                            // 満員の場合
                                            if(nokori_ninzu == 0){
                                                // キャンセル待ち機能を利用する場合はキャンセル待ち人数を表示
                                                if(cancel_setting == 0){
                                                    set_html += parseInt(value.ninzu - value.teiin + 1)
                                                    
                                                }else{
                                                    // キャンセル待ち機能を利用しない場合はこちら
                                                    set_html += "0"
                                                }
                                            }else{
                                                // 残り申込可能人数を表示
                                                set_html += nokori_ninzu
                                            }
                                        }
                                    }

                                    // 定員がnullの場合は表示しない
                                    /*
                                    if(value.teiin != null){
                                        set_html +=  "/"+ value.teiin
                                    }*/
                                    set_html += '</b></div>'

                                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        // スマホの場合は申込可不可（● or ×）を表示
                                        set_sp_html += '<div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;" ';   
                                        if(value.ninzu < value.teiin){
                                            //set_sp_html += 'id="'+setDate+'"';
                                        }
                                        set_sp_html += '>'
                                        set_sp_html += " <img style='width:50%' src='../../../img/"
                                        
                                        // 申込人数が定員より少ないときは青色の「●」
                                        if(value.ninzu < value.teiin){
                                            set_sp_html += "OK.png' id='"+setDate+","+m+"'/>"
                                        }else{// 申込人数が定員のとき
                                            
                                            // キャンセル待ち機能を利用するなら●のときと同様にIDを付け、画像はキャンセル待ち用（▲）とする
                                            if(cancel_setting == 0){
                                                set_sp_html += "wait_cancel.png'"
                                                set_sp_html += " id='"+setDate+","+m+"' "
                                            }else{
                                                // キャンセル待ち機能を利用しない場合は、赤色の「ー」とする（選択不可）
                                                set_sp_html += "NG.png'"
                                            }

                                            set_sp_html += "/>"
                                        }
                                        
                                        set_sp_html += '</div>'
                                    }
                                }else 

                                // 他に申込んでいるプログラムがないなら時間帯（PC）or申込可不可マーク（スマホ）を表示
                                if(moushikomi_flg == 0){
                                    console.log(moushikomi_flg)

                                    // PCの場合は時間帯を表示し、日付をクリックできるかどうかを判定する
                                    set_html += '<div class="set_id9999'+m+value.all_count+'"';
                                    // 日程の選択が1日ごとの場合
                                    if(taiken_list.value.nittei_sentaku == 0){
                                        set_html += 'id="'+value.all_count+','+value.check_date+','+value.jikantai_start+','+value.jikantai_end+','+value.ninzu+','+value.teiin+','+value.date_bango+',jikantai_click,'+m+'"'
                                        set_html += 'style="display: flex;align-items: center;'
                                            
                                        // カレンダー表示時、選択した日付が存在するなら背景色を変える
                                        if(check_array.findIndex(({bango}) => bango == value.all_count) != -1){
                                            set_html += "background-color:#AFA;"
                                        }

                                    }else{
                                        // 日程の選択が日程ごとの場合
                                        set_html += 'id="nittei_click,'+m+'"'
                                        set_html += 'style="display: flex;align-items: center;'
                                        // カレンダー表示時、選択した日時が存在するなら背景色を変える
                                        if(check_array.findIndex(({kaisai_date}) => kaisai_date == value.check_date) != -1){
                                            if(check_array.findIndex(({jikantai_start}) => jikantai_start == value.jikantai_start) != -1){
                                                set_html += "background-color:#AFA;"
                                            }
                                        }
                                    }

                                    // 申込人数が定員より少ないとき、または満員でもキャンセル待ち機能を利用するときは下線とカーソルを入れる（クリック可能なことを強調）
                                    if((value.ninzu < value.teiin) || cancel_setting == 0){
                                        set_html += "cursor:pointer;border-bottom:1px solid #000;"
                                    }

                                    set_html += '">'
                                    set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)

                                    // 定員は、「定員の扱い」が「時間帯ごと」なら時間帯の後に表記
                                    if(taiken_list.value.teiin_settei == 0){
                                        set_html += " <b style='font-size:15px;margin-left:10px;"
                                        
                                        // 申込人数が定員より少ないときは青色
                                        if(value.ninzu < value.teiin){
                                            set_html += "color:blue"
                                        }else{// 申込人数が定員のときは赤色
                                            set_html += "color:red"
                                        }
                                        
                                        set_html += "'>"
                                        
                                        // 申込人数 / 定員
                                        let nokori_ninzu = (value.teiin - value.ninzu)

                                        // 満員の場合は0に補正
                                        if(nokori_ninzu < 0){
                                            nokori_ninzu = 0
                                        }
                                        if(value.teiin < 999){
                                            // 満員の場合
                                            if(nokori_ninzu == 0){
                                                // キャンセル待ち機能を利用する場合はキャンセル待ち人数を表示
                                                if(cancel_setting == 0){
                                                    set_html += parseInt(value.ninzu - value.teiin + 1) 
                                                    
                                                }else{
                                                    // キャンセル待ち機能を利用しない場合はこちら
                                                    set_html += "0"
                                                }
                                            }else{
                                                // 残り申込可能人数を表示
                                                set_html += nokori_ninzu
                                            }
                                        }
                                    }
                                     /*
                                    // 定員がnullの場合は表示しない
                                    if(value.teiin != null){
                                        set_html +=  "/"+ value.teiin
                                    }*/
                                    set_html += '</b></div>'

                                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        // スマホの場合は申込可不可（● or ×）を表示し、選択できるかどうかを判定する
                                        // ※キャンセル待ち機能を利用する場合はどちらにせよ選択可能とする
                                        console.log(value.ninzu +"/"+ value.teiin + "|"+cancel_setting)
                                        set_sp_html += '<div class="set_id9999'+m+value.all_count+'" ';   
                                        if((value.ninzu < value.teiin) || cancel_setting == 0){
                                            set_sp_html += 'id="'+setDate+'"';
                                        }
                                        set_sp_html += 'style="width:100%;height: 100%;display: flex;align-items: center;justify-content: center;'
                                        
                                        
                                        set_sp_html += '">'
                                        set_sp_html += " <img style='width:50%' src='../../../img/"
                                        
                                        // 申込人数が定員より少ないときは青色の「●」
                                        if(value.ninzu < value.teiin){
                                            set_sp_html += "OK.png' id='"+setDate+","+m+"'/>"
                                        }else{// 申込人数が定員のときは赤色の「×」
                                        
                                            // キャンセル待ち機能を利用するなら●のときと同様にIDを付け、画像はキャンセル待ち用（▲）とする
                                            if(cancel_setting == 0){
                                                set_sp_html += "wait_cancel.png'"
                                                set_sp_html += " id='"+setDate+","+m+"' "
                                            }else{
                                                // キャンセル待ち機能を利用しない場合は、赤色の「ー」とする（選択不可）
                                                set_sp_html += "NG.png'"
                                            }

                                            set_sp_html += "/>"
                                        }
                                        
                                        set_sp_html += '</div>'
                                    }
                                    
                                }else{

                                    // 申込済みの場合、PCは申込済みであることを明記する
                                    set_html += '<span style="color:red">'
                                    if(moushikomi_flg == 100){
                                    set_html += 'このプログラムの参加日'
                                    }else if(moushikomi_flg == 1){
                                    set_html += '申込済(体験)'
                                    }else if(moushikomi_flg == 2){
                                    set_html += '申込済(事前)'
                                    }else{
                                    set_html += '申込済(事後)'
                                    }
                                    
                                    set_html += '</span>'
                                    
                                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        // スマホは×を表示
                                        set_sp_html += " <img style='width:50%' src='../../../img/NG.png'>"
                                    }
                                }
                                set_html += '</div>'
                                
                                // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                if(value.check_date != before_date){
                                set_sp_html += '</div>'
                                }

                                // 表示中の日付を取得
                                before_date = setDate
                                // 日付ごとの時間帯カウントを加算
                                datetime_count++
                            }
                            
                        })
                        datetime_count = 0
                            set_html += '</div>'
                            set_sp_html += '</div>'

                        dayCount++
                        setCount++
                        }
                        datetime_count = 0
                        set_html += '</div>'
                        set_sp_html += '</div>'
                    }
                    set_html += '</div>'
                    set_sp_html += '</div>'

                    // 日付の入ったカラムが1個でもあれば行として追加
                    if(setCount !=0){
                        calendarHtml += set_html
                        spHtml += set_sp_html
                    }
                }
            }
       // }
    }

    Calendar.value = calendarHtml
    CalendarSp.value = spHtml
    
  }
  

  // カレンダーの月を加算・減算し、再度カレンダーを表示する
  let Change_month = function(num,nittei){
    
   calendar_month[nittei] = calendar_month[nittei] + num
    if(calendar_month[nittei] == 0) {
      calendar_month[nittei] = 12
      calendar_year[nittei] = calendar_year[nittei] - 1
    }
    if(calendar_month[nittei] == 13) {
      calendar_month[nittei] = 1
      calendar_year[nittei] = calendar_year[nittei] + 1
    }
    Calendar_set()
  }

  // カレンダー上の時間帯をクリックした時（PC）
  let htmlColumnClick = function(e){
        let clicked = e.target.id

        if(clicked == "") return

        let Click_array = clicked.split(",")

      if(Click_array[0] == "link_katsudou_cal"){
          // 別の活動に移動する
          link_katsudou_cal(Click_array[1])
          
      }else if(Click_array[0] == "link_katsudou_cal_nittei"){
        // 活動内の別の日程に移動する
        link_katsudou_cal_nittei(Click_array[1],Click_array[2],Click_array[3])
      }else if(Click_array[0] == "month_change_prev"){
        // カレンダーの月を1つ戻す
        Change_month(-1,Click_array[1])
      }else if(Click_array[0] == "month_change_next"){
        // カレンダーの月を1つ進める
        Change_month(1,Click_array[1])
      }else if(Click_array[0] == "nittei_click"){
        // 日程ごとの選択の場合で、カレンダーを選択した時
        Set_list_click(Click_array[1],2)
      }else if(Click_array[7] == "jikantai_click"){
                           
        Set_id(Click_array[1],Click_array[2],Click_array[3],Click_array[0],2,Click_array[6],Click_array[8],Click_array[5],Click_array[4])
      }
    }

    // 日程ごとの選択の場合のセット（活動１）
    let Set_list_click = function(nittei_no,set_type){
        
        // ログイン中かつユーザー登録済みの場合のみ選択可能
        if(mode.value == 'sel'){
            

            let set_back_color = "#AFA"
            if(select_date.value[nittei_no].length == 0){
                // 選択した日程がまだ選択されていない場合
                
                for(let n = 0;n<moushikomi_list.value[nittei_no].length;n++){
                    let nittei = moushikomi_list.value[nittei_no][n]
                    console.log(nittei)
                    // 選択した日程のリストを作成
                    let set_list = {"kaisai_date":nittei.check_date,"jikantai_start":nittei.jikantai_start,"jikantai_end":nittei.jikantai_end,"ninzu":nittei.ninzu,"teiin":nittei.teiin}
                    select_date.value[nittei_no].push(set_list)
                }
            }else if(select_date.value[nittei_no].length > 0){
                // 選択した日程が選択済みの場合は削除
                select_date.value[nittei_no] = []
                set_back_color = "#FFF"
            }

            // IDを元に背景色を変更
            if(set_type == 1){
                // set_type = 1（リストをクリック）
                let obj = document.getElementById('set_list9999'+nittei_no)
                obj.style.backgroundColor = set_back_color
            }else if(set_type == 2 || set_type == 3){
                Calendar_set()
            }
            
        }
    }

    // 日程ごとの選択の場合のセット（活動２～）
    let Sub_Set_list_click = function(nittei_no,katsudou_no,set_type){

        // ログイン中かつユーザー登録済みの場合のみ選択可能
        console.log("katsudou_no:"+katsudou_no+"/nittei_no:"+nittei_no)
        if(mode.value == 'sel'){

            let set_back_color = "#AFA"
            if(select_date_sub.value[katsudou_no][nittei_no].length == 0){
                // 選択した日程がまだ選択されていない場合
                for(let n = 0;n<moushikomi_list_sub.value[katsudou_no][nittei_no].length;n++){
                    let nittei = moushikomi_list_sub.value[katsudou_no][nittei_no][n]
                    // 選択した日程のリストを作成
                    let set_list = {"kaisai_date":nittei.check_date,"jikantai_start":nittei.jikantai_start,"jikantai_end":nittei.jikantai_end,"ninzu":nittei.ninzu,"teiin":nittei.teiin}
                    select_date_sub.value[katsudou_no][nittei_no].push(set_list)
                }
            }else if(select_date_sub.value[katsudou_no][nittei_no].length > 0){
                // 選択した日程が選択済みの場合は削除
                select_date_sub.value[katsudou_no][nittei_no] = []
                set_back_color = "#FFF"
                set_type = 2
            }

            // IDを元に背景色を変更
            if(set_type == 1){
                // set_type = 1（リストをクリック）
                let obj = document.getElementById('set_list'+katsudou_no+nittei_no)
                obj.style.backgroundColor = set_back_color
            }else if(set_type == 2 || set_type == 3){
                Sub_Calendar_set(KatsudouActive_no.value)

            }
            
            
            /*if(set_type == 2){
                // set_type = 2（カレンダー（PC）をクリック）
                let obj = document.getElementsByTagName("*")

                for(let o in obj){
                    if(obj[o].className == 'set_list'+katsudou_no+nittei_no){
                        obj[o].style.backgroundColor = set_back_color
                    }
                }
            }else if(set_type == 3){
                // set_type = 3（カレンダー（スマホ）で選択
                let obj = document.getElementById(kaisai_date0+katsudou_no+nittei_no)
                obj.style.backgroundColor = set_back_color
            }*/

            
        }
    }
  
  // 選択した日時を保存
  let Set_id = function(kaisai_date0,jikantai_start0,jikantai_end0,num,set_type,date_bango,nittei_no,teiin0,ninzu0){
    
    // ログイン中かつユーザー登録済みの場合のみ選択可能
    if(mode.value == 'sel'){
        let set_list = {"bango":num,"date_bango":date_bango,
                        "kaisai_date":kaisai_date0,
                        "nittei_group":nittei_no,
                        "jikantai_start":jikantai_start0,"jikantai_end":jikantai_end0,"teiin":teiin0,"ninzu":ninzu0}

        console.log(set_list)
        let set_back_color = "#AFA"
        // 配列内に選択した番号があるかどうか
        // 番号が存在しない場合は追加
        let check_array = []
        let other_array = select_date.value
        /*
        if(select_date.value[nittei_no]){
            check_array = select_date.value[nittei_no]
        }*/

       for(let o = 0 ;o<select_date.value.length;o++){
            let check_date = select_date.value[o]
            for(let c = 0;c<check_date.length;c++){
                console.log(check_date[c])
                check_array.push(check_date[c])
            }
       }
        if(check_array.findIndex(array => array.bango == num && array.nittei_group == nittei_no) == -1){
            // 定員の扱いが1日ごとの場合
            if(taiken_list.value.teiin_settei == 1){
                console.log("選択した日付番号"+date_bango)
                
                // 同じ日付番号が存在する場合はいったん削除
                for(let d = 0;d < select_date.value[nittei_no].length;d++){
                    if(select_date.value[nittei_no][d].date_bango == date_bango){
                        select_date.value[nittei_no].splice(d,1)
                    }
                }
                
            }
            // 選択できる最大日数
            let max_day = taiken_list.value.nissu_max

            // 参加代行リストに値が入力済みの場合はチェックを挟む
            if(check_array.length != 0){
                // 現在の選択日数＋1日が最大日数を超える場合
                if(max_day == check_array.length){
                
                    message.value = max_day+"日以上は選択できません。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal
                    return
                }
            }
            
            // 同じ活動内の他の日程で、同じ日が選択されている場合は選択不可
            let set_ng = 0
            if(check_array.length > 0){
                for(let o = 0;o<check_array.length;o++){
                    let nittei = check_array[o]
                    if(nittei["kaisai_date"] == kaisai_date0){
                        set_ng = 1
                    }
                }
            }

            if(set_ng == 1){
                message.value = "同じ活動内の他の日程でこの日付が選択されています。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "nissu_error";
                contentMessage.value = MessageModal
                return
            }else{
                select_date.value[nittei_no].push(set_list)
            }

        }else{

            // 番号が存在する場合は削除
            for(let d = 0;d < select_date.value[nittei_no].length;d++){
                if(select_date.value[nittei_no][d].bango == num){
                    select_date.value[nittei_no].splice(d,1)
                }
            }
            set_back_color = "#FFF"
        }

        // IDを元に背景色を変更
        if(set_type == 1){
            // set_type = 1（リストをクリック）
            let obj = document.getElementById('set_id9999'+nittei_no+num)
            obj.style.backgroundColor = set_back_color
        }else if(set_type == 2){
            // set_type = 2（カレンダー（PC）をクリック）
            let obj = document.getElementsByTagName("*")

            for(let o in obj){
                if(obj[o].className == 'set_id9999'+nittei_no+num){
                    obj[o].style.backgroundColor = set_back_color
                }
            }
        }else if(set_type == 3){
            // set_type = 3（カレンダー（スマホ）で選択
            let obj = document.getElementById(kaisai_date0+"9999"+nittei_no)
            obj.style.backgroundColor = set_back_color
        }
    }
}

// カレンダー上のマーク（●）をクリックした時（スマホ）
let htmlColumnClickSp = function(e){
    let clicked = e.target.id
    console.log(clicked)
    if(clicked == "") return
    
        let Click_array = clicked.split(",")
      if(Click_array[0] == "link_katsudou_cal"){
          // 別の活動に移動する
          link_katsudou_cal(Click_array[1])
          
      }else if(Click_array[0] == "link_katsudou_cal_nittei"){
        // 活動内の別の日程に移動する
        link_katsudou_cal_nittei(Click_array[1],Click_array[2],Click_array[3])
      }else if(Click_array[0] == "month_change_prev"){
        // カレンダーの月を1つ戻す
        Change_month(-1,Click_array[1])
      }else if(Click_array[0] == "month_change_next"){
        // カレンダーの月を1つ進める
        Change_month(1,Click_array[1])
      }else {

        /*
        // 同じ活動内で他に選択されている日がある場合は選択不可
            let set_ng = 0
           
            if(other_array.length > 0){
                for(let o = 0;o<other_array.length;o++){
                    let nittei = other_array[o]
                    if(nittei_no != o){
                        if(nittei.length > 0){
                            set_ng = 1
                        }
                    }
                }
            }
        */

        // 日程選択ウィンドウを開く
        let disp_moushikomi_time = []
        let disp_moushikomi_nittei = {}
        let moushikomi_OK_count = 0
        if(Click_array[1]){
            if(taiken_list.value.nittei_sentaku == 0){
                for(let m = 0;m<moushikomi_list.value[Click_array[1]].length;m++){
                    // 選択した日が申込日に存在するかどうか
                    if(moushikomi_list.value[Click_array[1]][m].check_date == Click_array[0]){
                        disp_moushikomi_time[disp_moushikomi_time.length] = moushikomi_list.value[Click_array[1]][m]
                        moushikomi_OK_count++
                    }
                }
            }else{
                if(Click_array[1]){
                    disp_moushikomi_nittei = set_nittei_list.value[Click_array[1]]
                    disp_moushikomi_time[disp_moushikomi_time.length] = moushikomi_list.value[Click_array[1]]
                    moushikomi_OK_count++
                }
                
            }
            // 申込める日があるならウィンドウを開く
            if(moushikomi_OK_count != 0){
                paramCalendar = {"set_nittei_list":disp_moushikomi_nittei,
                                "nittei_sentaku":taiken_list.value.nittei_sentaku,
                                "teiin_oneday":taiken_list.value.teiin_oneday,
                                "teiin_settei":taiken_list.value.teiin_settei,
                                "clicked":Click_array[0],
                                "moushikomi":disp_moushikomi_time,
                                "select_date":select_date.value[Click_array[1]],
                                "mode":mode.value,
                                "katsudou_no":9999,
                                "nittei_no":Click_array[1],
                                "katsudou":"main",
                                "cancel_setting":cancel_setting}
                                /*
                                
                paramCalendar = {"set_nittei_list":disp_moushikomi_nittei,
                                "nittei_sentaku":sub_list.value[Click_array[1]].nittei_sentaku,
                                "teiin_oneday":sub_list.value[Click_array[1]].teiin_oneday,
                                "teiin_settei":sub_list.value[Click_array[1]].teiin_settei,
                                "clicked":Click_array[0],
                                "moushikomi":disp_moushikomi_time,
                                "select_date":select_date_sub.value[Click_array[1]][Click_array[2]],
                                "mode":mode.value,
                                "katsudou_no":Click_array[1],
                                "nittei_no":Click_array[2],
                                "katsudou":"sub"}
                                */
                smart_calendar_area.value = true
                contentCalendar.value = UserCalendarSmart
            }
        }
    }
}


  // 申込める日時を配列として作成する（活動２～）
  let sub_nittei_set = function(){
    sub_set_nittei_list.value = [] 
    
    let today = new Date()
    today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    today = new Date(today)
    today.setHours(0, 0, 0, 0);//0時0分0秒に設定
    
    // サブプログラムの数だけ日程データがある
    for(let s = 0;s<sub_nittei_list.value.length;s++){

      sub_calendar_hyoji_date[s] = []
      sub_calendar_year[s] = []
      sub_calendar_month[s] = []
      sub_holiday_year_month[s] = []
      sub_kaisai_start[s] = []
      sub_kaisai_end[s] = []

      // 申込める日時のカウント
      let moushikomi_count = 0

      // 日程グループを格納
      let before_set_no = 0
        moushikomi_list_sub.value[s] = []

      let nittei_list_count = 0
      sub_set_nittei_list.value[s] = []
       // 日程レコードから申込める日時を作成する
    if(sub_list.value[s].nittei_sentaku == 0){
      sub_nittei_list.value[s].forEach(function(nittei) {
        let all_sanka_ok = 0 // 日程のすべての日付にに参加可能かどうか

        if(!moushikomi_list_sub.value[s][0]){
          moushikomi_list_sub.value[s][0] = []
        }
        /*
        // 日程グループが変わったら申込カウントをリセット
        if(before_set_no != nittei["nittei_set_no"]){
          moushikomi_count = 0
        }
        before_set_no = nittei["nittei_set_no"]
        */
        // 開催日（自・至）から日数を求める
        let start_date = new Date(nittei["kaisai_start"]);
        if(moushikomi_count == 0){
          
          if(!sub_calendar_hyoji_date[s][0]){
            sub_calendar_hyoji_date[s][0] = []
            sub_calendar_hyoji_date[s][0] = new Date(start_date)
            sub_calendar_year[s][0] = []
            sub_calendar_year[s][0] = sub_calendar_hyoji_date[s][0].getFullYear()
            sub_calendar_month[s][0] = []
            sub_calendar_month[s][0] = sub_calendar_hyoji_date[s][0].getMonth() + 1  
            sub_holiday_year_month[s][0] = []
            sub_holiday_year_month[s][0] = sub_calendar_year[s][0]+"-"+sub_calendar_month[s][0]+"-01"
            
            let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日

            // 開催日（至）がnullの場合は、その月の最後までを対象とする
            if(sub_kaisai_end[s][0] == null){
              let nissu = mondate[sub_calendar_month[s]-1];
                  if(sub_calendar_month[s][0] == 2){
                    if(sub_calendar_year[s][0]%4 == 0){
                      if(sub_calendar_year[s][0]%100 == 0){
                        if(sub_calendar_year[s][0]%400 == 0){
                          nissu = 29;
                        }
                      }else{
                        nissu = 29;
                          
                      }
                    }
                  }
              sub_kaisai_end[s][0] = sub_calendar_year[s][0]+"-"+sub_calendar_month[s][0]+"-"+nissu
            }
          }
        }

        let set_kaisai_end = nittei["kaisai_end"] 

        // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
        if(nittei["kaisai_end"] == null){
          set_kaisai_end = kaisai_end
        }
        const end_date = new Date(set_kaisai_end);
        // 差日を求めた上で＋1することで日数になる
        const termDay = ((end_date - start_date) / 86400000) + 1;

        // 申込める時間帯を取得
        const jikantai_start = nittei["jikantai_start"]
        const jikantai_end = nittei["jikantai_end"]

        // この日程の各日の定員を取得
        let teiin = nittei["teiin"]
        
        // 定員の扱いが1日ごとの場合は1日ごとの定員を格納
        if(sub_list.value[s].teiin_settei == 1){
            teiin = sub_list.value[s].teiin_oneday
        }

        // 開催曜日を取得
        let kaisai_list = []
        if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
          kaisai_list = nittei["kaisai_youbi"].split("、")
        }
        // 除外曜日を取得
        let jogai_list = []
        if(nittei["jogai"] != "" && nittei["jogai"] != null){
          jogai_list = nittei["jogai"].split("、")
        }
        
        // 除外日を取得
        let jogai_date = []
        if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
          jogai_date = nittei["jogai_date"].split("、")
        }

        let nittei_group = nittei["nittei_group"]


        for(let i = 0;i < termDay;i++){
          let date = new Date();
          if(i != 0) {
            date = start_date.setDate(start_date.getDate() + 1);
          }else{
            date = start_date.setDate(start_date.getDate());
          }
          let set_date = new Date(date)

          let set_year = set_date.getFullYear()
          let set_month = set_date.getMonth() + 1
          let set_day = set_date.getDate()
          let set_youbi = set_date.getDay()

          let moushikomibi = set_year+"/"+set_month+"/"+set_day
          let jogai_day = set_month+"/"+set_day
          

          // 開催曜日の指定がある場合
          if(kaisai_list.length != 0){
            // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
            if(kaisai_list.includes(youbi_list[set_youbi])) {


            }else{

              // 開催曜日に祝日がある場合
              if(kaisai_list.includes("祝")){
                // 日付が祝日かどうかを確認
                // 祝日でなければスルー
                if(!holidays_list.includes(moushikomibi)) continue
                
              }else{
                continue
              }
            }
          }

          // 除外曜日の指定がある場合
          if(jogai_list.length != 0){
            // 除外曜日に指定した曜日に該当する日の場合
            // 飛ばして次へ
            if(jogai_list.includes(youbi_list[set_youbi])) continue

            // 除外曜日に祝日がある場合
            if(jogai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日であれば飛ばして次へ
              if(holidays_list.includes(moushikomibi)) continue
              
            }
          }

          // 除外日の指定がある場合
          if(jogai_date.length){
            
            // 除外日に該当する日の場合
            // 飛ばして次へ
            if(jogai_date.includes(jogai_day)) continue
          }

          let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);
          
          // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
          let add_flg = 0
          moushikomi_list_sub.value[s][0].filter( function (value) {
            if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
              // 同じ日時がすでにある場合は飛ばす
              add_flg = 1
            }
          })
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date)
            set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

            // 開催日と今日の日付を比較して日数を取得
            var checkDay = (set_date - today) / 86400000 ;
            let set_nissu = 1
            // 受付〆切日時がプログラム単位の場合
            if(end_shubetsu.value == 2){
                // 受付〆切日が設定されていない場合
                if(!sub_list.value[s].shimekiri_date){
                    set_nissu = sub_list.value[s].shimekiri_nissu
                }
            }
            
            if (checkDay < set_nissu) {
                add_flg = 1
            }


          // 追加済みの日時であれば飛ばして次へ
          if(add_flg == 0){ 
            let moushikomi_flg = 0 // 0：申込みなし、1:体験プログラムに申込み済み、2：事前説明会に申込み済み、3：事後集会に申込み済み

            // ログイン中かつユーザー登録済みの場合、申込むユーザーは該当日に申込み済みか確認する
            if(user_taiken_jyokyo.length != 0){
                for(let j = 0;j<user_taiken_jyokyo.length;j++){
                    let kaisai_date = new Date(user_taiken_jyokyo[j].kaisai_date)
                    let check_kaisai_date = kaisai_date.getFullYear()+"-"+('00'+(kaisai_date.getMonth()+1)).slice(-2)+"-"+('00'+kaisai_date.getDate()).slice(-2);
                    // 申込み済みの場合はフラグを立てる（キャンセルした体験プログラムは除く）
                    if(check_kaisai_date == check_date && user_taiken_jyokyo[j].jokyo != 9){
                        // 実績が事前説明会の場合
                        if(user_taiken_jyokyo[j].program_kbn == 2){
                            if(user_taiken_jyokyo[j].syurui == 3){
                            // 動画視聴の場合は申込無しとする
                            }else{
                                // 動画視聴以外の場合はフラグを立てる
                                moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                            }
                        }else{
                            moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                        }
                    }
                }
            }

            if(moushikomi_flg != 0) all_sanka_ok = moushikomi_flg


            // Dateは並び替え用のdate、申込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
            moushikomi_list_sub.value[s][0][moushikomi_count] = {"all_count":i,"moushikomi_count":moushikomi_count,"nittei_group":nittei_group,"date":set_date,"check_date":check_date,"hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],"jikantai_start":jikantai_start,"jikantai_end":jikantai_end,"ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
            moushikomi_count++
          }
        
        }

        // 開催日の開始日が今日より後ならリストに追加
        if(today < start_date){

            // 他のプログラムや説明会などにより参加の有無を示すフラグを追加
            sub_nittei_list.value[s][nittei_list_count]["all_sanka_ok"] = all_sanka_ok
            sub_set_nittei_list.value[s][sub_set_nittei_list.value[s].length] = sub_nittei_list.value[s][nittei_list_count]
            
        }

        nittei_list_count++

      });
    }else{

      // 日程レコードから申込める日時を作成する
      sub_nittei_list.value[s].forEach(function(nittei) {
        let all_sanka_ok = 0 // 日程のすべての日付にに参加可能かどうか

        if(!moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1]){
          moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1] = []
        }
        // 日程グループが変わったら申込カウントをリセット
        if(before_set_no != nittei["nittei_set_no"]){
          moushikomi_count = 0
        }
        before_set_no = nittei["nittei_set_no"]
        // 開催日（自・至）から日数を求める
        let start_date = new Date(nittei["kaisai_start"]);
        if(moushikomi_count == 0){
          
          if(!sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1]){
            sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1] = []
            sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1] = new Date(start_date)
            sub_calendar_year[s][nittei["nittei_set_no"]-1] = []
            sub_calendar_year[s][nittei["nittei_set_no"]-1] = sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1].getFullYear()
            sub_calendar_month[s][nittei["nittei_set_no"]-1] = []
            sub_calendar_month[s][nittei["nittei_set_no"]-1] = sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1].getMonth() + 1  
            sub_holiday_year_month[s][nittei["nittei_set_no"]-1] = []
            sub_holiday_year_month[s][nittei["nittei_set_no"]-1] = sub_calendar_year[s][nittei["nittei_set_no"]-1]+"-"+sub_calendar_month[s][nittei["nittei_set_no"]-1]+"-01"
            
            let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日

            // 開催日（至）がnullの場合は、その月の最後までを対象とする
            if(sub_kaisai_end[s][nittei["nittei_set_no"]-1] == null){
              let nissu = mondate[sub_calendar_month[s]-1];
                  if(sub_calendar_month[s][nittei["nittei_set_no"]-1] == 2){
                    if(sub_calendar_year[s][nittei["nittei_set_no"]-1]%4 == 0){
                      if(sub_calendar_year[s][nittei["nittei_set_no"]-1]%100 == 0){
                        if(sub_calendar_year[s][nittei["nittei_set_no"]-1]%400 == 0){
                          nissu = 29;
                        }
                      }else{
                        nissu = 29;
                          
                      }
                    }
                  }
              sub_kaisai_end[s][nittei["nittei_set_no"]-1] = sub_calendar_year[s][nittei["nittei_set_no"]-1]+"-"+sub_calendar_month[s][nittei["nittei_set_no"]-1]+"-"+nissu
            }
          }
        }

        let set_kaisai_end = nittei["kaisai_end"] 

        // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
        if(nittei["kaisai_end"] == null){
          set_kaisai_end = kaisai_end
        }
        const end_date = new Date(set_kaisai_end);
        // 差日を求めた上で＋1することで日数になる
        const termDay = ((end_date - start_date) / 86400000) + 1;

        // 申込める時間帯を取得
        const jikantai_start = nittei["jikantai_start"]
        const jikantai_end = nittei["jikantai_end"]

        // この日程の各日の定員を取得
        let teiin = nittei["teiin"]
        
        // 定員の扱いが1日ごとの場合は1日ごとの定員を格納
        if(sub_list.value[s].teiin_settei == 1){
            teiin = sub_list.value[s].teiin_oneday
        }

        // 開催曜日を取得
        let kaisai_list = []
        if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
          kaisai_list = nittei["kaisai_youbi"].split("、")
        }
        // 除外曜日を取得
        let jogai_list = []
        if(nittei["jogai"] != "" && nittei["jogai"] != null){
          jogai_list = nittei["jogai"].split("、")
        }
        
        // 除外日を取得
        let jogai_date = []
        if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
          jogai_date = nittei["jogai_date"].split("、")
        }

        let nittei_group = nittei["nittei_group"]


        for(let i = 0;i < termDay;i++){
          let date = new Date();
          if(i != 0) {
            date = start_date.setDate(start_date.getDate() + 1);
          }else{
            date = start_date.setDate(start_date.getDate());
          }
          let set_date = new Date(date)

          let set_year = set_date.getFullYear()
          let set_month = set_date.getMonth() + 1
          let set_day = set_date.getDate()
          let set_youbi = set_date.getDay()

          let moushikomibi = set_year+"/"+set_month+"/"+set_day
          let jogai_day = set_month+"/"+set_day
          

          // 開催曜日の指定がある場合
          if(kaisai_list.length != 0){
            // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
            if(kaisai_list.includes(youbi_list[set_youbi])) {


            }else{

              // 開催曜日に祝日がある場合
              if(kaisai_list.includes("祝")){
                // 日付が祝日かどうかを確認
                // 祝日でなければスルー
                if(!holidays_list.includes(moushikomibi)) continue
                
              }else{
                continue
              }
            }
          }

          // 除外曜日の指定がある場合
          if(jogai_list.length != 0){
            // 除外曜日に指定した曜日に該当する日の場合
            // 飛ばして次へ
            if(jogai_list.includes(youbi_list[set_youbi])) continue

            // 除外曜日に祝日がある場合
            if(jogai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日であれば飛ばして次へ
              if(holidays_list.includes(moushikomibi)) continue
              
            }
          }

          // 除外日の指定がある場合
          if(jogai_date.length){
            
            // 除外日に該当する日の場合
            // 飛ばして次へ
            if(jogai_date.includes(jogai_day)) continue
          }

          let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);
          
          // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
          let add_flg = 0
          moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1].filter( function (value) {
            if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
              // 同じ日時がすでにある場合は飛ばす
              add_flg = 1
            }
          })
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date)
            set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

            // 開催日と今日の日付を比較して日数を取得
            var checkDay = (set_date - today) / 86400000 ;
            let set_nissu = 1
            // 受付〆切日時がプログラム単位の場合
            if(end_shubetsu.value == 2){
                // 受付〆切日が設定されていない場合
                if(!sub_list.value[s].shimekiri_date){
                    set_nissu = sub_list.value[s].shimekiri_nissu
                }
            }
            
            if (checkDay < set_nissu) {
                add_flg = 1
            }


          // 追加済みの日時であれば飛ばして次へ
          if(add_flg == 0){ 
            let moushikomi_flg = 0 // 0：申込みなし、1:体験プログラムに申込み済み、2：事前説明会に申込み済み、3：事後集会に申込み済み

            // ログイン中かつユーザー登録済みの場合、申込むユーザーは該当日に申込み済みか確認する
            if(user_taiken_jyokyo.length != 0){
                for(let j = 0;j<user_taiken_jyokyo.length;j++){
                    let kaisai_date = new Date(user_taiken_jyokyo[j].kaisai_date)
                    let check_kaisai_date = kaisai_date.getFullYear()+"-"+('00'+(kaisai_date.getMonth()+1)).slice(-2)+"-"+('00'+kaisai_date.getDate()).slice(-2);
                    // 申込み済みの場合はフラグを立てる（キャンセルした体験プログラムは除く）
                    if(check_kaisai_date == check_date && user_taiken_jyokyo[j].jokyo != 9){
                        // 実績が事前説明会の場合
                        if(user_taiken_jyokyo[j].program_kbn == 2){
                            if(user_taiken_jyokyo[j].syurui == 3){
                            // 動画視聴の場合は申込無しとする
                            }else{
                                // 動画視聴以外の場合はフラグを立てる
                                moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                            }
                        }else{
                            moushikomi_flg = user_taiken_jyokyo[j].program_kbn
                        }
                    }
                }
            }

            if(moushikomi_flg != 0) all_sanka_ok = moushikomi_flg


            // Dateは並び替え用のdate、申込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
            moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1][moushikomi_count] = {"all_count":i,"moushikomi_count":moushikomi_count,"nittei_group":nittei_group,"date":set_date,"check_date":check_date,"hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],"jikantai_start":jikantai_start,"jikantai_end":jikantai_end,"ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
         //   moushikomi_list_sub.value[s][0][moushikomi_count] = {"all_count":i,"moushikomi_count":moushikomi_count,"nittei_group":nittei_group,"date":set_date,"check_date":check_date,"hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],"jikantai_start":jikantai_start,"jikantai_end":jikantai_end,"ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
            moushikomi_count++
          }
        
        }

        // 開催日の開始日が今日より後ならリストに追加
        if(today < start_date){

            // 他のプログラムや説明会などにより参加の有無を示すフラグを追加
            sub_nittei_list.value[s][nittei_list_count]["all_sanka_ok"] = all_sanka_ok
            sub_set_nittei_list.value[s][sub_set_nittei_list.value[s].length] = sub_nittei_list.value[s][nittei_list_count]
            
        }

        nittei_list_count++

      });
      
    }

      // 割り振った番号（日程グループ）ごとにリストを整える
      for(let n = 0;n<moushikomi_list_sub.value[s].length;n++){
        // 時間帯順で並び替え
        moushikomi_list_sub.value[s][n].sort((a, b) => b.jikantai_start - a.jikantai_start);

        // 日付順で並び替え
        moushikomi_list_sub.value[s][n].sort((a, b) => a.date - b.date);

        let before_date = ""
        let date_bango = 0 // 日付ごとの番号

        // 同じ日付には同じ番号を振るようにする
        for(let md = 0;md<moushikomi_list_sub.value[s][n].length;md++){
            if(moushikomi_list_sub.value[s][n][md].hyoji_date != before_date){
                date_bango = date_bango + 1
            }
            before_date = moushikomi_list_sub.value[s][n][md].hyoji_date
            moushikomi_list_sub.value[s][n][md].date_bango = date_bango
        }
      }

      let nittei_count = 0
      // 申込状況レコードから申込まれた日時の人数を確認する
            console.log("申込状況レコードから申込まれた日時の人数を確認する")

        for(let n = 0;n<moushikomi_list_sub.value[s].length;n++){
            // 申込状況レコードから、申込まれた日時の人数を確認する
            for(let j = 0;j<jisseki_all.length;j++){
                jisseki_all[j].forEach(function(jyokyo) {
                    if(jyokyo.program_id == sub_list.value[s].taiken_id){
                        // 申込める日時配列内を、申込状況レコードでフィルター検索
                        moushikomi_list_sub.value[s][n].filter( function (value) {
                   
                            if(sub_list.value[s].teiin_settei == 1){
                                // 定員の扱いが1日ごとの場合は開催日が合致したら
                                if(jyokyo["kaisai_date"] == value.check_date){
                                    // 合致した条件の人数を加算する
                                    value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                                    console.log("申込状況レコードから申込まれた日時の人数を確認する")
                                }
                            }else{
                                // 定員の扱いが時間帯ごとの場合は開催日・開催時間が合致したら
                                if(jyokyo["kaisai_date"] == value.check_date 
                                    && jyokyo["jikantai_start"] == value.jikantai_start
                                    && jyokyo["jikantai_end"] == value.jikantai_end){
                                    // 合致した条件の人数を加算する
                                    value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                                }
                            }
                        })
                    nittei_count++
                    }
                });
            }
        }

        // 日程ごとに選択する場合、1日目の参加人数を取得（1日目の人数＝他の日付の人数と同じ）
        for(let s2 = 0;s2<sub_set_nittei_list.value[s].length;s2++){
            sub_set_nittei_list.value[s][s2]["ninzu"] = 0
            jisseki_all[s+1].forEach(function(jyokyo) {
                // 申込める日時配列内を、申込状況レコードの開催日・開催時間（自）でフィルター検索
                if(jyokyo["kaisai_date"] == sub_set_nittei_list.value[s][s2]["kaisai_start"] 
                    && jyokyo["jikantai_start"] == sub_set_nittei_list.value[s][s2]["jikantai_start"]){
                        // 合致した条件の人数を加算する
                        sub_set_nittei_list.value[s][s2]["ninzu"] = jyokyo["ninzu"]
                }
            });
        }

    }
            console.log("ここからカレンダー")
    
    Sub_Calendar_set(KatsudouActive_no.value)
    // ローディングアイコンストップ
    emit('call',{ cmd:'loading_end_noreload' })
  }


  // カレンダーを表示する（活動２～）
  let Sub_Calendar_set = function(program_num){
    
     let all_sub_calendar = ""
     let all_sub_calendarSp = ""
     
    console.log("program_num:"+program_num)
    console.log(sub_nittei_list.value)
     
    // サブプログラムの数だけ日程データがある
    for(let s = 0;s<sub_nittei_list.value.length;s++){

        if(s != program_num) continue;       

        let calendarHtml = '' // HTMLを組み立てる変数
        let spHtml = ''
      
      let add_flg = 0

      console.log(moushikomi_list_sub.value[s])

      
      // 日程ごとに処理する
      for(let m = 0;m<moushikomi_list_sub.value[s].length;m++){
        
        let check_array = []
        if(select_date_sub.value[s][m]){
            check_array = select_date_sub.value[s][m]
        }

        console.log(select_date_sub.value[s][m])
        console.log(NitteiActive.value+"/"+m)

        // 選択した日程ならカレンダーに写す
  //      if(NitteiActive.value == m) {    

            console.log(moushikomi_list_sub.value[s][m].length)
            
            if(moushikomi_list_sub.value[s][m].length == 0){
                
                all_sub_calendar += '<br>選択できる日程がありません。' // HTMLを組み立てる変数
                all_sub_calendarSp += '<br>選択できる日程がありません。'
        
            }else{
                    
            add_flg = 1  
                    const date = new Date(sub_calendar_year[s][m],sub_calendar_month[s][m],1)
                    const year = date.getFullYear()
                    const month = date.getMonth() 

                    console.log(date)

                    const startDate = new Date(year, month - 1, 1) // 月の最初の日を取得
                    const endDate = new Date(year, month,  0) // 月の最後の日を取得
                    const endDayCount = endDate.getDate() // 月の末日
                    const startDay = startDate.getDay() // 月の最初の日の曜日を取得
                    let dayCount = 1 // 日にちのカウント
                    
                    
                    // キャンセル待ち機能を利用する場合
                    if(cancel_setting == 0){
                        calendarHtml += '<div style="fonr-weight:700;width:100%;padding:10px 10px 0;text-align:left">※ 赤表示は<span style="color:red">キャンセル待ち人数</span>になります。</div>'
                        spHtml += '<div style="padding-top:10px">※ 赤（<span style="color:red">▲</span>）はキャンセル待ちです。</div>'

                    }
                    calendarHtml += '<div id="calendar_button_area">';
                        
                    calendarHtml += '<div id="sub_month_change_prev,'+s+','+m+'" class="month_change">＜＜前月</div>'+
                                        '<div><h2 style="margin:0">'+(sub_calendar_month[s][m])+' 月</h2></div>'+
                                        '<div id="sub_month_change_next,'+s+','+m+'" class="month_change">翌月＞＞</div>'+
                                    '</div>'+
                                    '<div id="title_area" style="border-bottom: 1px solid #000;">'+
                                        '<div class="list_column_header calendar_column_left" style="color: red;">日</div>'+
                                        '<div class="list_column_header calendar_column">月</div>'+
                                        '<div class="list_column_header calendar_column">火</div>'+
                                        '<div class="list_column_header calendar_column">水</div>'+
                                        '<div class="list_column_header calendar_column">木</div>'+
                                        '<div class="list_column_header calendar_column">金</div>'+
                                        '<div class="list_column_header calendar_column_right" style="color:blue">土</div>'+
                                    '</div></div>'
                    
                    spHtml += '<div id="calendar_button_area">';
                    spHtml += '<div id="sub_month_change_prev,'+s+','+m+'" class="month_change">＜＜前月</div>'+
                                '<div><h2 style="margin:0">'+(sub_calendar_month[s][m])+' 月</h2></div>'+
                                '<div id="sub_month_change_next,'+s+','+m+'" class="month_change">翌月＞＞</div>'+
                                '</div>'+
                                '<div id="title_area" style="border-bottom: 1px solid #000;">'+
                                    '<div class="list_column_header calendar_column_left" style="color: red;">日</div>'+
                                    '<div class="list_column_header calendar_column">月</div>'+
                                    '<div class="list_column_header calendar_column">火</div>'+
                                    '<div class="list_column_header calendar_column">水</div>'+
                                    '<div class="list_column_header calendar_column">木</div>'+
                                    '<div class="list_column_header calendar_column">金</div>'+
                                    '<div class="list_column_header calendar_column_right" style="color:blue">土</div>'+
                                '</div></div>'

                // リスト全体の番号を割り振る
                for(let i = 0;i<moushikomi_list_sub.value[s][m].length;i++){
                    moushikomi_list_sub.value[s][m][i].all_count = i
                }

                for (let w = 0; w < 6; w++) {

                    // 1週間のうち、日付を入れたカラムを判定する
                    let setCount = 0

                    // PC用とスマホ用の2つを用意
                    let set_html = '<div id="calendar_column_area" >'
                    let set_sp_html = '<div id="calendar_column_area" >'

                    for (let d = 0; d < 7; d++) {
                        // 時間帯をいくつ配置したか
                        let datetime_count = 0
                        set_html += '<div class="'
                        set_sp_html += '<div class="'
                        if(d == 0) {
                            set_html += 'calendar_column_left'
                            set_sp_html += 'calendar_column_left'
                        }else if(d == 6){
                            set_html += 'calendar_column_right'
                            set_sp_html += 'calendar_column_right'

                        }else{
                            set_html += 'calendar_column'
                            set_sp_html += 'calendar_column'
                        }
                        set_html += '" style="height:100px">'
                        if (w == 0 && d < startDay) {
                            set_sp_html += '">'
                            // 1行目で1日の曜日の前
                            set_html += '<div class="column_date_blank"></div>'
                            set_sp_html += '<div class="column_date_blank"></div>'
                        } else if (dayCount > endDayCount) {
                            set_sp_html += '">'
                            // 末尾の日数を超えた
                            set_html += '<div class="column_date_blank"></div>'
                            set_sp_html += '<div class="column_date_blank"></div>'
                        } else {
                            // 申込リスト内に日付がある場合は申込まれた人数を表示
                            // 現在表示する日付をセット
                            let setDate = sub_calendar_year[s][m]+"-"+('00'+(sub_calendar_month[s][m])).slice(-2)+"-"+('00'+dayCount).slice(-2)
                            let checkHoliday = sub_calendar_year[s][m]+"/"+sub_calendar_month[s][m] + "/"+ dayCount
                            
                            set_sp_html += '"'
                            set_sp_html += ' id="'+setDate+s+m+'"'
                            // スマホの場合はここで、選択した日付が存在するなら背景色を変える
                            if(check_array.findIndex(({kaisai_date}) => kaisai_date == setDate) != -1){
                                set_sp_html += 'style="background-color:#AFA;"'
                            }
                            set_sp_html += '>'

                            // 日付を入力
                            set_html += '<div class="column_date">'
                            
                            set_sp_html += '<div class="column_date"  ';
                            set_sp_html += '>'

                            set_html += '<div class="column_date_day"><span '
                            set_sp_html += '<div class="column_date_day" ><span '
                            // 祝 or 日なら赤
                            if(holidays_list.includes(checkHoliday) || d == 0){
                            set_html += "style='color:red'"
                            set_sp_html += "style='color:red'"
                            }else if(d == 6){
                            // 土なら青
                            set_html += "style='color:blue'"
                            set_sp_html += "style='color:blue'"
                            }
                        
                            set_html += '/>'
                            set_sp_html += '/>'
                        
                            set_html +=  dayCount
                            set_sp_html +=  dayCount
                            
                            set_html += '</span></div>'
                            set_sp_html += '</span></div>'

                            let before_date = 0
                            moushikomi_list_sub.value[s][m].filter( function (value) {
                            // 申込める日付リストに存在していたら時間帯（PC）or申込可不可マーク（スマホ）を表示
                                if(setDate == value.check_date ){
                                // 申込人数 / 定員は定員の扱いが「1日ごと」なら時間帯の上に1つだけ表記
                                if(sub_list.value[s].teiin_settei == 1 && datetime_count == 0){
                                    
                                        set_html += " <b style='"
                                        // 申込人数が定員より少ないときは青色
                                        if(value.ninzu < sub_list.value[s].teiin_oneday){
                                            set_html += "color:blue"
                                        }else{// 申込人数が定員のときは赤色
                                            set_html += "color:red"
                                        }
                                        set_html += "'>"
                                        set_html += value.ninzu
                                        
                                        // 定員がnullの場合は表示しない
                                        if(sub_list.value[s].teiin_oneday!= null){
                                        set_html +=  "/"+ sub_list.value[s].teiin_oneday
                                        }
                                        set_html += '</b>'
                                        datetime_count++
                                }
                                
                                set_html += '<div class="column_date_time">'
                                // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        set_sp_html += '<div class="column_date_time" >'
                                    }
                                    // 参加日がある（申込OK）かどうか
                                    let check_moushikomi_flg = 0
                                    if(sub_list.value[s].nittei_sentaku == 0){
                                        // 日程選択が1日なら1日ごとの申込状況をチェック
                                        check_moushikomi_flg = value.moushikomi_flg
                                    }else{
                                        // 日程選択が日程なら日程全体の申込状況をチェック
                                        if(sub_set_nittei_list.value[s][m]?.all_sanka_ok) {
                                            check_moushikomi_flg = sub_set_nittei_list.value[s][m].all_sanka_ok
                                        }else{
                                            check_moushikomi_flg = 0
                                        }
                                    }
                                        console.log(sub_list.value[s].nittei_sentaku+"/"+JSON.stringify(sub_set_nittei_list.value[s][m]?.all_sanka_ok))
                                        console.log(check_moushikomi_flg)

                                    // 未ログイン・未ユーザー登録の場合
                                if(mode.value == 'nologin' || mode.value == 'noinfo' ){
                                    // PCの場合は時間帯と人数を表示
                                    set_html += '<div >'
                                    set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)
                                    
                                    // 定員は、「定員の扱い」が「時間帯ごと」なら時間帯の後に表記
                                    if(sub_list.value[s].teiin_settei == 0){
                                        set_html += " <b style='font-size:15px;margin-left:10px;"
                                        
                                        // 申込人数が定員より少ないときは青色
                                        if(value.ninzu < value.teiin){
                                            set_html += "color:blue"
                                        }else{// 申込人数が定員のときは赤色
                                            set_html += "color:red"
                                        }
                                        
                                        set_html += "'>"
                                        // 申込人数 / 定員
                                            let nokori_ninzu = (value.teiin - value.ninzu)

                                            // 満員の場合は0に補正
                                            if(nokori_ninzu < 0){
                                                nokori_ninzu = 0
                                            }
                                            if(value.teiin < 999){
                                                // 満員の場合
                                                if(nokori_ninzu == 0){
                                                    // キャンセル待ち機能を利用する場合はキャンセル待ち人数を表示
                                                    if(cancel_setting == 0){
                                                        set_html += parseInt(value.ninzu - value.teiin + 1) 
                                                        
                                                    }else{
                                                        // キャンセル待ち機能を利用しない場合はこちら
                                                        set_html += "0"
                                                    }
                                                }else{
                                                    // 残り申込可能人数を表示
                                                    set_html += nokori_ninzu
                                                }
                                            }
                                    }

                                    // 定員がnullの場合は表示しない
                                    /*
                                    if(value.teiin != null){
                                        set_html +=  "/"+ value.teiin
                                    }*/
                                    set_html += '</b></div>'

                                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        // スマホの場合は申込可不可（● or ×）を表示
                                        set_sp_html += '<div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;" ';   
                                        if(value.ninzu < value.teiin){
                                            //set_sp_html += 'id="'+setDate+'"';
                                        }
                                        set_sp_html += '>'
                                        set_sp_html += " <img style='width:50%' src='../../../img/"
                                        
                                        // 申込人数が定員より少ないときは青色の「●」
                                        if(value.ninzu < value.teiin){
                                            set_sp_html += "OK.png' id='"+setDate+","+s+","+m+"'/>"
                                        }else{// 申込人数が定員のとき
                                            // キャンセル待ち機能を利用するなら●のときと同様にIDを付け、画像はキャンセル待ち用（▲）とする
                                            if(cancel_setting == 0){
                                                set_sp_html += "wait_cancel.png'"
                                                set_sp_html += " id='"+setDate+","+s+","+m+"' "
                                            }else{
                                                // キャンセル待ち機能を利用しない場合は、赤色の「ー」とする（選択不可）
                                                set_sp_html += "NG.png'"
                                            }

                                            set_sp_html += "/>"
                                        }
                                        
                                        set_sp_html += '</div>'
                                    }
                                }else 
                                // 他に申込んでいるプログラムがないなら時間帯（PC）or申込可不可マーク（スマホ）を表示
                                if(check_moushikomi_flg == 0){
                                    // PCの場合は時間帯を表示し、日付をクリックできるかどうかを判定する
                                    set_html += '<div class="set_id'+s+m+value.all_count+'"';
                                    if(sub_list.value[s].nittei_sentaku == 0){
                                        // 日程の選択が1日ごとの場合
                                        set_html += 'id="'+value.all_count+','+value.check_date+','+value.jikantai_start+','+value.jikantai_end+','+value.ninzu+','+value.teiin+','+value.date_bango+',jikantai_click,'+s+','+m+'"'
                                        set_html += 'style="display: flex;align-items: center;'
                                        // カレンダー表示時、選択した日付が存在するなら背景色を変える
                                        if(check_array.findIndex(({bango}) => bango == value.all_count) != -1){
                                            set_html += "background-color:#AFA;"
                                        }
                                    }else{
                                        // 日程の選択が日程ごとの場合
                                        set_html += 'id="nittei_click,'+s+','+m+'"'
                                        set_html += 'style="display: flex;align-items: center;'
                                        // カレンダー表示時、選択した日時が存在するなら背景色を変える
                                        if(check_array.findIndex(({kaisai_date}) => kaisai_date == value.check_date) != -1){
                                            if(check_array.findIndex(({jikantai_start}) => jikantai_start == value.jikantai_start) != -1){
                                                set_html += "background-color:#AFA;"
                                            }
                                        }
                                    }
                                    
                                    
                                    // カレンダー表示時、選択した日付が存在するなら背景色を変える
                                    if(check_array.findIndex(({bango}) => bango == value.all_count) != -1){
                                        set_html += "background-color:#AFA;"
                                    }

                                    // 申込人数が定員より少ないとき、または満員でもキャンセル待ち機能を利用するときは下線とカーソルを入れる（クリック可能なことを強調）
                                    if((value.ninzu < value.teiin) || cancel_setting == 0){
                                        set_html += "cursor:pointer;border-bottom:1px solid #000;"
                                    }

                                    set_html += '">'
                                    set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)

                                    // 定員は、「定員の扱い」が「時間帯ごと」なら時間帯の後に表記
                                    if(sub_list.value[s].teiin_settei == 0){
                                        set_html += " <b style='font-size:15px;margin-left:10px;"
                                        
                                        // 申込人数が定員より少ないときは青色
                                        if(value.ninzu < value.teiin){
                                            set_html += "color:blue"
                                        }else{// 申込人数が定員のときは赤色
                                            set_html += "color:red"
                                        }
                                        
                                        set_html += "'>"
                                        // 申込人数 / 定員
                                            let nokori_ninzu = (value.teiin - value.ninzu)

                                            // 満員の場合は0に補正
                                            if(nokori_ninzu < 0){
                                                nokori_ninzu = 0
                                            }
                                            if(value.teiin < 999){
                                                // 満員の場合
                                                if(nokori_ninzu == 0){
                                                    // キャンセル待ち機能を利用する場合はキャンセル待ち人数を表示
                                                    if(cancel_setting == 0){
                                                        set_html += parseInt(value.ninzu - value.teiin + 1) 
                                                        
                                                    }else{
                                                        // キャンセル待ち機能を利用しない場合はこちら
                                                        set_html += "0"
                                                    }
                                                }else{
                                                    // 残り申込可能人数を表示
                                                    set_html += nokori_ninzu
                                                }
                                            }
                                    }
                                    
                                    set_html += '</b></div>'

                                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        // スマホの場合は申込可不可（● or ×）を表示し、選択できるかどうかを判定する
                                        // ※キャンセル待ち機能を利用する場合はどちらにせよ選択可能とする
                                        set_sp_html += '<div class="set_id'+value.all_count+'" ';
                                        console.log(value.ninzu +"/"+ value.teiin + "|"+cancel_setting)
                                        if((value.ninzu < value.teiin) || cancel_setting == 0){
                                            set_sp_html += 'id="'+setDate+'"';
                                        }
                                        set_sp_html += 'style="width:100%;height: 100%;display: flex;align-items: center;justify-content: center;'
                                        
                                        
                                        set_sp_html += '">'
                                        set_sp_html += " <img style='width:50%' src='../../../img/"
                                        
                                        // 申込人数が定員より少ないときは青色の「●」
                                        if(value.ninzu < value.teiin){
                                            set_sp_html += "OK.png'  id='"+setDate+","+s+","+m+"'/>"
                                        
                                        }else{// 申込人数が定員のとき
                                            // キャンセル待ち機能を利用するなら●のときと同様にIDを付け、画像はキャンセル待ち用（▲）とする
                                            if(cancel_setting == 0){
                                                set_sp_html += "wait_cancel.png'"
                                                set_sp_html += " id='"+setDate+","+s+","+m+"' "
                                            }else{
                                                // キャンセル待ち機能を利用しない場合は、赤色の「ー」とする（選択不可）
                                                set_sp_html += "NG.png'"
                                            }
                                            set_sp_html += "/>"
                                        }
                                        
                                        set_sp_html += '</div>'
                                    }
                                    
                                }else{

                                    console.log(check_moushikomi_flg)

                                    // 申込済みの場合、PCは申込済みであることを明記する
                                    set_html += '<span style="color:red">'
                                    if(check_moushikomi_flg == 100){
                                    set_html += 'このプログラムの参加日'
                                    }else if(check_moushikomi_flg == 1){
                                    set_html += '申込済(体験)'
                                    }else if(check_moushikomi_flg == 2){
                                    set_html += '申込済(事前)'
                                    }else{
                                    set_html += '申込済(事後)'
                                    }
                                    set_html += '</span>'
                                    
                                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                    if(value.check_date != before_date){
                                        // スマホは×を表示
                                        set_sp_html += " <img style='width:50%' src='../../../img/NG.png'>"
                                    }
                                }
                                set_html += '</div>'
                                
                                // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                                if(value.check_date != before_date){
                                set_sp_html += '</div>'
                                }

                                // 表示中の日付を取得
                                before_date = setDate
                                // 日付ごとの時間帯カウントを加算
                                datetime_count++
                            }
                            })
                            datetime_count = 0
                            set_html += '</div>'
                            set_sp_html += '</div>'

                            dayCount++
                            setCount++
                            }
                            datetime_count = 0
                            set_html += '</div>'
                            set_sp_html += '</div>'
                        }
                        set_html += '</div>'
                        set_sp_html += '</div>'

                        // 日付の入ったカラムが1個でもあれば行として追加
                        if(setCount !=0){
                            calendarHtml += set_html
                            spHtml += set_sp_html
                        }
                    }

            }
       // }
      }

      console.log(add_flg)


        all_sub_calendar += calendarHtml
        all_sub_calendarSp += spHtml
    }


    Calendar_sub.value = all_sub_calendar
    CalendarSp_sub.value = all_sub_calendarSp
    
  }
  
  // カレンダーの月を加算・減算し、再度カレンダーを表示する（活動２～）
  let Sub_Change_month = function(num,program_num,nittei){
    // 指定したプログラムナンバーの月を処理する
 
    sub_calendar_month[program_num][nittei] = sub_calendar_month[program_num][nittei] + num
    if(sub_calendar_month[program_num][nittei] == 0) {
        sub_calendar_month[program_num][nittei] = 12
        sub_calendar_year[program_num][nittei] = sub_calendar_year[program_num][nittei] - 1
    }
    if(sub_calendar_month[program_num][nittei] == 13) {
        sub_calendar_month[program_num][nittei] = 1
        sub_calendar_year[program_num][nittei] = sub_calendar_year[program_num][nittei] + 1
    }
    Sub_Calendar_set(program_num)
  }

  // v-html内の要素をクリックした時（PC：活動2～）
  let sub_htmlColumnClick = function(e){

    let clicked = e.target.id

    if(clicked == "") return

    let Click_array = clicked.split(",")
      if(Click_array[0] == "sub_link_katsudou_cal"){
        // 別の活動に移動する
        link_katsudou_cal(Click_array[1],Click_array[2])
        }else if(Click_array[0] == "sub_link_katsudou_cal_nittei"){
        // 活動内の別の日程に移動する
        link_katsudou_cal_nittei(Click_array[1],Click_array[2],Click_array[3])
      }else if(Click_array[0] == "sub_month_change_prev"){
        // カレンダーの月を1つ戻す
        Sub_Change_month(-1,Click_array[1],Click_array[2])
      }else if(Click_array[0] == "sub_month_change_next"){
        // カレンダーの月を1つ進める
        Sub_Change_month(1,Click_array[1],Click_array[2])
      }else if(Click_array[0] == "nittei_click"){
        // 日程ごとの選択の場合で、カレンダーを選択した時
        Sub_Set_list_click(Click_array[1],Click_array[2],2)
      }else if(Click_array[7] == "jikantai_click"){
          Sub_Set_id(Click_array[1],Click_array[2],Click_array[3],Click_array[0],2,Click_array[6],Click_array[8],Click_array[9],Click_array[5],Click_array[4])
      }

  }
  // v-html内の要素をクリックした時（スマホ：活動2～）
  let sub_htmlColumnClickSp = function(e){

    let clicked = e.target.id

    if(clicked == "") return

    let Click_array = clicked.split(",")
      if(Click_array[0] == "sub_link_katsudou_cal"){
        // 別の活動に移動する
        link_katsudou_cal(Click_array[1],Click_array[2])
        }else if(Click_array[0] == "sub_link_katsudou_cal_nittei"){
        // 活動内の別の日程に移動する
        link_katsudou_cal_nittei(Click_array[1],Click_array[2],Click_array[3])
      }else if(Click_array[0] == "sub_month_change_prev"){
        // カレンダーの月を1つ戻す
        Sub_Change_month(-1,Click_array[1],Click_array[2])
      }else if(Click_array[0] == "sub_month_change_next"){
        // カレンダーの月を1つ進める
        Sub_Change_month(1,Click_array[1],Click_array[2])
      }else {
        // 日程選択ウィンドウを開く
        let disp_moushikomi_time = []
        let disp_moushikomi_nittei = {}
        let moushikomi_OK_count = 0
        if(Click_array[1]){
            if(sub_list.value[Click_array[1]].nittei_sentaku == 0){
                for(let m = 0;m<moushikomi_list_sub.value[Click_array[1]][Click_array[2]].length;m++){
                    // 選択した日が申込日に存在するかどうか
                    if(moushikomi_list_sub.value[Click_array[1]][Click_array[2]][m].check_date == Click_array[0]){
                        disp_moushikomi_time[disp_moushikomi_time.length] = moushikomi_list_sub.value[Click_array[1]][Click_array[2]][m]
                        moushikomi_OK_count++
                    }
                }
            }else{
                if(Click_array[1]){
                    disp_moushikomi_nittei = sub_set_nittei_list.value[Click_array[1]][Click_array[2]]
                    disp_moushikomi_time[disp_moushikomi_time.length] = moushikomi_list_sub.value[Click_array[1]][Click_array[2]]
                    moushikomi_OK_count++
                    moushikomi_OK_count++
                }
                
            }
            // 申込める日があるならウィンドウを開く
            if(moushikomi_OK_count != 0){
                smart_calendar_area.value = true
                paramCalendar = {"set_nittei_list":disp_moushikomi_nittei,
                                "nittei_sentaku":sub_list.value[Click_array[1]].nittei_sentaku,
                                "teiin_oneday":sub_list.value[Click_array[1]].teiin_oneday,
                                "teiin_settei":sub_list.value[Click_array[1]].teiin_settei,
                                "clicked":Click_array[0],
                                "moushikomi":disp_moushikomi_time,
                                "select_date":select_date_sub.value[Click_array[1]][Click_array[2]],
                                "mode":mode.value,
                                "katsudou_no":Click_array[1],
                                "nittei_no":Click_array[2],
                                "katsudou":"sub",
                                "cancel_setting":cancel_setting}
                contentCalendar.value = UserCalendarSmart
            }
        }
    }
  }

  
  // 選択した日時を保存
  let Sub_Set_id = function(kaisai_date0,jikantai_start0,jikantai_end0,num,set_type,date_bango,katsudou_no,nittei_no,teiin0,ninzu0){

    // ログイン中かつユーザー登録済みの場合のみ選択可能
    if(mode.value == 'sel'){
        let set_list = {"bango":num,"date_bango":date_bango,
                        "nittei_group":nittei_no,
                        "kaisai_date":kaisai_date0,"jikantai_start":jikantai_start0,"jikantai_end":jikantai_end0,"teiin":teiin0,"ninzu":ninzu0}

        let set_back_color = "#AFA"


        // 配列内に選択した番号があるかどうか
        // 番号が存在しない場合は追加
        let check_array = []
        let other_array = select_date_sub.value[katsudou_no]

        
       for(let o = 0 ;o<select_date_sub.value[katsudou_no].length;o++){
            let check_date = select_date_sub.value[katsudou_no][o]
            for(let c = 0;c<check_date.length;c++){
                console.log(check_date[c])
                check_array.push(check_date[c])
            }
       }
       /*
        if(select_date_sub.value[katsudou_no][nittei_no]){
            check_array = select_date_sub.value[katsudou_no][nittei_no]
        }*/
        if(check_array.findIndex(array => array.bango == num && array.nittei_group == nittei_no) == -1){

            // 定員の扱いが1日ごとの場合
            if(sub_list.value[katsudou_no].teiin_settei == 1){
                console.log("選択した日付番号"+date_bango)
                // 同じ日付番号が存在する場合はいったん削除
                for(let d = 0;d < select_date_sub.value[katsudou_no][nittei_no].length;d++){
                    if(select_date_sub.value[katsudou_no][nittei_no][d].date_bango == date_bango){
                        select_date_sub.value[katsudou_no][nittei_no].splice(d,1)
                    }
                }
                
            }
            
            // 選択できる最大日数
            let max_day = sub_list.value[katsudou_no].nissu_max

            // リストに値が入力済みの場合はチェックを挟む
            if(check_array.length != 0){
                // 現在の選択日数＋1日が最大日数を超える場合
                if(max_day == check_array.length){
                
                    message.value = max_day+"日以上は選択できません。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal
                    return
                }
            }

           
            // 同じ活動内の他の日程で、同じ日が選択されている場合は選択不可
            let set_ng = 0
            if(check_array.length > 0){
                for(let o = 0;o<check_array.length;o++){
                    let nittei = check_array[o]
                    if(nittei["kaisai_date"] == kaisai_date0){
                        set_ng = 1
                    }
                }
            }

            if(set_ng == 1){
                message.value = "同じ活動内の他の日程でこの日付が選択されています。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "nissu_error";
                contentMessage.value = MessageModal
                return
            }else{
                select_date_sub.value[katsudou_no][nittei_no].push(set_list)
            }
        }else{

            // 番号が存在する場合は削除
            for(let d = 0;d < select_date_sub.value[katsudou_no][nittei_no].length;d++){
                if(select_date_sub.value[katsudou_no][nittei_no][d].bango == num){
                    select_date_sub.value[katsudou_no][nittei_no].splice(d,1)
                }
            }
            set_back_color = "#FFF"
        }


        // IDを元に背景色を変更
        if(set_type == 1){
            // set_type = 1（リストをクリック）
            let obj = document.getElementById('set_id'+katsudou_no+nittei_no+num)
            obj.style.backgroundColor = set_back_color
        }else if(set_type == 2){
            // set_type = 2（カレンダー（PC）をクリック）
            let obj = document.getElementsByTagName("*")

            for(let o in obj){
                if(obj[o].className == 'set_id'+katsudou_no+nittei_no+num){
                    obj[o].style.backgroundColor = set_back_color
                }
            }
        }else if(set_type == 3){
            // set_type = 3（カレンダー（スマホ）で選択
            let obj = document.getElementById(kaisai_date0+katsudou_no+nittei_no)
            obj.style.backgroundColor = set_back_color
        }
    }
}


  
  // 表示用の日程をセッティングする
  let disp_nittei_list_setting = function(){
    // 初期化
    disp_nittei_list.value = [] 
    // 日程レコードに日程セットNo.を格納
    let once_list = []
    let before_no = 1
    for(let n = 0;n<nittei_list.value.length;n++){
      if(n != 0 && nittei_list.value[n]["nittei_set_no"] != before_no){
        disp_nittei_list.value[disp_nittei_list.value.length] = once_list
        once_list = []
      }
      once_list[once_list.length] = nittei_list.value[n]
      before_no = nittei_list.value[n]["nittei_set_no"]

      if((n+1) == nittei_list.value.length){
        disp_nittei_list.value[disp_nittei_list.value.length] = once_list
      }
    }
    
    // 初期化
    sub_disp_nittei_list.value = [] 
    
    // サブ
    for(let s = 0;s<sub_nittei_list.value.length;s++){
      // プログラムごとの日程を入れる配列
      
      let sub_nittei = sub_nittei_list.value[s]
      let set_list = []

      //
      // 日程レコードに日程セットNo.を格納
      let once_list = []
      let before_no = 1
      for(let n = 0;n<sub_nittei.length;n++){
        if(n != 0 && sub_nittei[n]["nittei_set_no"] != before_no){
          set_list[set_list.length] = once_list
          once_list = []
        }
        once_list[once_list.length] = sub_nittei[n]
        before_no = sub_nittei[n]["nittei_set_no"]

        if((n+1) == sub_nittei.length){
          set_list[set_list.length] = once_list
        }
      }

      sub_disp_nittei_list.value[sub_disp_nittei_list.value.length] = set_list 
    }


    for(let d = 0;d<disp_nittei_list.value.length;d++){
        select_date.value[d] = []
    }
    for(let d = 0;d<sub_disp_nittei_list.value.length;d++){
        for(let d2 =0;d2<sub_disp_nittei_list.value[d].length;d2++){
            select_date_sub.value[d][d2] = [] 
        }
    }
  }
    
    // 申込画面に送る、選択した申込日
    let send_main_array = []
    let send_sub_array = []

    // 格納したサブ（参加対象となるもののみ）
    let send_sub_katsudou = []
    
    // 指定した日付で申込む
    const moushikomi_set = function(){

        emit('call',{ cmd:'page_scroll' })

        console.log(taiken_list.value.shubetsu)
        
        if(taiken_list.value.shubetsu == 1){
            
            // 施設・地域活動の場合は日程一覧タブへ移動
            if(TabActive.value == 'tab_detail'){
                TabSelect('tab_list')
                return
            }
        }

        if(mode.value == 'nologin' ){
            message.value = "申込みにはログインが必要です。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "login_error";
            contentMessage.value = MessageModal
            return
        }
        
        if(mode.value == 'noinfo' ){
            message.value = "申込みの前にユーザー情報（プロフィール）の登録を行ってください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "user_error";
            contentMessage.value = MessageModal
            return
        }

        // 配列初期化
        // 申込画面に送る、選択した申込日
        send_main_array = []
        send_sub_array = []

        // 格納したサブ（参加対象となるもののみ）
        send_sub_katsudou = []
    
        // 施設・地域活動の場合
        if(taiken_list.value.shubetsu == 1){
            
            let message_error = ""
            let main_add_ok = 0 // 選択日の配列の長さ。1日でも選択されていれば条件の判定を行う
            let main_add_banchi = 100 // 活動1において日程を利用する番地。100は存在しないことを表す
            let sub_add_banchi = [] // 活動2以降において日程を利用する番地の配列（[0,100,100…]と格納）。100は存在しないことを表す
            let sub_hissu_flg_list = []


            // 活動1の場合
            for(let m = 0;m<select_date.value.length;m++){
                if(main_add_ok < select_date.value[m].length){
                    main_add_ok = select_date.value[m].length

                    // 日付の入っている配列の番地を格納
                    main_add_banchi = m
                }
            }


            // 日程選択の有無について判定
            if(main_add_ok == 0){
                // 活動1の日程が1つも選択されていない上に、ほかの活動（2～）が存在しない場合は問答無用でエラー
                if(sub_list.value.length == 0){
                    message_error += "日程を選択してください。";
                }else{
                    // ほかの活動（2～）が存在する場合
                    // 活動1が参加必須であれば選択されていなければならない
                    if(taiken_list.value.hissu_flg == 1){
                        message_error += "【活動1】の日程は必ず選択してください。";

                    }

                    // ほかの活動（2～）においての選択日の配列の長さ
                    let all_sub_add_ok = 0

                    // ほかの活動（2～）以降も選択されているかチェック
                    for(let s = 0;s<sub_list.value.length;s++){
                        let sub = sub_list.value[s]
                        let sub_add_ok = 0
                        sub_add_banchi[s] = 100
                        for(let m = 0;m<select_date_sub.value[s].length;m++){
                            if(sub_add_ok < select_date_sub.value[s][m].length){
                                sub_add_ok = select_date_sub.value[s][m].length

                                // 日付の入っている配列の番地を格納
                                sub_add_banchi[s] = m
                            }
                        }

                        if(sub.hissu_flg == 1){
                            // 参加必須なのに何も選択されていなければエラー
                            if(sub_add_ok == 0){
                                if(message_error != "") message_error += "<br>"
                                message_error += "【活動"+(s+2)+"】の日程は必ず選択してください。";
                            }
                        }

                        // 必須フラグを格納
                        sub_hissu_flg_list[s] = sub.hissu_flg

                        if(all_sub_add_ok < sub_add_ok){
                            all_sub_add_ok = sub_add_ok
                        }
                    }

                    // 活動1だけではなく活動2以降も全く選択されていない場合はエラー
                    // 必須選択エラーの方が優先なので、エラーメッセージがない場合のみ入力
                    if(all_sub_add_ok == 0 && message_error == ""){
                        message_error += "日程を選択してください。";
                    }
                }
            }else{

                
                // 活動1が選択されていたら、活動2以降は参加の義務のものをチェックする
                for(let s = 0;s<sub_list.value.length;s++){
                    let sub = sub_list.value[s]
                    let sub_add_ok = 0
                    sub_add_banchi[s] = 100
                    for(let m = 0;m<select_date_sub.value[s].length;m++){
                        if(sub_add_ok < select_date_sub.value[s][m].length){
                            sub_add_ok = select_date_sub.value[s][m].length

                            // 日付の入っている配列の番地を格納
                            sub_add_banchi[s] = m
                        }
                    }

                    if(sub.hissu_flg == 1){
                        // 参加必須なのに何も選択されていなければエラー
                        if(sub_add_ok == 0){
                            if(message_error != "") message_error += "<br>"
                            message_error += "【活動"+(s+2)+"】の日程は必ず選択してください。";
                        }
                    }
                    // 必須フラグを格納
                    sub_hissu_flg_list[s] = sub.hissu_flg
                }
            }


            // エラーメッセージが入力されていたら（＝日程が何も選択されていない場合は）中断
            if(message_error != ""){
                message.value = message_error
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "nissu_error";
                contentMessage.value = MessageModal
                return
            }

            // 活動2以降が存在するならチェック
            if(sub_list.value.length != 0){
                
                // 必須活動に関する選択で特にエラーがなかったら下記をチェック
                if(message_error == ""){

                    // 条件付き・必須のどちらかが選択されているかどうか。されていたら0とする
                    let joken_error = 1

                    let all_nini = 0

                    // 必須フラグが「0（任意）以外」が存在するかどうか、存在する場合はその「条件付き or 必須」活動が選択されているかどうかチェック
                    if(taiken_list.value.hissu_flg != 0){
                        // 番地が100のまま（選択無）なら条件付き未選択 or 必須未選択エラー
                        if(main_add_banchi != 100) joken_error = 0
                            all_nini = taiken_list.value.hissu_flg

                    }

                    // 活動2以降は配列で回す
                    for(let s = 0;s<sub_list.value.length;s++){
                        let sub = sub_list.value[s]

                        // 任意以外の場合
                        if(sub.hissu_flg != 0){
                            // 番地が100のまま（選択無）なら条件付き未選択 or 必須未選択エラー
                            if(sub_add_banchi[s] != 100)  joken_error = 0
                            all_nini = sub.hissu_flg
                        }

                    }

                    // 全部任意ならそのまま通す
                    if(all_nini == 0) joken_error = 0
                    // エラーフラグが立っていたらメッセージを追加
                    if(joken_error == 1){
                        message_error += "「条件付き」の活動は、どれか1つ必ず参加してください。";

                    }
                }
            }

            // エラーメッセージが入力されていたら（＝条件付き日程が何も選択されていない場合は）中断
            if(message_error != ""){
                message.value = message_error
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "nissu_error";
                contentMessage.value = MessageModal
                return
            }

            // 入力された日程のチェックを行う
            // 活動1の判定
            if(main_add_ok != 0){
                    let check_array = []
                    for(let s = 0;s<select_date.value.length;s++){
                        let set_date = select_date.value[s]
                        for(let c = 0 ; c < set_date.length; c++){
                            check_array.push(set_date[c])
                        }
                    }
                    console.log(check_array)
                    // 要素が2つ以上ある場合は番号順→日程グループで並び替え
                    if(check_array.length != 1){
                        check_array.sort((a, b) => a.bango - b.bango);
                        check_array.sort((a, b) => a.nittei_group - b.nittei_group);
                    }

                // 日程の選択が1日ごとである場合は、選んだ日付が日数の範囲内かチェックする
                if(taiken_list.value.nittei_sentaku == 0){

                    // 選択できる最小日数
                    let min_day = taiken_list.value.nissu_min
                    // 選択できる最大日数
                    let max_day = taiken_list.value.nissu_max

                    if(min_day == null || min_day == ""){
                        min_day = 1
                    }
                    if(max_day == null || max_day == ""){
                        max_day = 99
                    }

                    // 最大日数と最小日数が同じ場合
                    if(max_day == min_day){
                        // 選択した日数が最大日数に満たない場合はエラー
                        if(check_array.length < max_day){
                            if(sub_list.value.length != 0){
                                message_error += "【活動1】"

                            }
                            message_error += "日数は"+max_day+"日分選択してください。\n";
                        }

                    }else{

                        // 最大日数と最小日数が別の場合
                        if(min_day <= check_array.length && check_array.length <= max_day){
                            // 選択した日数が最小～最大の間ならOK
                            
                        }else{
                            if(sub_list.value.length != 0){
                                message_error += "【活動1】"
                            }

                            // 選択した日数が最小～最大の間ではない場合はエラー
                            if(taiken_list.value.nissu_min == null || taiken_list.value.nissu_min == ""){
                                message_error += "日数は"+max_day+"日以内で";
                            }else if(taiken_list.value.nissu_max == null || taiken_list.value.nissu_max == ""){
                                message_error += "日数は"+min_day+"日以上";

                            }else{
                                message_error += "日数は"+min_day+"～"+max_day+"日の間で";
                            }
                            message_error += "選択してください。\n"
                        }

                    }
                    let error_count = 0

                    // 日数条件が連続の場合
                    if(taiken_list.value.nissu_joken == 1){

                        let jogai = taiken_list.value.nissu_jogai
                        //jogai = false
                        
                        // 除外日を飛ばす場合
                        if(jogai == true){

                            // 比較する番号（前の番号）
                            let before_bango = 99999999999  

                            
                            // 連番ではない場合はエラー
                            for(let d = 0;d < check_array.length;d++){
                                if(before_bango != 99999999999 ) {
                                    if(parseInt(check_array[d].date_bango) == parseInt(before_bango)+1){
                                    }else{
                                        error_count = error_count + 1

                                    }
                                }
                                before_bango = check_array[d].date_bango
                            }
                            
                            if(error_count != 0){
                                
                                if(sub_list.value.length != 0){
                                    message_error += "【活動1】"

                                }
                                message_error += "連続した日付を選択してください。\n";
                            }
                        }else{
                            // 除外日を飛ばさない場合
                            // 比較する日付（前の日付）
                            let before_date = ""    

                            // 日付が順番ではない場合はエラー
                            for(let d = 0;d < check_array.length;d++){
                                if(before_date != "" ) {
                                    // 確認する日付と比較する日付をDate型に変換
                                    let check_kaisai_date = new Date(check_array[d].kaisai_date)
                                    let check_before_date = new Date(before_date)
                                    check_before_date.setDate( check_before_date.getDate() +1 )//確認する日付を1日進める

                                    if(check_kaisai_date.getTime() == check_before_date.getTime()){
                                    }else{
                                        error_count = error_count + 1
                                    }
                                }
                                before_date = check_array[d].kaisai_date
                            }

                            if(error_count != 0){
                                if(sub_list.value.length != 0){
                                    message_error += "【活動1】"

                                }
                                message_error += "連続した日程を選択してください。<br>※除外日及び除外曜日も含め\n";
                            }

                        }
                    }
                }
                
                // 格納
                if(main_add_banchi != 100){
                    send_main_array = check_array
                }
            }

            console.log(select_date_sub.value)

            console.log("活動2以降の日数チェック")

            // ほかの活動（2～）以降をチェック
            for(let s = 0;s<sub_list.value.length;s++){

                let error_count = 0

                console.log(sub_add_banchi[s] )
                
                // 番地の値が100ではない（＝何かしら入力されている）場合は処理
                if(sub_add_banchi[s] != 100){
                    
                    let check_array = []
                    for(let s2 = 0;s2<select_date_sub.value[s].length;s2++){
                        let set_date = select_date_sub.value[s][s2]
                        for(let c = 0 ; c < set_date.length; c++){
                            check_array.push(set_date[c])
                        }
                    }
                    console.log(check_array)
                    // 要素が2つ以上ある場合は番号順→日程グループで並び替え
                    if(check_array.length != 1){
                        check_array.sort((a, b) => a.bango - b.bango);
                        check_array.sort((a, b) => a.nittei_group - b.nittei_group);
                    }
                    // 日程の選択が1日ごとである場合は、選んだ日付が日数の範囲内かチェックする
                    if(sub_list.value[s].nittei_sentaku == 0){
                            // 選択できる最小日数
                            let min_day = sub_list.value[s].nissu_min
                            // 選択できる最大日数
                            let max_day = sub_list.value[s].nissu_max

                            if(min_day == null || min_day == ""){
                                min_day = 1
                            }
                            if(max_day == null || max_day == ""){
                                max_day = 99
                            }

                            console.log(min_day +"<="+ check_array.length +"<="+ max_day)

                            // 最大日数と最小日数が同じ場合
                            if(max_day == min_day){
                                // 選択した日数が最大日数に満たない場合はエラー
                                if(check_array.length < max_day){
                                    message_error += "【活動"+(s+2)+"】日数は"+max_day+"日分選択してください。\n";
                                }

                            }else{

                                // 最大日数と最小日数が別の場合
                                if(min_day <= check_array.length && check_array.length <= max_day){
                                    // 選択した日数が最小～最大の間ならOK
                                    
                                }else{

                                    message_error += "【活動"+(s+2)+"】"
                                    // 選択した日数が最小～最大の間ではない場合はエラー
                                    if(sub_list.value[s].nissu_min == null || sub_list.value[s].nissu_min == ""){
                                        message_error += "日数は"+max_day+"日以内で";
                                    }else if(sub_list.value[s].nissu_max == null || sub_list.value[s].nissu_max == ""){
                                        message_error += "日数は"+min_day+"日以上";

                                    }else{
                                        message_error += "日数は"+min_day+"～"+max_day+"日の間で";
                                    }
                                    message_error += "選択してください。\n"
                                }

                            }

                        // 日数条件が連続の場合
                        if(sub_list.value[s].nissu_joken == 1){

                            let jogai = sub_list.value[s].nissu_jogai
                            
                            // 除外日を飛ばす場合
                            if(jogai == true){

                                // 比較する番号（前の番号）
                                let before_bango = 99999999999  

                                
                                // 連番ではない場合はエラー
                                for(let d = 0;d < check_array.length;d++){
                                    if(before_bango != 99999999999 ) {
                                        if(parseInt(check_array[d].date_bango) == parseInt(before_bango)+1){
                                        }else{
                                            error_count = error_count + 1

                                        }
                                    }
                                    before_bango = check_array[d].date_bango
                                }
                                
                                if(error_count != 0){
                                    message_error += "【活動"+(s+2)+"】連続した日付を選択してください。\n";
                                }
                            }else{
                                // 除外日を飛ばさない場合
                                // 比較する日付（前の日付）
                                let before_date = ""    

                                // 日付が順番ではない場合はエラー
                                for(let d = 0;d < check_array.length;d++){
                                    if(before_date != "" ) {
                                        // 確認する日付と比較する日付をDate型に変換
                                        let check_kaisai_date = new Date(check_array[d].kaisai_date)
                                        let check_before_date = new Date(before_date)
                                        check_before_date.setDate( check_before_date.getDate() +1 )//確認する日付を1日進める

                                        if(check_kaisai_date.getTime() == check_before_date.getTime()){
                                        }else{
                                            error_count = error_count + 1
                                        }
                                    }
                                    before_date = check_array[d].kaisai_date
                                }

                                if(error_count != 0){
                                    message_error += "【活動"+(s+2)+"】連続した日程を選択してください。<br>※除外日及び除外曜日も含め\n";
                                }
                            }
                        }else{

                        }

                    }
                    // 格納
                    send_sub_array[send_sub_array.length] = check_array
                    sub_list.value[s].sub_num = s
                    send_sub_katsudou[send_sub_katsudou.length] = sub_list.value[s]
                }
            }

            // エラーメッセージが存在する場合はここでストップ
            if(message_error != ""){
                message.value = message_error
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "nissu_error";
                contentMessage.value = MessageModal
                return
            }

                console.log(send_main_array)
                console.log(send_sub_array)
            // キャンセル待ちが存在するかどうか
            if(cancel_setting == 0){
                let cancel_wait_flg = 0
                // 活動1チェック
                for(let m = 0;m<send_main_array.length;m++){
                    if(send_main_array[m].ninzu >= send_main_array[m].teiin){
                        cancel_wait_flg = 1
                    }
                }

                // ほかの活動（2～）以降をチェック
                for(let s = 0;s<send_sub_array.length;s++){
                    let sub = send_sub_array[s]
                    for(let m = 0;m<sub.length;m++){
                        if(sub[m].ninzu >= sub[m].teiin){
                            cancel_wait_flg = 1
                        }
                    }
                }

                // キャンセル待ちが含まれる場合はここで選択
                if(cancel_wait_flg == 1){
                    message.value = "<b><u style='color:red'>キャンセル待ちでの申込（仮予約）となります。</u></b><br>よろしいですか？"
                    message_cat.value = 1;
                    message_flag.value = true;
                    message_method.value = "cancel_ok";
                    contentMessage.value = MessageModal
                    return
                }
            }

            
        }else{
            // 制作・寄付活動の場合
        }

        // 特にエラーがなければ親コンポーネントに日付を含む配列を送って確認画面へ
        moshikomi_send()
    }  

    // 確認画面へ
    let moshikomi_send = function(){

        emit('call',{cmd:'moushikomi',
                shosai:taiken_list.value,
                sub:send_sub_katsudou,
                select_date:send_main_array,
                select_date_sub:send_sub_array,
                user_jyokyo:user_taiken_jyokyo})
    }

// 満員や〆切日のチェック
let over_check_error = 0
let over_check = function(){

        // 日程オーバーフラグ（初期値はtrue：オーバーしている）
        // 1つでも終了日以前なら、全体としてはオーバーしていないとする（一度でもfalseになったら塗り替えない）
        let nittei_over_flg = true
    
        // 〆切オーバーフラグ（true(初期値のまま)の時はオーバー）
        let over_flg = true
        let check_shimekiri = end_datetime.value

        // 定員フラグ（１の時は満員）
        let teiin_flg = 0
        
        let today = new Date()

        // 日程が全て終わっているか確認
        for(let n = 0;n<nittei_list.value.length;n++){
            let check_nittei = nittei_list.value[n]
            // 日程の終了日を取得
            let end = new Date(check_nittei.kaisai_end)
            end = end.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            end = new Date(end);
            end.setHours(end.getHours()-9);

            console.log(end+"/"+today)
            // 終了日が今日以降ならfalse
            if (end >= today) {
                nittei_over_flg = false
            }
        }

        // 活動2以降がある場合
        if(sub_list.value){
            for(let s = 0;s<sub_list.value.length;s++){
                for(let n = 0;n<sub_nittei_list.value[s].length;n++){
                    let check_nittei = sub_nittei_list.value[s][n]
                    // 日程の終了日を取得
                    let end = new Date(check_nittei.kaisai_end)
                    end = end.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                    end = new Date(end);
                    end.setHours(end.getHours()-9);

                    console.log(end+"/"+today)
                    // 終了日が今日以降ならfalse
                    if (end >= today) {
                        nittei_over_flg = false
                    }
                }
            }
        }
        
        // 〆切日の確認
        // メイン活動の確認
        // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
        if(end_shubetsu.value == 2 && taiken_list.value.shimekiri_date){
            let shimekiri = new Date(taiken_list.value.shimekiri_date)

            shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            shimekiri = new Date(shimekiri);
            shimekiri.setHours(shimekiri.getHours()-9);
            check_shimekiri = shimekiri
            if (check_shimekiri >= today) {
                over_flg = false
            }
        }else if(end_shubetsu.value == 1){
            // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
            check_shimekiri = ShimekiriSetting(end_datetime.value)
            if (check_shimekiri >= today) {
                over_flg = false
            }
        }else{
            // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は、設定された「〇日前」と今日の日付によってチェック
            let shimakiri_nissu = taiken_list.value.shimekiri_nissu

            // 日程のうち、最初の番地の開催終了日を入力
            let end_date = new Date(nittei_list.value[0].kaisai_end)

            for(let n = 0;n<nittei_list.value.length;n++){
                // 最初の番地以外の開催終了日も確認し、日付が一番後ろのものを格納
                if(n != 0){
                    let nittei_end_date = new Date(nittei_list.value[n].kaisai_end)
                    if(end_date < nittei_end_date){
                        end_date = nittei_end_date
                    }
                }
            }

            // 今日の日付を取得
            let today = new Date()
            today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            today = new Date(today)
            today.setHours(0, 0, 0, 0);//0時0分0秒に設定

            // 最終的に取得した開催終了日のロケールと時刻をセット
            end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            end_date = new Date(end_date)
            end_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

            
            // 開催日と今日の日付を比較して日数を取得
            let checkDay = (end_date - today) / 86400000 ;
            
            console.log(end_date+"/"+today)

            // 設定された「開催日より〇日前」を下回るのであれば〆切
            if (checkDay < shimakiri_nissu) {
            }else{
                over_flg = false
            }
        }
        
        // 活動2以降がある場合
        if(sub_list.value){
            for(let s = 0;s<sub_list.value.length;s++){

                // 一旦事業単位の受付〆切日を格納
                let s_check_shimekiri = new Date()
                
                // 活動を一つずつ取り出す
                let spg = sub_list.value[s]

                // 活動1のチェック
                // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
                if(end_shubetsu.value == 2 && spg.shimekiri_date){
                    let shimekiri = new Date(spg.shimekiri_date)
                    shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                    shimekiri = new Date(shimekiri);
                    shimekiri.setHours(shimekiri.getHours()-9);
                    s_check_shimekiri = shimekiri
                    if (s_check_shimekiri >= today) {
                        over_flg = false
                    }
                }else if(end_shubetsu.value == 1){
                    // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
                    s_check_shimekiri = ShimekiriSetting(end_datetime.value)
                    if (s_check_shimekiri >= today) {
                        over_flg = false
                    }
                }else{
                    // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は、設定された「〇日前」と今日の日付によってチェック
                    let shimakiri_nissu = spg.shimekiri_nissu

                    // 日程のうち、最初の番地の開催終了日を入力
                    let end_date = new Date(sub_nittei_list.value[s][0].kaisai_end)

                    for(let n = 0;n<sub_nittei_list.value[s].length;n++){
                        // 最初の番地以外の開催終了日も確認し、日付が一番後ろのものを格納
                        if(n != 0){
                            let nittei_end_date = new Date(sub_nittei_list.value[s].kaisai_end)
                            if(end_date < nittei_end_date){
                            end_date = nittei_end_date
                            }
                        }
                    }

                    // 今日の日付を取得
                    let today = new Date()
                    today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                    today = new Date(today)
                    today.setHours(0, 0, 0, 0);//0時0分0秒に設定

                    // 最終的に取得した開催終了日のロケールと時刻をセット
                    end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                    end_date = new Date(end_date)
                    end_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

                    
                    // 開催日と今日の日付を比較して日数を取得
                    let checkDay = (end_date - today) / 86400000 ;

                    // 設定された「開催日より〇日前」を下回るのであれば〆切
                    if (checkDay < shimakiri_nissu) {
                    }else{
                        over_flg = false
                    }
                }
            }
        }

        // 全体の定員を利用する場合はオーバーしていたら申込不可（施設・地域のみ）
        if(taiken_list.value.shubetsu == 1){
            if(taiken_list.value.all_teiin_flg == 1){
                if(ok_user_count.value >= taiken_list.value.seisaku_teiin){
                    teiin_flg = 1;
                }
            }
        }

        if (teiin_flg == 1) {
        
            // ローディングアイコンストップ
            emit('call',{ cmd:'loading_end_noreload' })
            message.value = "このプログラムは満員です。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "teiin_end";
            contentMessage.value = MessageModal
        }else{
            if(nittei_over_flg){
                // ローディングアイコンストップ
                emit('call',{ cmd:'loading_end_noreload' })
                message.value = "このプログラムは申込める日程がありません。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "moushikomi_end";
                contentMessage.value = MessageModal
            }else
            if (over_flg) {
        
                // ローディングアイコンストップ
                emit('call',{ cmd:'loading_end_noreload' })
                message.value = "このプログラムは申込みを締め切っています。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "moushikomi_end";
                contentMessage.value = MessageModal
            }else{
                

                if(props.param.type != undefined){
                    // 初期表示タブが指定されていたらそちらを表示
                    TabSelect(props.param.type)
                }else{
                    // 特に指定がない場合は詳細
                    TabSelect('tab_detail')
                }
                
                if (GlobalData.$User_email) { // ログインしているかチェック
                    if (GlobalData.user_id) { // ユーザー情報があるかチェック
                        
                        // ログイン中かつユーザー情報登録済みであれば実績データを取得
                        axios.post(GlobalData.$API_URL + "Taikenuser_Jisseki",
                        {
                        taikenuser_id: GlobalData.user_id
                        },GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
                        .then(response => {

                            if(response.data["status"] == 1){
                                
                                    
                            }else{
                                user_taiken_jyokyo = response.data.jisseki
                                
                                /*
                                // キャンセルを除いたものを抽出
                                for(let u = 0;u<user_taiken_jyokyo.length;u++){
                                    if(user_taiken_jyokyo[u].jokyo != '9'){
                                        user_ok_jyokyo[user_ok_jyokyo.length] = user_taiken_jyokyo[u]
                                    }
                                    
                                }

                                
                                ok_user_count.value = user_ok_jyokyo.length*/

                                let sanka_flg = 0
                                let sanka_count = 0
                                let before_id = 0
                                // 締切前なら体験プログラムの申込み状況を確認
                                // ついでに申込済みの体験プログラムをカウント
                                for(let u = 0;u<user_taiken_jyokyo.length;u++){

                                    if(user_taiken_jyokyo[u].jokyo != 9){
                                        if(taiken_list.value.taiken_id == user_taiken_jyokyo[u].main_taiken_id){
                                            // 未参加のものがあれば申込不可
                                            if(user_taiken_jyokyo[u].jokyo == '1'){
                                                sanka_flg = 1
                                            }
                                        }
                                        
                                        if(before_id != user_taiken_jyokyo[u].main_taiken_id){
                                            if(user_taiken_jyokyo[u].program_kbn == 1){
                                            sanka_count++
                                            }
                                        }
                                        before_id = user_taiken_jyokyo[u].main_taiken_id
                                    }
                                }

                                if(sanka_flg == 1){
        
                                    // ローディングアイコンストップ
                                    emit('call',{ cmd:'loading_end_noreload' })
                                    message.value = "このプログラムは申込済です。";
                                    message_cat.value = 0;
                                    message_flag.value = true;
                                    message_method.value = "sanka_zumi";
                                    contentMessage.value = MessageModal
                                }else{
                                    
                                    // 申込み回数の上限が決まっている場合
                                    if(program_shubetsu.value == 1){

                                        // 申込み回数がすでに上限以上の場合は進入不可
                                        if(program_count.value <= sanka_count ){
                                            
                                            // ローディングアイコンストップ
                                            emit('call',{ cmd:'loading_end_noreload' })
                                            message.value = "申込み回数の上限に達しています。\n※このプログラムに参加したい場合は、他のプログラムを１つキャンセルする必要があります。"
                                            message_cat.value = 0;
                                            message_flag.value = true;
                                            message_method.value = "sanka_zumi";
                                            contentMessage.value = MessageModal
                                            return
                                        }

                                    }
        
                                    // 日程を元に申込み日をセッティング
                                    nittei_set()
                                    sub_nittei_set()
                                    disp_nittei_list_setting()

                                    // 総申込者数との比較
                                    moshikomi_count_read()

                                }

                            }
                        })
                        .catch(error => {
                            if(over_check_error == 6){
                                message.value = error + GlobalData.$axios_error;
                                message_cat.value = 0;
                                message_flag.value = true;
                                message_method.value = "over_check_error";
                                contentMessage.value = MessageModal
                            }else{
                                over_check_error++
                                setTimeout(function(){
                                    over_check()
                                },"1000")
                            }
                        })
                    }else{
        
                        mode.value = "noinfo"
                        // 日程を元に申込み日をセッティング
                        nittei_set()
                        sub_nittei_set()
                        disp_nittei_list_setting()
                    }
                }else{
        
                    mode.value = "nologin"
                    // 日程を元に申込み日をセッティング
                    nittei_set()
                    sub_nittei_set()
                    disp_nittei_list_setting()
                }
            }
        }
    }
    
let EndDateTimeSetting = function(changedate){
  
  let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()+9);

    //return date;
    return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+")"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
}
  //年月日＋時間の表示を整える(EU時間)
  let EuDateTimeSetting = function(changedate){
     /*
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours()-8);
 */
     let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
  }

  // 参加条件の大小をチェック（先に来る区分が小さくなければならない）
  function kubunCheck(start,end){
    if (!start) return 1;

    const [startKubun] = start;
    const startOrder = joken_kubun_name[startKubun];

    let endOrder = null;

    if (end) {
      const [endKubun] = end;
      endOrder = joken_kubun_name[endKubun];
    }

    // 区分大小チェック（start > end は不正なのでここで終了）
    if (endOrder !== null && startOrder > endOrder) {
      return 1 
    }
    return 0

  }

  // 参加条件をテキスト化
  function createJokenText(startText, endText) {
    if(!startText) return "小学生～一般"
    const STUDENT_LABEL = {
      '小': gakusei_meisho_list.value[0],
      '中': gakusei_meisho_list.value[1],
      '高': gakusei_meisho_list.value[2],
      '高専': gakusei_meisho_list.value[3],
      '専': gakusei_meisho_list.value[4],
      '大': gakusei_meisho_list.value[5],
      '院': gakusei_meisho_list.value[6],
      '一般': '一般'
    };

    const parse = (text) => {
      const [kubun, gradeStr] = text.split(':');
      return { kubun, grade: Number(gradeStr) };
    };
    const start = parse(startText);
    const end = parse(endText);

    // 一般のみ
    if (start.kubun === '一般' && end.kubun === '一般') {
      return '一般';
    }

    // 開始と終了が異なる → 常に「～」
    if (startText !== endText) {
      const startLabel =
        start.grade > 0
          ? `${STUDENT_LABEL[start.kubun]}${start.grade}年生`
          : STUDENT_LABEL[start.kubun];

      const endLabel =
        end.grade > 0
          ? `${STUDENT_LABEL[end.kubun]}${end.grade}年生`
          : STUDENT_LABEL[end.kubun];

      return `${startLabel}～${endLabel}`;
    }

    // 同一区分・同一学年
    if (start.grade > 0) {
      return `${STUDENT_LABEL[start.kubun]}${start.grade}年生`;
    }

    // 同一区分・学年なし
    return STUDENT_LABEL[start.kubun];
  }

  // joken_all_startとjoken_all_endのテキストを分解
  function parseKubunText(text) {
    const [kubun, gradeStr] = text.split(':');
    return {
      kubun,
      grade: Number(gradeStr)
    };
  }
//------------------- リンク
const home = () => { router.push('/'+cityname+'/Taiken') }
const ichiran = () => {
    router.push('/'+cityname+'/Taiken/Program')
}
const userinfo = () => {
    emit('call',{ cmd:'user_toroku' })
}

const login = () => {
    emit('call', { cmd:'login',id:''})
}

const jizen_list = () =>{
    router.push('/'+cityname+'/Taiken/Jizen')
}

//------------------- Googlemap（外部リンク）へ
const jusho = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

//------------------- 添付資料（外部リンク）へ
const shiryo_open = (url)  => { 
    window.open(url,"_blank")

}

// 所属社協へ移動する
const move_shozoku = () =>{
    location.href=location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
}

// ユーザー登録後アンケートへ移動
let move_enqete = function(){
  router.push('/'+cityname+'/Taiken/enqete/1') 
}

const shiryo_open_sp = (url)  => { 
//    window.open(url,"_blank")

    location.href = url
}

  // 指定の高さにスクロールさせる
  let Page_scroll = function(height){
    // ページの一番上にスクロールする：height＝位置（上から何pxか）
    //「behavior: 'smooth'」はスムーズなスクロール。「behavior: 'auto'」だと一瞬で移動する
    document.querySelector("#vy_main").scrollTo({
      top: height,
      behavior: 'smooth'
    })
  }

  // 指定のタグにフォーカスさせる
  let Page_id_focus = function(id){
    const elements = document.getElementById(id)
    elements.focus({preventScroll:false})
    elements.scrollIntoView({ behavior: 'instant', block: 'start' });

  }
  
    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる

        // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
        if(message_method.value == "login_error"){
            // 未ログインの場合はログイン画面へ
            emit('call', { cmd:'login',id:''})
        }else if(message_method.value == "user_error"){
            // ユーザー未登録の場合はユーザー登録画面へ
            userinfo()
        }else if(message_method.value=="sanka_zumi"){
            router.push('/'+cityname+'/Taiken/mypage')
        }else if(message_method.value=="moushikomi_end" || message_method.value == "teiin_end" || message_method.value == "sanka_error" || message_method.value == "all_moshikomi_error"){
            // 何らかの理由で申込不可の場合は一覧へ戻す
            router.push('/'+cityname+'/Taiken')
        }else if(message_method.value == "enqete_error"){
            // アンケート未回答の場合はアンケート画面へ
            move_enqete()
        }else if(message_method.value == "cancel_ok"){
            // キャンセル待ち日程が含まれていても申し込む場合
             moshikomi_send()
        }

        
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }

    // 申込OKなら左サイドバーの申込ボタンを表示する
    let LeftBar_moshkomi_ok = function(){
        if(shakyo_moushikomi_flg.value == true && seisaku_moushikomi_flg.value == true && joken_moushikomi_flg.value == true){
             emit('call',{ cmd:'pg_moshikomi_ok' })

        }
    }

    //親コンポーネントで利用する関数の指定
    defineExpose({
        moushikomi_set,
    });

    /* 初期処理 */
    // ページトップまでスクロール
    emit('call',{ cmd:'page_scroll' })

//-------------- 子コンポーネントの呼び出しに応じて処理を呼び出す -------------------
const call = function(proc) {
        switch(proc.cmd) {
            case "close":
              
              // カレンダー日時ウィンドウを閉じる
              smart_calendar_area.value = false

              break
            
            case "set":

                let set_moushikomi = proc.moushikomi
                Set_id(proc.date,set_moushikomi.jikantai_start,set_moushikomi.jikantai_end,set_moushikomi.all_count,3,set_moushikomi.date_bango,proc.nittei_no,set_moushikomi.teiin,set_moushikomi.ninzu)
                // カレンダー日時ウィンドウを閉じる
                smart_calendar_area.value = false

              break
            case "sub_set":

                let sub_set_moushikomi = proc.moushikomi
                Sub_Set_id(proc.date,sub_set_moushikomi.jikantai_start,sub_set_moushikomi.jikantai_end,sub_set_moushikomi.all_count,3,sub_set_moushikomi.date_bango,proc.katsudou_no,proc.nittei_no,sub_set_moushikomi.teiin,sub_set_moushikomi.ninzu)
                // カレンダー日時ウィンドウを閉じる
                smart_calendar_area.value = false
                break
            case "set_list":
                Set_list_click(proc.nittei_no,3)
                // カレンダー日時ウィンドウを閉じる
                smart_calendar_area.value = false
                break
            case "sub_set_list":
                console.log("proc.katsudou_no:"+proc.katsudou_no+"/proc.nittei_no:"+proc.nittei_no)
                Sub_Set_list_click(proc.nittei_no,proc.katsudou_no,3)
                // カレンダー日時ウィンドウを閉じる
                smart_calendar_area.value = false
                break
            default:
                break
        }
    }


    let manual_open = function(){
      let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
      window.open(url,"_blank")
  }

  // Q&Aを開く
  const qanda_open = () =>{

    let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
    window.open(url,"_blank")
  }        
      

    // 初期処理：祝日取得→社協情報呼び出し

    // 祝日を取得
    const calendarId = 'japanese__ja@holiday.calendar.google.com'
    const calendarApiUrl = 'https://www.googleapis.com/calendar/v3/calendars/'
    const apiKey = GlobalData.$holiday_key
    function loadGoogleCalendarApi() {
        gapi.client.init({
            apiKey: apiKey,
        }).then(() => {
            return gapi.client.request({
            path: calendarApiUrl + encodeURIComponent(calendarId) + '/events'
            })
        }).then((res) => {
            
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            
            // Googleカレンダーで祝日にされてしまっているもの
            let not_holiday = ["雛祭り","クリスマス","母の日","七五三","節分","七夕"]
            const items = res.result.items
            for(let i = 0; i < items.length; i++){
                // 今年と来年の祝日だけ取得
                if(items[i].start.date.substring(0,4) == set_date.getFullYear() ||
                    items[i].start.date.substring(0,4) == (set_date.getFullYear()+1) ){

                        // 祝日ではない場合は挿入しない
                        if(!not_holiday.includes(items[i].summary)){
                            let set_date = new Date(items[i].start.date)
                            let set_year = set_date.getFullYear()
                            let set_month = set_date.getMonth() + 1
                            let set_day = set_date.getDate()
                            holidays_list[holidays_list.length] = set_year+"/"+set_month+"/"+set_day
                        }

                }
            }
        
            // 社協呼び出し
            shakyo_read()
            
        })
    }
    gapi.load('client', loadGoogleCalendarApi)



    
    // ユーザーの参加条件で申込めるかどうかの判断
    let joken_moushikomi_flg = ref(true)
    let joken_fuka_message =  ref(createJokenText(taiken_list.value.joken_all_start,taiken_list.value.joken_all_end))

    if(taiken_list.value.joken_mongon != ""){
        joken_fuka_message.value = taiken_list.value.joken_mongon
    }

    setTimeout(function(){
        if(GlobalData.shokugyo_kbn != null){
            joken_moushikomi_flg.value = isUserEligible(taiken_list.value.joken_all_start,taiken_list.value.joken_all_end)

            // 参加条件で申し込めなかった場合のエラーメッセージ

            // 活動2以降がある場合
            if(sub_list.value.length != 0){
                joken_fuka_message.value = "【活動1】<br>"+joken_fuka_message.value
                
                let sub_joken_message = ""

                for(let s = 0;s<sub_list.value.length;s++){
                    sub_joken_message += "<br>【活動"+(s+2)+"】<br>"
                    let sub = sub_list.value[s]
                    let set_sub_message = createJokenText(sub.joken_all_start,sub.joken_all_end)
                    
                    if(sub.joken_mongon != ""){
                        set_sub_message = sub.joken_mongon
                    }
                    sub_joken_message += set_sub_message
                    // これより以前の活動で参加不可だった場合、他の活動も参加不可なのかチェックする
                    if(!joken_moushikomi_flg.value){
                        joken_moushikomi_flg.value = isUserEligible(sub.joken_all_start,sub.joken_all_end)
                    }
                    
                }
                joken_fuka_message.value += sub_joken_message
            }

            joken_fuka_message.value = "本プログラムの対象者は以下の通りです。<br>" + joken_fuka_message.value 


            if(joken_moushikomi_flg.value == false){
                
                message.value = joken_fuka_message.value;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "sanka_error";
                contentMessage.value = MessageModal
            }
        }
    },"1000")
</script>

<style scoped>
.hov {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color: wheat;
  cursor: pointer;
}
.joken_table{
    text-align: center;
    width: 70%;
    table-layout: fixed;
}
.joken_table tr td{
    text-align: center;
    border: 1px solid #000;
}

    #tab {
        width: 100%;
        margin: auto;
        border: 0;
    }
    #tab_detail{
        border-radius: 5px 0 0 0;
    }
    #tab_calendar{
        border-radius: 0 5px 0 0;
    }
    #tab_list {
        border-left: 2px solid #FFF;
        border-right: 2px solid #FFF;
    }
  .tabMenu {
    display: flex;
    padding: 0;
    margin-bottom:0;
   }

   .tabMenu li {
      list-style:none;
      width: 33%;
      padding: 10px 20px;
      cursor: pointer;
  }
  
  .tabblue{
      color: #fff;
      background-color: #06F;
  }
  .tabgray{
      color: #fff;
      background-color:#b3b3b3 ;
      cursor: pointer;
  }
  .tabgreen{
    color: #fff;
    background-color: darkgreen;
  }

  .edit_komoku_area{
    border: 1px solid rgb(170,170,170);
    padding: 0 10px 10px 10px;
    margin-bottom:10px;
  }

  .edit_tabMenu{
    display: flex;
    flex-wrap: wrap;
      padding: 0;
      margin-bottom: 0;
  }

  .edit_tabMenu li{
    padding:10px 20px;
    border-radius:5px 5px 0 0;
    list-style: none;
  }
  .contentswhite{
      background-color: #fff;
  }
  .contentsred{
      background-color: mistyrose;
  }

  .tabContents {
    border:1px solid rgb(170,170,170);
  }
 
  /* 活動・日程のタブエリア */
  #katsudou_tabMenu{
    width: 90%;
  }
  #katsudou_tabMenu,
  #nittei_tabMenu{
    width: 100%;
    display: flex;
    padding: 0;
    margin: 0;
    
  }
  
  /* 活動・日程のタブ共通 */
  #katsudou_tabMenu li,
  #nittei_tabMenu li{
    flex: 1;
    text-align: center;
    margin-right:2px;
  }

  /* 活動・日程の最初 */
  #katsudou_tabMenu li:first-child,
  #nittei_tabMenu li:first-child{
    border-radius: 5px 0 0 0;
  }

  /* 活動・日程の最初・末尾以外 */
  #katsudou_tabMenu li:not(:first-child):not(:last-child),
  #nittei_tabMenu li:not(:first-child):not(:last-child){
    border-radius: 0;
  }
  /* 活動・日程の末尾 */
  #katsudou_tabMenu li:last-child,
  #nittei_tabMenu li:last-child{
    border-radius: 0 5px 0 0;
    margin-right:0;
  }

  /* 活動・日程が1件のみ（最初であり末尾でもある） */
  #katsudou_tabMenu li:first-child:last-child,
  #nittei_tabMenu li:first-child:last-child{
    border-radius: 5px 5px 0 0;
  }
  
  /* 活動タブのみ */
  #katsudou_tabMenu li{
    min-width: 86px;
  }

  /* 日程タブのみ */
  #nittei_tabMenu li{
    min-width: 70px;
  }

  .nittei_title{
    font-size: 1.15em;
  }

  .joken_div{
    display: flex;
    align-items: center;
    margin-top:10px;
    height: 35px;
  }
  .joken_div select,
  .joken_div input{
    font-size:1em
  }
  
  .edit_tabMenu{
    display: flex;
      padding: 0;
      margin-bottom: 0;
  }

  .edit_tabMenu li{
    padding:10px 20px;
    border-radius:5px 5px 0 0;
    list-style: none;
  }

  :deep(.list_column_left){
    border-left:1px solid #000;
    border-right:1px solid #000;
    width:30%;
    flex:1 1 0%;
  } 
  :deep(.list_column_standard){
    border-right:1px solid #000;
    width:30%;
    flex:1 1 0%;
  }
  :deep(.list_column_center){
    border-right:1px solid #000;
    border-top:1px solid #000;
    width:40%;
    flex:1 1 0%;
  }
  :deep(.list_column_header){
    border-top:1px solid #000;
    border-bottom:1px solid #000;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :deep(#title_area),:deep(#list_column_area),:deep(#calendar_column_area){
    display: flex;
    align-items: center;
  }
  :deep(#list_column_area div){
    height:40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  :deep(#katsudou_area){
    text-align: left;
    padding:10px;
  }
  
  :deep(#katsudou_button_area){
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
  }
  :deep(#calendar_button_area){
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  :deep(.month_change){
    cursor: pointer;
    border-bottom: 1px solid #000;
  }
  
  :deep(.calendar_column){
    width:14%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_right){
    width:15%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_left){
    width:15%;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom:1px solid #000;
  }
  
  
  :deep(.column_date_blank){
    min-height: 100px;
  }
  :deep(.column_date){
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  :deep(.column_date_day){
    height:30px;
    display: flex;
    align-items: center;
  }
  :deep(.column_date_time){
    height:20px;
    width:100%;
    font-size: 11px;
    line-height: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  :deep(.column_date_time_left){
    width: 55%;
    text-align: left;
    padding: 0;
    display: flex;
    justify-content: center;
  }

:deep(.katsudou_blue){
  border-radius:10px;background-color:blue;color:white;width:70px;height:30px;
  margin-right: 10px;
}
:deep(.katsudou_green){
  border-radius:10px;background-color:green;color:white;width:70px;height:30px;
  margin-right: 10px;
}
:deep(.katsudou_white){
  border:1px solid #000;border-radius:10px;background-color:white;color:black;width:70px;height:30px;
  margin-right: 10px;
}
  
  
  :deep(.calendar_column){
    width:14%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_right){
    width:15%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_left){
    width:15%;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom:1px solid #000;
  }
  
  
  :deep(.column_date){
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  :deep(.column_date_day){
    height:30px;
    display: flex;
    align-items: center;
  }
  :deep(.column_date_time){
    height:25px;
    width:100%;
    font-size: 11px;
    line-height: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  :deep(.column_date_time_left){
    width: 55%;
    text-align: left;
    padding: 0;
    display: flex;
    justify-content: center;
  }


    @media screen and (min-width: 961px) {

        /* PC版 */
        .tabMenu li {
            padding: 10px 20px;
        }
        .tabContents{
            padding: 15px;
        }

        :deep(.column_date_blank){
            height: 100px;
        }
        :deep(.column_date){
            height: 100px;
        }
        .floating_over{
            display: none
        }
        
        .pc_only{
            display:revert
        }
        .sp_only{
            display:none
        }
    }
    @media screen and (max-width: 960px) {

        /* スマホ版 */
        .tabMenu li {
            padding: 5px;
            height:50px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tabContents{
            padding: 5px;
        }


        /* スマホの場合は項目名を大きめにする */
        label{
            font-size: 19px;
        }
        
        :deep(.column_date_blank){
            min-height: 60px;
        }
        :deep(.column_date){
            min-height: 60px;
        }
        
        .floating_over{
            display: flex
        }
  
        .pc_only{
            display:none
        }
        .sp_only{
            display:revert
        }
    }
    

.balloon_parent:hover .balloon-top-right {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top-right {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  right : -20px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 350px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top-right:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 89%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}
</style>
